//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @return Success
     */
    sendPasswordResetCode(emailAddress: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendPasswordResetCode?";
        if (emailAddress === null)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPasswordResetCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPasswordResetCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendPasswordResetCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: SelfResetPasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalUserSetPassword(body: SelfResetPasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/ExternalUserSetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalUserSetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalUserSetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processExternalUserSetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activateUserAccount(body: ActivateUserAccountDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/ActivateUserAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateUserAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateUserAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processActivateUserAccount(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getTenantPublicSettings(tenantId: number | undefined): Observable<TenantPublicSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/Account/GetTenantPublicSettings?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantPublicSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantPublicSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantPublicSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantPublicSettingsDto>;
        }));
    }

    protected processGetTenantPublicSettings(response: HttpResponseBase): Observable<TenantPublicSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantPublicSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AssetServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AssetDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AssetDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<AssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: AssetDto | undefined): Observable<AssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param emailsToExclude (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAssignableNaturalPersonsForAsset(emailsToExclude: string[] | undefined, order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AssignableNaturalPersonAssetDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/GetAllAssignableNaturalPersonsForAsset?";
        if (emailsToExclude === null)
            throw new Error("The parameter 'emailsToExclude' cannot be null.");
        else if (emailsToExclude !== undefined)
            emailsToExclude && emailsToExclude.forEach(item => { url_ += "EmailsToExclude=" + encodeURIComponent("" + item) + "&"; });
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAssignableNaturalPersonsForAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAssignableNaturalPersonsForAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignableNaturalPersonAssetDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignableNaturalPersonAssetDtoPagedResultDto>;
        }));
    }

    protected processGetAllAssignableNaturalPersonsForAsset(response: HttpResponseBase): Observable<AssignableNaturalPersonAssetDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignableNaturalPersonAssetDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param juridicalPersonId (optional) 
     * @param emailsToExclude (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAssignableJuridicalPersonsForAsset(juridicalPersonId: number | undefined, emailsToExclude: string[] | undefined, order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AssignableJuridicalPersonAssetDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/GetAllAssignableJuridicalPersonsForAsset?";
        if (juridicalPersonId === null)
            throw new Error("The parameter 'juridicalPersonId' cannot be null.");
        else if (juridicalPersonId !== undefined)
            url_ += "JuridicalPersonId=" + encodeURIComponent("" + juridicalPersonId) + "&";
        if (emailsToExclude === null)
            throw new Error("The parameter 'emailsToExclude' cannot be null.");
        else if (emailsToExclude !== undefined)
            emailsToExclude && emailsToExclude.forEach(item => { url_ += "EmailsToExclude=" + encodeURIComponent("" + item) + "&"; });
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAssignableJuridicalPersonsForAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAssignableJuridicalPersonsForAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignableJuridicalPersonAssetDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignableJuridicalPersonAssetDtoPagedResultDto>;
        }));
    }

    protected processGetAllAssignableJuridicalPersonsForAsset(response: HttpResponseBase): Observable<AssignableJuridicalPersonAssetDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignableJuridicalPersonAssetDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveOwners(body: PersonCompanyAssetDataDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Asset/SaveOwners";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveOwners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveOwners(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveOwners(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    getValueFieldsForAsset(assetId: number | undefined): Observable<ValueFieldDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Asset/GetValueFieldsForAsset?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValueFieldsForAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValueFieldsForAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValueFieldDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValueFieldDto[]>;
        }));
    }

    protected processGetValueFieldsForAsset(response: HttpResponseBase): Observable<ValueFieldDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ValueFieldDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    getAssetReport(assetId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Asset/GetAssetReport?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAssetReport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: AssetDto | undefined): Observable<AssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Asset/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AssetStateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AssetStateDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetState/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetStateDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetStateDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AssetStateDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetStateDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<AssetStateDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetState/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetStateDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AssetStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetStateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: AssetStateDto | undefined): Observable<AssetStateDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetState/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetStateDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AssetStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetStateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: AssetStateDto | undefined): Observable<AssetStateDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetState/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetStateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetStateDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AssetStateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetStateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AssetState/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AttorneyInFactTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<AttorneyInFactTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/AttorneyInFactType/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttorneyInFactTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttorneyInFactTypeDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AttorneyInFactTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttorneyInFactTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AttorneyInFactTypeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AttorneyInFactType/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttorneyInFactTypeDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttorneyInFactTypeDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AttorneyInFactTypeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttorneyInFactTypeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: AttorneyInFactTypeDto | undefined): Observable<AttorneyInFactTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/AttorneyInFactType/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttorneyInFactTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttorneyInFactTypeDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AttorneyInFactTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttorneyInFactTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: AttorneyInFactTypeDto | undefined): Observable<AttorneyInFactTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/AttorneyInFactType/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttorneyInFactTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttorneyInFactTypeDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AttorneyInFactTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttorneyInFactTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AttorneyInFactType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuditLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AuditLogDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditLogDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditLogDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AuditLogDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditLogDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<AuditLogDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuditLogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuditLogDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AuditLogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditLogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CategoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CategoryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Category/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CategoryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/Category/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CategoryDto | undefined): Observable<CategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/Category/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CategoryDto | undefined): Observable<CategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/Category/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Category/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CompanyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | undefined): Observable<CreateOrUpdateCompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateCompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateCompanyDto>;
        }));
    }

    protected processGetForEdit(response: HttpResponseBase): Observable<CreateOrUpdateCompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateCompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getForAllTenants(id: number | undefined): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetForAllTenants?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForAllTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForAllTenants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDto>;
        }));
    }

    protected processGetForAllTenants(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCompaniesByTenantId(tenantId: number | undefined, order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SelectableCompanyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetAllCompaniesByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCompaniesByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCompaniesByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectableCompanyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectableCompanyDtoPagedResultDto>;
        }));
    }

    protected processGetAllCompaniesByTenantId(response: HttpResponseBase): Observable<SelectableCompanyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectableCompanyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCompanyFinalBeneficiaries(id: number | undefined): Observable<PersonCompanyRoleDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCompanyFinalBeneficiaries?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyFinalBeneficiaries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyFinalBeneficiaries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonCompanyRoleDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonCompanyRoleDataDto[]>;
        }));
    }

    protected processGetCompanyFinalBeneficiaries(response: HttpResponseBase): Observable<PersonCompanyRoleDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCompanyShareholders(id: number | undefined): Observable<PersonCompanyRoleDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCompanyShareholders?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyShareholders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyShareholders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonCompanyRoleDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonCompanyRoleDataDto[]>;
        }));
    }

    protected processGetCompanyShareholders(response: HttpResponseBase): Observable<PersonCompanyRoleDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param companyId (optional) 
     * @return Success
     */
    companyHasAttorneysInFact(companyId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Company/CompanyHasAttorneysInFact?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompanyHasAttorneysInFact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompanyHasAttorneysInFact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCompanyHasAttorneysInFact(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCompanyContacts(id: number | undefined): Observable<PersonCompanyRoleDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCompanyContacts?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonCompanyRoleDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonCompanyRoleDataDto[]>;
        }));
    }

    protected processGetCompanyContacts(response: HttpResponseBase): Observable<PersonCompanyRoleDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCompanyLinked(id: number | undefined): Observable<PersonCompanyRoleDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCompanyLinked?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyLinked(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyLinked(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonCompanyRoleDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonCompanyRoleDataDto[]>;
        }));
    }

    protected processGetCompanyLinked(response: HttpResponseBase): Observable<PersonCompanyRoleDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCompanyDirectory(id: number | undefined): Observable<PersonCompanyRoleDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCompanyDirectory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyDirectory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyDirectory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonCompanyRoleDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonCompanyRoleDataDto[]>;
        }));
    }

    protected processGetCompanyDirectory(response: HttpResponseBase): Observable<PersonCompanyRoleDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCompanyAttorneysInFact(id: number | undefined): Observable<PersonCompanyRoleDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCompanyAttorneysInFact?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyAttorneysInFact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyAttorneysInFact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonCompanyRoleDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonCompanyRoleDataDto[]>;
        }));
    }

    protected processGetCompanyAttorneysInFact(response: HttpResponseBase): Observable<PersonCompanyRoleDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param companyRoleId (optional) 
     * @param showAllTenants (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getPersonsRolesByCompany(companyId: number | undefined, companyRoleId: number | undefined, showAllTenants: boolean | undefined, order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PersonRoleByCompanyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetPersonsRolesByCompany?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (companyRoleId === null)
            throw new Error("The parameter 'companyRoleId' cannot be null.");
        else if (companyRoleId !== undefined)
            url_ += "CompanyRoleId=" + encodeURIComponent("" + companyRoleId) + "&";
        if (showAllTenants === null)
            throw new Error("The parameter 'showAllTenants' cannot be null.");
        else if (showAllTenants !== undefined)
            url_ += "ShowAllTenants=" + encodeURIComponent("" + showAllTenants) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonsRolesByCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonsRolesByCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonRoleByCompanyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonRoleByCompanyDtoPagedResultDto>;
        }));
    }

    protected processGetPersonsRolesByCompany(response: HttpResponseBase): Observable<PersonRoleByCompanyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonRoleByCompanyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param showAllTenants (optional) 
     * @param managedCompanies (optional) 
     * @param juridicalPersonId (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSelectableCompaniesForUser(userId: number | undefined, showAllTenants: boolean | undefined, managedCompanies: boolean | undefined, juridicalPersonId: number | undefined, order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SelectableCompanyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetAllSelectableCompaniesForUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (showAllTenants === null)
            throw new Error("The parameter 'showAllTenants' cannot be null.");
        else if (showAllTenants !== undefined)
            url_ += "ShowAllTenants=" + encodeURIComponent("" + showAllTenants) + "&";
        if (managedCompanies === null)
            throw new Error("The parameter 'managedCompanies' cannot be null.");
        else if (managedCompanies !== undefined)
            url_ += "ManagedCompanies=" + encodeURIComponent("" + managedCompanies) + "&";
        if (juridicalPersonId === null)
            throw new Error("The parameter 'juridicalPersonId' cannot be null.");
        else if (juridicalPersonId !== undefined)
            url_ += "JuridicalPersonId=" + encodeURIComponent("" + juridicalPersonId) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSelectableCompaniesForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSelectableCompaniesForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectableCompanyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectableCompanyDtoPagedResultDto>;
        }));
    }

    protected processGetAllSelectableCompaniesForUser(response: HttpResponseBase): Observable<SelectableCompanyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelectableCompanyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param showAllTenants (optional) 
     * @param managedCompanies (optional) 
     * @param juridicalPersonId (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(showAllTenants: boolean | undefined, managedCompanies: boolean | undefined, juridicalPersonId: number | undefined, order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CompanyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetAll?";
        if (showAllTenants === null)
            throw new Error("The parameter 'showAllTenants' cannot be null.");
        else if (showAllTenants !== undefined)
            url_ += "ShowAllTenants=" + encodeURIComponent("" + showAllTenants) + "&";
        if (managedCompanies === null)
            throw new Error("The parameter 'managedCompanies' cannot be null.");
        else if (managedCompanies !== undefined)
            url_ += "ManagedCompanies=" + encodeURIComponent("" + managedCompanies) + "&";
        if (juridicalPersonId === null)
            throw new Error("The parameter 'juridicalPersonId' cannot be null.");
        else if (juridicalPersonId !== undefined)
            url_ += "JuridicalPersonId=" + encodeURIComponent("" + juridicalPersonId) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CompanyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllVerifiedCompanies(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetAllVerifiedCompanies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllVerifiedCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllVerifiedCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetAllVerifiedCompanies(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param showAllTenants (optional) 
     * @param managedCompanies (optional) 
     * @param juridicalPersonId (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllUsersCompanies(showAllTenants: boolean | undefined, managedCompanies: boolean | undefined, juridicalPersonId: number | undefined, order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CompanyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetAllUsersCompanies?";
        if (showAllTenants === null)
            throw new Error("The parameter 'showAllTenants' cannot be null.");
        else if (showAllTenants !== undefined)
            url_ += "ShowAllTenants=" + encodeURIComponent("" + showAllTenants) + "&";
        if (managedCompanies === null)
            throw new Error("The parameter 'managedCompanies' cannot be null.");
        else if (managedCompanies !== undefined)
            url_ += "ManagedCompanies=" + encodeURIComponent("" + managedCompanies) + "&";
        if (juridicalPersonId === null)
            throw new Error("The parameter 'juridicalPersonId' cannot be null.");
        else if (juridicalPersonId !== undefined)
            url_ += "JuridicalPersonId=" + encodeURIComponent("" + juridicalPersonId) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsersCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsersCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDtoPagedResultDto>;
        }));
    }

    protected processGetAllUsersCompanies(response: HttpResponseBase): Observable<CompanyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllVerifiedCompaniesForUser(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetAllVerifiedCompaniesForUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllVerifiedCompaniesForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllVerifiedCompaniesForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetAllVerifiedCompaniesForUser(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOrUpdateCompanyDto | undefined): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CreateOrUpdateCompanyDto | undefined): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSuggestedChanges(body: UpdateSuggestedCompanyChangesInputDto | undefined): Observable<RequestStatusEnum> {
        let url_ = this.baseUrl + "/api/services/app/Company/UpdateSuggestedChanges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSuggestedChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSuggestedChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestStatusEnum>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestStatusEnum>;
        }));
    }

    protected processUpdateSuggestedChanges(response: HttpResponseBase): Observable<RequestStatusEnum> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    userSuggestedCompanyChanges(body: CreateOrUpdateCompanyDto | undefined): Observable<UserSuggestedCompanyChangesControl> {
        let url_ = this.baseUrl + "/api/services/app/Company/UserSuggestedCompanyChanges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserSuggestedCompanyChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserSuggestedCompanyChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSuggestedCompanyChangesControl>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSuggestedCompanyChangesControl>;
        }));
    }

    protected processUserSuggestedCompanyChanges(response: HttpResponseBase): Observable<UserSuggestedCompanyChangesControl> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSuggestedCompanyChangesControl.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    hasSuggestedCompanyChanges(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/Company/HasSuggestedCompanyChanges";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasSuggestedCompanyChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasSuggestedCompanyChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processHasSuggestedCompanyChanges(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    hasSuggestedCompanyChangesByUser(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/Company/HasSuggestedCompanyChangesByUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasSuggestedCompanyChangesByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasSuggestedCompanyChangesByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processHasSuggestedCompanyChangesByUser(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserSuggestedCompanyChanges(id: number | undefined): Observable<UserSuggestedCompanyChangesOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetUserSuggestedCompanyChanges?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSuggestedCompanyChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSuggestedCompanyChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSuggestedCompanyChangesOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSuggestedCompanyChangesOutputDto>;
        }));
    }

    protected processGetUserSuggestedCompanyChanges(response: HttpResponseBase): Observable<UserSuggestedCompanyChangesOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSuggestedCompanyChangesOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editCompanySummary(body: EditCompanySummaryDto | undefined): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/EditCompanySummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditCompanySummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditCompanySummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDto>;
        }));
    }

    protected processEditCompanySummary(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editCompanyAddresses(body: EditCompanyAddressesDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Company/EditCompanyAddresses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditCompanyAddresses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditCompanyAddresses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditCompanyAddresses(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Company/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAttorneyInFactCompanyRoleId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetAttorneyInFactCompanyRoleId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttorneyInFactCompanyRoleId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttorneyInFactCompanyRoleId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetAttorneyInFactCompanyRoleId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getFinalBeneficiaryCompanyRoleId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetFinalBeneficiaryCompanyRoleId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinalBeneficiaryCompanyRoleId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinalBeneficiaryCompanyRoleId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetFinalBeneficiaryCompanyRoleId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getShareholderCompanyRoleId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetShareholderCompanyRoleId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShareholderCompanyRoleId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShareholderCompanyRoleId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetShareholderCompanyRoleId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDirectorCompanyRoleId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetDirectorCompanyRoleId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDirectorCompanyRoleId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDirectorCompanyRoleId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetDirectorCompanyRoleId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getContactCompanyRoleId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetContactCompanyRoleId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactCompanyRoleId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactCompanyRoleId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetContactCompanyRoleId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getLinkedCompanyRoleId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetLinkedCompanyRoleId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLinkedCompanyRoleId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLinkedCompanyRoleId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetLinkedCompanyRoleId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param companyId (optional) 
     * @return Success
     */
    getCompanyReport(companyId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCompanyReport?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetCompanyReport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param companyId (optional) 
     * @return Success
     */
    getCorporateMap(companyId: number | undefined): Observable<NodeMapDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCorporateMap?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCorporateMap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCorporateMap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NodeMapDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NodeMapDto>;
        }));
    }

    protected processGetCorporateMap(response: HttpResponseBase): Observable<NodeMapDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NodeMapDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param companyId (optional) 
     * @return Success
     */
    getCompanyLibraryConfiguration(companyId: number | undefined): Observable<LibraryFileOwnerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCompanyLibraryConfiguration?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyLibraryConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyLibraryConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LibraryFileOwnerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LibraryFileOwnerDto[]>;
        }));
    }

    protected processGetCompanyLibraryConfiguration(response: HttpResponseBase): Observable<LibraryFileOwnerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LibraryFileOwnerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userPassword (optional) 
     * @param id (optional) 
     * @return Success
     */
    deleteCompanyLibraryItem(userPassword: string | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Company/DeleteCompanyLibraryItem?";
        if (userPassword === null)
            throw new Error("The parameter 'userPassword' cannot be null.");
        else if (userPassword !== undefined)
            url_ += "UserPassword=" + encodeURIComponent("" + userPassword) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCompanyLibraryItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCompanyLibraryItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCompanyLibraryItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param filterEndDate (optional) 
     * @return Success
     */
    getAllAssignablePrincipalsForAttorneyInFact(companyId: number | undefined, filterEndDate: boolean | undefined): Observable<PersonCompanyRoleDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetAllAssignablePrincipalsForAttorneyInFact?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (filterEndDate === null)
            throw new Error("The parameter 'filterEndDate' cannot be null.");
        else if (filterEndDate !== undefined)
            url_ += "filterEndDate=" + encodeURIComponent("" + filterEndDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAssignablePrincipalsForAttorneyInFact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAssignablePrincipalsForAttorneyInFact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonCompanyRoleDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonCompanyRoleDataDto[]>;
        }));
    }

    protected processGetAllAssignablePrincipalsForAttorneyInFact(response: HttpResponseBase): Observable<PersonCompanyRoleDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param filterEndDate (optional) 
     * @return Success
     */
    getAllAssignableShareholderForFinalBeneficiary(companyId: number | undefined, filterEndDate: boolean | undefined): Observable<PersonCompanyRoleDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetAllAssignableShareholderForFinalBeneficiary?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (filterEndDate === null)
            throw new Error("The parameter 'filterEndDate' cannot be null.");
        else if (filterEndDate !== undefined)
            url_ += "filterEndDate=" + encodeURIComponent("" + filterEndDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAssignableShareholderForFinalBeneficiary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAssignableShareholderForFinalBeneficiary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonCompanyRoleDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonCompanyRoleDataDto[]>;
        }));
    }

    protected processGetAllAssignableShareholderForFinalBeneficiary(response: HttpResponseBase): Observable<PersonCompanyRoleDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personCompanyRoleDataId (optional) 
     * @return Success
     */
    deleteCompanyRelationByPersonCompanyRoleDataId(personCompanyRoleDataId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Company/DeleteCompanyRelationByPersonCompanyRoleDataId?";
        if (personCompanyRoleDataId === null)
            throw new Error("The parameter 'personCompanyRoleDataId' cannot be null.");
        else if (personCompanyRoleDataId !== undefined)
            url_ += "personCompanyRoleDataId=" + encodeURIComponent("" + personCompanyRoleDataId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCompanyRelationByPersonCompanyRoleDataId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCompanyRelationByPersonCompanyRoleDataId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCompanyRelationByPersonCompanyRoleDataId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CompanyRoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CompanyRoleDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyRole/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyRoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyRoleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CompanyRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CompanyRoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyRole/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyRoleDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyRoleDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CompanyRoleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyRoleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CompanyRoleDto | undefined): Observable<CompanyRoleDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyRole/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyRoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyRoleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CompanyRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CompanyRoleDto | undefined): Observable<CompanyRoleDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyRole/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyRoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyRoleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CompanyRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyRole/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CompanyTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CompanyTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyType/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyTypeDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CompanyTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CompanyTypeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyType/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyTypeDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyTypeDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CompanyTypeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyTypeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CompanyTypeDto | undefined): Observable<CompanyTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyType/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyTypeDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CompanyTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CompanyTypeDto | undefined): Observable<CompanyTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyType/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyTypeDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CompanyTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    uploadNewLogo(file: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/UploadNewLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadNewLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadNewLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadNewLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUiTheme(body: ChangeUiThemeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUiTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUiTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeCreateUserWithoutCompany(body: CreateUserWithoutCompanyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeCreateUserWithoutCompany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeCreateUserWithoutCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeCreateUserWithoutCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeCreateUserWithoutCompany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getLogoSettings(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetLogoSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLogoSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogoSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetLogoSettings(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getUiThemeSettings(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetUiThemeSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUiThemeSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUiThemeSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUiThemeSettings(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCreateUserWithoutCompanySettings(): Observable<CreateUserWithoutCompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetCreateUserWithoutCompanySettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCreateUserWithoutCompanySettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreateUserWithoutCompanySettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateUserWithoutCompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateUserWithoutCompanyDto>;
        }));
    }

    protected processGetCreateUserWithoutCompanySettings(response: HttpResponseBase): Observable<CreateUserWithoutCompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateUserWithoutCompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTenantLibraryConfigurationItem(body: UpdateTenantLibraryConfigurationItemDto | undefined): Observable<UpdateTenantLibraryConfigurationItemDto> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/UpdateTenantLibraryConfigurationItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenantLibraryConfigurationItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenantLibraryConfigurationItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateTenantLibraryConfigurationItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateTenantLibraryConfigurationItemDto>;
        }));
    }

    protected processUpdateTenantLibraryConfigurationItem(response: HttpResponseBase): Observable<UpdateTenantLibraryConfigurationItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateTenantLibraryConfigurationItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getTenantLibraryConfiguration(): Observable<LibraryFileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetTenantLibraryConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantLibraryConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantLibraryConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LibraryFileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LibraryFileDto[]>;
        }));
    }

    protected processGetTenantLibraryConfiguration(response: HttpResponseBase): Observable<LibraryFileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LibraryFileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param libraryConfigurationId (optional) 
     * @param libraryConfigurationKindId (optional) 
     * @param libraryConfigurationRoleId (optional) 
     * @param parentId (optional) 
     * @param libraryFileTypeId (optional) 
     * @param isVisble (optional) 
     * @param isChecked (optional) 
     * @param isRetroactive (optional) 
     * @param isShared (optional) 
     * @param name (optional) 
     * @param mIME (optional) 
     * @param fullNameExtension (optional) 
     * @param files (optional) 
     * @param isUploaderSpace (optional) 
     * @param isJP (optional) 
     * @param id (optional) 
     * @return Success
     */
    createTenantLibraryConfigurationItem(libraryConfigurationId: number | null | undefined, libraryConfigurationKindId: number | null | undefined, libraryConfigurationRoleId: number | null | undefined, parentId: number | null | undefined, libraryFileTypeId: number | undefined, isVisble: boolean | undefined, isChecked: boolean | undefined, isRetroactive: boolean | undefined, isShared: boolean | undefined, name: string | null | undefined, mIME: string | null | undefined, fullNameExtension: string | null | undefined, files: FileParameter[] | null | undefined, isUploaderSpace: boolean | undefined, isJP: boolean | undefined, id: number | undefined): Observable<CreateTenantLibraryConfigurationItemOutDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/CreateTenantLibraryConfigurationItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (libraryConfigurationId !== null && libraryConfigurationId !== undefined)
            content_.append("LibraryConfigurationId", libraryConfigurationId.toString());
        if (libraryConfigurationKindId !== null && libraryConfigurationKindId !== undefined)
            content_.append("LibraryConfigurationKindId", libraryConfigurationKindId.toString());
        if (libraryConfigurationRoleId !== null && libraryConfigurationRoleId !== undefined)
            content_.append("LibraryConfigurationRoleId", libraryConfigurationRoleId.toString());
        if (parentId !== null && parentId !== undefined)
            content_.append("ParentId", parentId.toString());
        if (libraryFileTypeId === null || libraryFileTypeId === undefined)
            throw new Error("The parameter 'libraryFileTypeId' cannot be null.");
        else
            content_.append("LibraryFileTypeId", libraryFileTypeId.toString());
        if (isVisble === null || isVisble === undefined)
            throw new Error("The parameter 'isVisble' cannot be null.");
        else
            content_.append("IsVisble", isVisble.toString());
        if (isChecked === null || isChecked === undefined)
            throw new Error("The parameter 'isChecked' cannot be null.");
        else
            content_.append("IsChecked", isChecked.toString());
        if (isRetroactive === null || isRetroactive === undefined)
            throw new Error("The parameter 'isRetroactive' cannot be null.");
        else
            content_.append("IsRetroactive", isRetroactive.toString());
        if (isShared === null || isShared === undefined)
            throw new Error("The parameter 'isShared' cannot be null.");
        else
            content_.append("IsShared", isShared.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (mIME !== null && mIME !== undefined)
            content_.append("MIME", mIME.toString());
        if (fullNameExtension !== null && fullNameExtension !== undefined)
            content_.append("FullNameExtension", fullNameExtension.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (isUploaderSpace === null || isUploaderSpace === undefined)
            throw new Error("The parameter 'isUploaderSpace' cannot be null.");
        else
            content_.append("IsUploaderSpace", isUploaderSpace.toString());
        if (isJP === null || isJP === undefined)
            throw new Error("The parameter 'isJP' cannot be null.");
        else
            content_.append("IsJP", isJP.toString());
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTenantLibraryConfigurationItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTenantLibraryConfigurationItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateTenantLibraryConfigurationItemOutDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateTenantLibraryConfigurationItemOutDto[]>;
        }));
    }

    protected processCreateTenantLibraryConfigurationItem(response: HttpResponseBase): Observable<CreateTenantLibraryConfigurationItemOutDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CreateTenantLibraryConfigurationItemOutDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userPassword (optional) 
     * @param id (optional) 
     * @return Success
     */
    deleteTenantLibraryConfigurationItem(userPassword: string | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/DeleteTenantLibraryConfigurationItem?";
        if (userPassword === null)
            throw new Error("The parameter 'userPassword' cannot be null.");
        else if (userPassword !== undefined)
            url_ += "UserPassword=" + encodeURIComponent("" + userPassword) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTenantLibraryConfigurationItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTenantLibraryConfigurationItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTenantLibraryConfigurationItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CountryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CountryDto> {
        let url_ = this.baseUrl + "/api/services/app/Country/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CountryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CountryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Country/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CountryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CountryDto | undefined): Observable<CountryDto> {
        let url_ = this.baseUrl + "/api/services/app/Country/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CountryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CountryDto | undefined): Observable<CountryDto> {
        let url_ = this.baseUrl + "/api/services/app/Country/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CountryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Country/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CurrencyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CurrencyDto> {
        let url_ = this.baseUrl + "/api/services/app/Currency/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrencyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrencyDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CurrencyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrencyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CurrencyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Currency/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrencyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrencyDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CurrencyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrencyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CurrencyDto | undefined): Observable<CurrencyDto> {
        let url_ = this.baseUrl + "/api/services/app/Currency/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrencyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrencyDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CurrencyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrencyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CurrencyDto | undefined): Observable<CurrencyDto> {
        let url_ = this.baseUrl + "/api/services/app/Currency/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrencyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrencyDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CurrencyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrencyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Currency/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CustomFieldServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomFieldDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomField/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomFieldDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomFieldDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustomFieldDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomFieldDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCustomFieldsTemplateAssets(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TemplateCustomFieldDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomField/GetAllCustomFieldsTemplateAssets?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCustomFieldsTemplateAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCustomFieldsTemplateAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateCustomFieldDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateCustomFieldDtoPagedResultDto>;
        }));
    }

    protected processGetAllCustomFieldsTemplateAssets(response: HttpResponseBase): Observable<TemplateCustomFieldDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateCustomFieldDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CustomFieldDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomField/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomFieldDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomFieldDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CustomFieldDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomFieldDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CustomFieldDto | undefined): Observable<CustomFieldDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomField/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomFieldDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomFieldDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CustomFieldDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomFieldDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CustomFieldDto | undefined): Observable<CustomFieldDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomField/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomFieldDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomFieldDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CustomFieldDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomFieldDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CustomField/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CustomFieldOptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CustomFieldOptionDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomFieldOption/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomFieldOptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomFieldOptionDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CustomFieldOptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomFieldOptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomFieldOptionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomFieldOption/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomFieldOptionDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomFieldOptionDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustomFieldOptionDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomFieldOptionDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CustomFieldOptionDto | undefined): Observable<CustomFieldOptionDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomFieldOption/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomFieldOptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomFieldOptionDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CustomFieldOptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomFieldOptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CustomFieldOptionDto | undefined): Observable<CustomFieldOptionDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomFieldOption/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomFieldOptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomFieldOptionDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CustomFieldOptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomFieldOptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CustomFieldOption/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DocumentTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<DocumentTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentType/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTypeDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DocumentTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<DocumentTypeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentType/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTypeDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTypeDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DocumentTypeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTypeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: DocumentTypeDto | undefined): Observable<DocumentTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentType/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTypeDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DocumentTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: DocumentTypeDto | undefined): Observable<DocumentTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentType/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTypeDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DocumentTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FunctionalLinkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<FunctionalLinkDto> {
        let url_ = this.baseUrl + "/api/services/app/FunctionalLink/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FunctionalLinkDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FunctionalLinkDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FunctionalLinkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FunctionalLinkDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FunctionalLinkDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/FunctionalLink/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FunctionalLinkDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FunctionalLinkDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FunctionalLinkDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FunctionalLinkDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: FunctionalLinkDto | undefined): Observable<FunctionalLinkDto> {
        let url_ = this.baseUrl + "/api/services/app/FunctionalLink/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FunctionalLinkDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FunctionalLinkDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FunctionalLinkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FunctionalLinkDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: FunctionalLinkDto | undefined): Observable<FunctionalLinkDto> {
        let url_ = this.baseUrl + "/api/services/app/FunctionalLink/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FunctionalLinkDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FunctionalLinkDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FunctionalLinkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FunctionalLinkDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FunctionalLink/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HealthInsuranceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<HealthInsuranceDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthInsurance/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthInsuranceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthInsuranceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<HealthInsuranceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthInsuranceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<HealthInsuranceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthInsurance/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthInsuranceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthInsuranceDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<HealthInsuranceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthInsuranceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: HealthInsuranceDto | undefined): Observable<HealthInsuranceDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthInsurance/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthInsuranceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthInsuranceDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<HealthInsuranceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthInsuranceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: HealthInsuranceDto | undefined): Observable<HealthInsuranceDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthInsurance/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthInsuranceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthInsuranceDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<HealthInsuranceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthInsuranceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthInsurance/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class JuridicalPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/JuridicalPerson/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getForUser(id: number | undefined): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/JuridicalPerson/GetForUser?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDto>;
        }));
    }

    protected processGetForUser(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | undefined): Observable<CreateOrUpdateJuridicalPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/JuridicalPerson/GetForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateJuridicalPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateJuridicalPersonDto>;
        }));
    }

    protected processGetForEdit(response: HttpResponseBase): Observable<CreateOrUpdateJuridicalPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateJuridicalPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @param taxID (optional) 
     * @param emailAddress (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(name: string | undefined, taxID: string | undefined, emailAddress: string | undefined, order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CompanyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/JuridicalPerson/GetAll?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (taxID === null)
            throw new Error("The parameter 'taxID' cannot be null.");
        else if (taxID !== undefined)
            url_ += "TaxID=" + encodeURIComponent("" + taxID) + "&";
        if (emailAddress === null)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "EmailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CompanyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @param taxID (optional) 
     * @param emailAddress (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForUser(name: string | undefined, taxID: string | undefined, emailAddress: string | undefined, order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CompanyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/JuridicalPerson/GetAllForUser?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (taxID === null)
            throw new Error("The parameter 'taxID' cannot be null.");
        else if (taxID !== undefined)
            url_ += "TaxID=" + encodeURIComponent("" + taxID) + "&";
        if (emailAddress === null)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "EmailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDtoPagedResultDto>;
        }));
    }

    protected processGetAllForUser(response: HttpResponseBase): Observable<CompanyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param juridicalPersonId (optional) 
     * @param emailsToExclude (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAssignableJuridicalPersonsForSociety(juridicalPersonId: number | undefined, emailsToExclude: string[] | undefined, order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AssignableJuridicalPersonDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/JuridicalPerson/GetAllAssignableJuridicalPersonsForSociety?";
        if (juridicalPersonId === null)
            throw new Error("The parameter 'juridicalPersonId' cannot be null.");
        else if (juridicalPersonId !== undefined)
            url_ += "JuridicalPersonId=" + encodeURIComponent("" + juridicalPersonId) + "&";
        if (emailsToExclude === null)
            throw new Error("The parameter 'emailsToExclude' cannot be null.");
        else if (emailsToExclude !== undefined)
            emailsToExclude && emailsToExclude.forEach(item => { url_ += "EmailsToExclude=" + encodeURIComponent("" + item) + "&"; });
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAssignableJuridicalPersonsForSociety(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAssignableJuridicalPersonsForSociety(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignableJuridicalPersonDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignableJuridicalPersonDtoPagedResultDto>;
        }));
    }

    protected processGetAllAssignableJuridicalPersonsForSociety(response: HttpResponseBase): Observable<AssignableJuridicalPersonDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignableJuridicalPersonDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param juridicalPersonId (optional) 
     * @param emailsToExclude (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAssignableJuridicalPersonsForSocietyForUser(juridicalPersonId: number | undefined, emailsToExclude: string[] | undefined, order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AssignableJuridicalPersonDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/JuridicalPerson/GetAllAssignableJuridicalPersonsForSocietyForUser?";
        if (juridicalPersonId === null)
            throw new Error("The parameter 'juridicalPersonId' cannot be null.");
        else if (juridicalPersonId !== undefined)
            url_ += "JuridicalPersonId=" + encodeURIComponent("" + juridicalPersonId) + "&";
        if (emailsToExclude === null)
            throw new Error("The parameter 'emailsToExclude' cannot be null.");
        else if (emailsToExclude !== undefined)
            emailsToExclude && emailsToExclude.forEach(item => { url_ += "EmailsToExclude=" + encodeURIComponent("" + item) + "&"; });
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAssignableJuridicalPersonsForSocietyForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAssignableJuridicalPersonsForSocietyForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignableJuridicalPersonDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignableJuridicalPersonDtoPagedResultDto>;
        }));
    }

    protected processGetAllAssignableJuridicalPersonsForSocietyForUser(response: HttpResponseBase): Observable<AssignableJuridicalPersonDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignableJuridicalPersonDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @param from (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getJuridicalPersonAttorneysInFact(personId: number | undefined, from: boolean | undefined, order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PersonRoleByCompanyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/JuridicalPerson/GetJuridicalPersonAttorneysInFact?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "PersonId=" + encodeURIComponent("" + personId) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJuridicalPersonAttorneysInFact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJuridicalPersonAttorneysInFact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonRoleByCompanyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonRoleByCompanyDtoPagedResultDto>;
        }));
    }

    protected processGetJuridicalPersonAttorneysInFact(response: HttpResponseBase): Observable<PersonRoleByCompanyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonRoleByCompanyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOrUpdateJuridicalPersonDto | undefined): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/JuridicalPerson/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CreateOrUpdateJuridicalPersonDto | undefined): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/JuridicalPerson/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSuggestedChanges(body: UpdateSuggestedJuridicalPersonChangesInputDto | undefined): Observable<RequestStatusEnum> {
        let url_ = this.baseUrl + "/api/services/app/JuridicalPerson/UpdateSuggestedChanges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSuggestedChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSuggestedChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestStatusEnum>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestStatusEnum>;
        }));
    }

    protected processUpdateSuggestedChanges(response: HttpResponseBase): Observable<RequestStatusEnum> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    userSuggestedJuridicalPersonChanges(body: CreateOrUpdateJuridicalPersonDto | undefined): Observable<UserSuggestedJuridicalPersonChangesControl> {
        let url_ = this.baseUrl + "/api/services/app/JuridicalPerson/UserSuggestedJuridicalPersonChanges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserSuggestedJuridicalPersonChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserSuggestedJuridicalPersonChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSuggestedJuridicalPersonChangesControl>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSuggestedJuridicalPersonChangesControl>;
        }));
    }

    protected processUserSuggestedJuridicalPersonChanges(response: HttpResponseBase): Observable<UserSuggestedJuridicalPersonChangesControl> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSuggestedJuridicalPersonChangesControl.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    hasSuggestedJuridicalPersonChanges(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/JuridicalPerson/HasSuggestedJuridicalPersonChanges";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasSuggestedJuridicalPersonChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasSuggestedJuridicalPersonChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processHasSuggestedJuridicalPersonChanges(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    hasSuggestedJuridicalPersonChangesByUser(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/JuridicalPerson/HasSuggestedJuridicalPersonChangesByUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasSuggestedJuridicalPersonChangesByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasSuggestedJuridicalPersonChangesByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processHasSuggestedJuridicalPersonChangesByUser(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserSuggestedJuridicalPersonChanges(id: number | undefined): Observable<UserSuggestedJuridicalPersonChangesOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/JuridicalPerson/GetUserSuggestedJuridicalPersonChanges?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSuggestedJuridicalPersonChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSuggestedJuridicalPersonChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSuggestedJuridicalPersonChangesOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSuggestedJuridicalPersonChangesOutputDto>;
        }));
    }

    protected processGetUserSuggestedJuridicalPersonChanges(response: HttpResponseBase): Observable<UserSuggestedJuridicalPersonChangesOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSuggestedJuridicalPersonChangesOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/JuridicalPerson/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param juridicalPersonId (optional) 
     * @return Success
     */
    getJuridicalPersonReport(juridicalPersonId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/JuridicalPerson/GetJuridicalPersonReport?";
        if (juridicalPersonId === null)
            throw new Error("The parameter 'juridicalPersonId' cannot be null.");
        else if (juridicalPersonId !== undefined)
            url_ += "juridicalPersonId=" + encodeURIComponent("" + juridicalPersonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJuridicalPersonReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJuridicalPersonReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetJuridicalPersonReport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param juridicalPersonId (optional) 
     * @return Success
     */
    getJuridicalPersonReportForUser(juridicalPersonId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/JuridicalPerson/GetJuridicalPersonReportForUser?";
        if (juridicalPersonId === null)
            throw new Error("The parameter 'juridicalPersonId' cannot be null.");
        else if (juridicalPersonId !== undefined)
            url_ += "juridicalPersonId=" + encodeURIComponent("" + juridicalPersonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJuridicalPersonReportForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJuridicalPersonReportForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetJuridicalPersonReportForUser(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getJuridicalPersonIdInSocietyList(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/JuridicalPerson/GetJuridicalPersonIdInSocietyList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJuridicalPersonIdInSocietyList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJuridicalPersonIdInSocietyList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetJuridicalPersonIdInSocietyList(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getJuridicalPersonIdInSocietyListForUser(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/JuridicalPerson/GetJuridicalPersonIdInSocietyListForUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJuridicalPersonIdInSocietyListForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJuridicalPersonIdInSocietyListForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetJuridicalPersonIdInSocietyListForUser(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LibraryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param libraryFileOwnerId (optional) 
     * @param libraryConfigurationId (optional) 
     * @param libraryConfigurationKindId (optional) 
     * @param libraryConfigurationRoleId (optional) 
     * @param parentId (optional) 
     * @param libraryFileTypeId (optional) 
     * @param isVisble (optional) 
     * @param isChecked (optional) 
     * @param isShared (optional) 
     * @param name (optional) 
     * @param mIME (optional) 
     * @param fullNameExtension (optional) 
     * @param files (optional) 
     * @param companyId (optional) 
     * @param id (optional) 
     * @return Success
     */
    createLibraryItem(libraryFileOwnerId: number | null | undefined, libraryConfigurationId: number | null | undefined, libraryConfigurationKindId: number | null | undefined, libraryConfigurationRoleId: number | null | undefined, parentId: number | null | undefined, libraryFileTypeId: number | undefined, isVisble: boolean | undefined, isChecked: boolean | undefined, isShared: boolean | undefined, name: string | null | undefined, mIME: string | null | undefined, fullNameExtension: string | null | undefined, files: FileParameter[] | null | undefined, companyId: number | null | undefined, id: number | undefined): Observable<CreateLibraryItemOutDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Library/CreateLibraryItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (libraryFileOwnerId !== null && libraryFileOwnerId !== undefined)
            content_.append("LibraryFileOwnerId", libraryFileOwnerId.toString());
        if (libraryConfigurationId !== null && libraryConfigurationId !== undefined)
            content_.append("LibraryConfigurationId", libraryConfigurationId.toString());
        if (libraryConfigurationKindId !== null && libraryConfigurationKindId !== undefined)
            content_.append("LibraryConfigurationKindId", libraryConfigurationKindId.toString());
        if (libraryConfigurationRoleId !== null && libraryConfigurationRoleId !== undefined)
            content_.append("LibraryConfigurationRoleId", libraryConfigurationRoleId.toString());
        if (parentId !== null && parentId !== undefined)
            content_.append("ParentId", parentId.toString());
        if (libraryFileTypeId === null || libraryFileTypeId === undefined)
            throw new Error("The parameter 'libraryFileTypeId' cannot be null.");
        else
            content_.append("LibraryFileTypeId", libraryFileTypeId.toString());
        if (isVisble === null || isVisble === undefined)
            throw new Error("The parameter 'isVisble' cannot be null.");
        else
            content_.append("IsVisble", isVisble.toString());
        if (isChecked === null || isChecked === undefined)
            throw new Error("The parameter 'isChecked' cannot be null.");
        else
            content_.append("IsChecked", isChecked.toString());
        if (isShared === null || isShared === undefined)
            throw new Error("The parameter 'isShared' cannot be null.");
        else
            content_.append("IsShared", isShared.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (mIME !== null && mIME !== undefined)
            content_.append("MIME", mIME.toString());
        if (fullNameExtension !== null && fullNameExtension !== undefined)
            content_.append("FullNameExtension", fullNameExtension.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (companyId !== null && companyId !== undefined)
            content_.append("CompanyId", companyId.toString());
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLibraryItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLibraryItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateLibraryItemOutDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateLibraryItemOutDto[]>;
        }));
    }

    protected processCreateLibraryItem(response: HttpResponseBase): Observable<CreateLibraryItemOutDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CreateLibraryItemOutDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param naturalPersonId (optional) 
     * @param juridicalPersonId (optional) 
     * @param companyId (optional) 
     * @return Success
     */
    getPersonLibrary(naturalPersonId: number | undefined, juridicalPersonId: number | undefined, companyId: number | undefined): Observable<PersonLibraryResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Library/GetPersonLibrary?";
        if (naturalPersonId === null)
            throw new Error("The parameter 'naturalPersonId' cannot be null.");
        else if (naturalPersonId !== undefined)
            url_ += "NaturalPersonId=" + encodeURIComponent("" + naturalPersonId) + "&";
        if (juridicalPersonId === null)
            throw new Error("The parameter 'juridicalPersonId' cannot be null.");
        else if (juridicalPersonId !== undefined)
            url_ += "JuridicalPersonId=" + encodeURIComponent("" + juridicalPersonId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonLibrary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonLibrary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonLibraryResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonLibraryResponseDto[]>;
        }));
    }

    protected processGetPersonLibrary(response: HttpResponseBase): Observable<PersonLibraryResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PersonLibraryResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadLibraryFile(body: DownloadLibraryFileRequestDto | undefined): Observable<DownloadLibraryFileResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Library/DownloadLibraryFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadLibraryFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadLibraryFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadLibraryFileResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadLibraryFileResponseDto>;
        }));
    }

    protected processDownloadLibraryFile(response: HttpResponseBase): Observable<DownloadLibraryFileResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadLibraryFileResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePersonLibraryConfigurationItem(body: UpdatePersonLibraryConfigurationItemRequestDto | undefined): Observable<UpdatePersonLibraryConfigurationItemResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Library/UpdatePersonLibraryConfigurationItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePersonLibraryConfigurationItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePersonLibraryConfigurationItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdatePersonLibraryConfigurationItemResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdatePersonLibraryConfigurationItemResponseDto>;
        }));
    }

    protected processUpdatePersonLibraryConfigurationItem(response: HttpResponseBase): Observable<UpdatePersonLibraryConfigurationItemResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePersonLibraryConfigurationItemResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renameLibraryItem(body: RenameLibraryItemRequestDto | undefined): Observable<RenameLibraryItemResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Library/RenameLibraryItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenameLibraryItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenameLibraryItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RenameLibraryItemResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RenameLibraryItemResponseDto>;
        }));
    }

    protected processRenameLibraryItem(response: HttpResponseBase): Observable<RenameLibraryItemResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RenameLibraryItemResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveLibraryItems(body: MoveLibraryItemRequestDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Library/MoveLibraryItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveLibraryItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveLibraryItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMoveLibraryItems(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveLibraryItem(body: MoveLibraryItemRequestDto | undefined): Observable<MoveLibraryItemResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Library/MoveLibraryItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveLibraryItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveLibraryItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MoveLibraryItemResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MoveLibraryItemResponseDto>;
        }));
    }

    protected processMoveLibraryItem(response: HttpResponseBase): Observable<MoveLibraryItemResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MoveLibraryItemResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LocationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<LocationDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<LocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param countryId (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(countryId: number | undefined, order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<LocationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/GetAll?";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "CountryId=" + encodeURIComponent("" + countryId) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LocationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: LocationDto | undefined): Observable<LocationDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: LocationDto | undefined): Observable<LocationDto> {
        let url_ = this.baseUrl + "/api/services/app/Location/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<LocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Location/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MaritalStatusServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<MaritalStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/MaritalStatus/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaritalStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaritalStatusDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MaritalStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaritalStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<MaritalStatusDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MaritalStatus/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaritalStatusDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaritalStatusDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MaritalStatusDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaritalStatusDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: MaritalStatusDto | undefined): Observable<MaritalStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/MaritalStatus/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaritalStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaritalStatusDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MaritalStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaritalStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: MaritalStatusDto | undefined): Observable<MaritalStatusDto> {
        let url_ = this.baseUrl + "/api/services/app/MaritalStatus/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaritalStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaritalStatusDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MaritalStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaritalStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MaritalStatus/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MarriageRegimeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<MarriageRegimeDto> {
        let url_ = this.baseUrl + "/api/services/app/MarriageRegime/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarriageRegimeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarriageRegimeDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MarriageRegimeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarriageRegimeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<MarriageRegimeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MarriageRegime/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarriageRegimeDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarriageRegimeDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MarriageRegimeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarriageRegimeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: MarriageRegimeDto | undefined): Observable<MarriageRegimeDto> {
        let url_ = this.baseUrl + "/api/services/app/MarriageRegime/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarriageRegimeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarriageRegimeDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MarriageRegimeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarriageRegimeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: MarriageRegimeDto | undefined): Observable<MarriageRegimeDto> {
        let url_ = this.baseUrl + "/api/services/app/MarriageRegime/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MarriageRegimeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MarriageRegimeDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MarriageRegimeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarriageRegimeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MarriageRegime/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NationalityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<NationalityDto> {
        let url_ = this.baseUrl + "/api/services/app/Nationality/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NationalityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NationalityDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NationalityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NationalityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<NationalityDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Nationality/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NationalityDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NationalityDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<NationalityDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NationalityDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: NationalityDto | undefined): Observable<NationalityDto> {
        let url_ = this.baseUrl + "/api/services/app/Nationality/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NationalityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NationalityDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<NationalityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NationalityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: NationalityDto | undefined): Observable<NationalityDto> {
        let url_ = this.baseUrl + "/api/services/app/Nationality/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NationalityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NationalityDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<NationalityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NationalityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Nationality/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NaturalPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<NaturalPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/NaturalPerson/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NaturalPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NaturalPersonDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NaturalPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NaturalPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getForUser(id: number | undefined): Observable<NaturalPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/NaturalPerson/GetForUser?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NaturalPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NaturalPersonDto>;
        }));
    }

    protected processGetForUser(response: HttpResponseBase): Observable<NaturalPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NaturalPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getForEdit(id: number | undefined): Observable<CreateOrUpdateNaturalPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/NaturalPerson/GetForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateNaturalPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateNaturalPersonDto>;
        }));
    }

    protected processGetForEdit(response: HttpResponseBase): Observable<CreateOrUpdateNaturalPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateNaturalPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fullName (optional) 
     * @param phoneNumber (optional) 
     * @param emailAddress (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(fullName: string | undefined, phoneNumber: string | undefined, emailAddress: string | undefined, order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<NaturalPersonDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/NaturalPerson/GetAll?";
        if (fullName === null)
            throw new Error("The parameter 'fullName' cannot be null.");
        else if (fullName !== undefined)
            url_ += "FullName=" + encodeURIComponent("" + fullName) + "&";
        if (phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else if (phoneNumber !== undefined)
            url_ += "PhoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (emailAddress === null)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "EmailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NaturalPersonDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NaturalPersonDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<NaturalPersonDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NaturalPersonDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fullName (optional) 
     * @param phoneNumber (optional) 
     * @param emailAddress (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForUser(fullName: string | undefined, phoneNumber: string | undefined, emailAddress: string | undefined, order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<NaturalPersonDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/NaturalPerson/GetAllForUser?";
        if (fullName === null)
            throw new Error("The parameter 'fullName' cannot be null.");
        else if (fullName !== undefined)
            url_ += "FullName=" + encodeURIComponent("" + fullName) + "&";
        if (phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else if (phoneNumber !== undefined)
            url_ += "PhoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (emailAddress === null)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "EmailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NaturalPersonDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NaturalPersonDtoPagedResultDto>;
        }));
    }

    protected processGetAllForUser(response: HttpResponseBase): Observable<NaturalPersonDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NaturalPersonDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param emailsToExclude (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAssignableNaturalPersonsForSociety(emailsToExclude: string[] | undefined, order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AssignableNaturalPersonDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/NaturalPerson/GetAllAssignableNaturalPersonsForSociety?";
        if (emailsToExclude === null)
            throw new Error("The parameter 'emailsToExclude' cannot be null.");
        else if (emailsToExclude !== undefined)
            emailsToExclude && emailsToExclude.forEach(item => { url_ += "EmailsToExclude=" + encodeURIComponent("" + item) + "&"; });
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAssignableNaturalPersonsForSociety(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAssignableNaturalPersonsForSociety(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignableNaturalPersonDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignableNaturalPersonDtoPagedResultDto>;
        }));
    }

    protected processGetAllAssignableNaturalPersonsForSociety(response: HttpResponseBase): Observable<AssignableNaturalPersonDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignableNaturalPersonDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param emailsToExclude (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAssignableNaturalPersonsForSocietyForUser(emailsToExclude: string[] | undefined, order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AssignableNaturalPersonDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/NaturalPerson/GetAllAssignableNaturalPersonsForSocietyForUser?";
        if (emailsToExclude === null)
            throw new Error("The parameter 'emailsToExclude' cannot be null.");
        else if (emailsToExclude !== undefined)
            emailsToExclude && emailsToExclude.forEach(item => { url_ += "EmailsToExclude=" + encodeURIComponent("" + item) + "&"; });
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAssignableNaturalPersonsForSocietyForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAssignableNaturalPersonsForSocietyForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignableNaturalPersonDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignableNaturalPersonDtoPagedResultDto>;
        }));
    }

    protected processGetAllAssignableNaturalPersonsForSocietyForUser(response: HttpResponseBase): Observable<AssignableNaturalPersonDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignableNaturalPersonDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @param from (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getNaturalPersonAttorneysInFact(personId: number | undefined, from: boolean | undefined, order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PersonRoleByCompanyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/NaturalPerson/GetNaturalPersonAttorneysInFact?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "PersonId=" + encodeURIComponent("" + personId) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNaturalPersonAttorneysInFact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNaturalPersonAttorneysInFact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonRoleByCompanyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonRoleByCompanyDtoPagedResultDto>;
        }));
    }

    protected processGetNaturalPersonAttorneysInFact(response: HttpResponseBase): Observable<PersonRoleByCompanyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonRoleByCompanyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPersonIdForUser(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/NaturalPerson/GetPersonIdForUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonIdForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonIdForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetPersonIdForUser(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOrUpdateNaturalPersonDto | undefined): Observable<NaturalPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/NaturalPerson/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NaturalPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NaturalPersonDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<NaturalPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NaturalPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CreateOrUpdateNaturalPersonDto | undefined): Observable<NaturalPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/NaturalPerson/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NaturalPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NaturalPersonDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<NaturalPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NaturalPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSuggestedChanges(body: UpdateSuggestedNaturalPersonChangesInputDto | undefined): Observable<RequestStatusEnum> {
        let url_ = this.baseUrl + "/api/services/app/NaturalPerson/UpdateSuggestedChanges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSuggestedChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSuggestedChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestStatusEnum>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestStatusEnum>;
        }));
    }

    protected processUpdateSuggestedChanges(response: HttpResponseBase): Observable<RequestStatusEnum> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    userSuggestedNaturalPersonChanges(body: CreateOrUpdateNaturalPersonDto | undefined): Observable<UserSuggestedNaturalPersonChangesControl> {
        let url_ = this.baseUrl + "/api/services/app/NaturalPerson/UserSuggestedNaturalPersonChanges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserSuggestedNaturalPersonChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserSuggestedNaturalPersonChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSuggestedNaturalPersonChangesControl>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSuggestedNaturalPersonChangesControl>;
        }));
    }

    protected processUserSuggestedNaturalPersonChanges(response: HttpResponseBase): Observable<UserSuggestedNaturalPersonChangesControl> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSuggestedNaturalPersonChangesControl.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    hasSuggestedNaturalPersonChanges(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/NaturalPerson/HasSuggestedNaturalPersonChanges";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasSuggestedNaturalPersonChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasSuggestedNaturalPersonChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processHasSuggestedNaturalPersonChanges(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    hasSuggestedNaturalPersonChangesByUser(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/NaturalPerson/HasSuggestedNaturalPersonChangesByUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasSuggestedNaturalPersonChangesByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasSuggestedNaturalPersonChangesByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processHasSuggestedNaturalPersonChangesByUser(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserSuggestedNaturalPersonChanges(id: number | undefined): Observable<UserSuggestedNaturalPersonChangesOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/NaturalPerson/GetUserSuggestedNaturalPersonChanges?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSuggestedNaturalPersonChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSuggestedNaturalPersonChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSuggestedNaturalPersonChangesOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSuggestedNaturalPersonChangesOutputDto>;
        }));
    }

    protected processGetUserSuggestedNaturalPersonChanges(response: HttpResponseBase): Observable<UserSuggestedNaturalPersonChangesOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSuggestedNaturalPersonChangesOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NaturalPerson/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @return Success
     */
    checkEmailExistence(emailAddress: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/NaturalPerson/CheckEmailExistence?";
        if (emailAddress === null)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckEmailExistence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckEmailExistence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckEmailExistence(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personCompanyRoleDataId (optional) 
     * @return Success
     */
    getFinalBeneficiariesByPersonCompanyRoleDataId(personCompanyRoleDataId: number | undefined): Observable<PersonCompanyRoleDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NaturalPerson/GetFinalBeneficiariesByPersonCompanyRoleDataId?";
        if (personCompanyRoleDataId === null)
            throw new Error("The parameter 'personCompanyRoleDataId' cannot be null.");
        else if (personCompanyRoleDataId !== undefined)
            url_ += "personCompanyRoleDataId=" + encodeURIComponent("" + personCompanyRoleDataId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinalBeneficiariesByPersonCompanyRoleDataId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinalBeneficiariesByPersonCompanyRoleDataId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonCompanyRoleDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonCompanyRoleDataDto[]>;
        }));
    }

    protected processGetFinalBeneficiariesByPersonCompanyRoleDataId(response: HttpResponseBase): Observable<PersonCompanyRoleDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personCompanyRoleDataId (optional) 
     * @return Success
     */
    getAttorneysInFactByPersonCompanyRoleDataId(personCompanyRoleDataId: number | undefined): Observable<PersonCompanyRoleDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NaturalPerson/GetAttorneysInFactByPersonCompanyRoleDataId?";
        if (personCompanyRoleDataId === null)
            throw new Error("The parameter 'personCompanyRoleDataId' cannot be null.");
        else if (personCompanyRoleDataId !== undefined)
            url_ += "personCompanyRoleDataId=" + encodeURIComponent("" + personCompanyRoleDataId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttorneysInFactByPersonCompanyRoleDataId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttorneysInFactByPersonCompanyRoleDataId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonCompanyRoleDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonCompanyRoleDataDto[]>;
        }));
    }

    protected processGetAttorneysInFactByPersonCompanyRoleDataId(response: HttpResponseBase): Observable<PersonCompanyRoleDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personCompanyRoleDataId (optional) 
     * @return Success
     */
    getPersonEmailByPersonCompanyRoleDataId(personCompanyRoleDataId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/NaturalPerson/GetPersonEmailByPersonCompanyRoleDataId?";
        if (personCompanyRoleDataId === null)
            throw new Error("The parameter 'personCompanyRoleDataId' cannot be null.");
        else if (personCompanyRoleDataId !== undefined)
            url_ += "personCompanyRoleDataId=" + encodeURIComponent("" + personCompanyRoleDataId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonEmailByPersonCompanyRoleDataId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonEmailByPersonCompanyRoleDataId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetPersonEmailByPersonCompanyRoleDataId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param naturalPersonId (optional) 
     * @return Success
     */
    getNaturalPersonReport(naturalPersonId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/NaturalPerson/GetNaturalPersonReport?";
        if (naturalPersonId === null)
            throw new Error("The parameter 'naturalPersonId' cannot be null.");
        else if (naturalPersonId !== undefined)
            url_ += "naturalPersonId=" + encodeURIComponent("" + naturalPersonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNaturalPersonReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNaturalPersonReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetNaturalPersonReport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param guid (optional) 
     * @return Success
     */
    getNaturalPersonSocietiesByGuid(guid: string | undefined): Observable<CompanyDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NaturalPerson/GetNaturalPersonSocietiesByGuid?";
        if (guid === null)
            throw new Error("The parameter 'guid' cannot be null.");
        else if (guid !== undefined)
            url_ += "guid=" + encodeURIComponent("" + guid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNaturalPersonSocietiesByGuid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNaturalPersonSocietiesByGuid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDto[]>;
        }));
    }

    protected processGetNaturalPersonSocietiesByGuid(response: HttpResponseBase): Observable<CompanyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CompanyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUnreadNotificationsCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUnreadNotificationsCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnreadNotificationsCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnreadNotificationsCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetUnreadNotificationsCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param notificationId (optional) 
     * @return Success
     */
    setNotificationAsRead(notificationId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetNotificationAsRead?";
        if (notificationId === null)
            throw new Error("The parameter 'notificationId' cannot be null.");
        else if (notificationId !== undefined)
            url_ += "notificationId=" + encodeURIComponent("" + notificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNotificationAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNotificationAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetNotificationAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param notificationId (optional) 
     * @return Success
     */
    setNotificationAsUnRead(notificationId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetNotificationAsUnRead?";
        if (notificationId === null)
            throw new Error("The parameter 'notificationId' cannot be null.");
        else if (notificationId !== undefined)
            url_ += "notificationId=" + encodeURIComponent("" + notificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNotificationAsUnRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNotificationAsUnRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetNotificationAsUnRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param notificationId (optional) 
     * @return Success
     */
    setNotificationAsArchived(notificationId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetNotificationAsArchived?";
        if (notificationId === null)
            throw new Error("The parameter 'notificationId' cannot be null.");
        else if (notificationId !== undefined)
            url_ += "notificationId=" + encodeURIComponent("" + notificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNotificationAsArchived(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNotificationAsArchived(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetNotificationAsArchived(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    setAllNotificationsAsArchivated(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetAllNotificationsAsArchivated";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAllNotificationsAsArchivated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllNotificationsAsArchivated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAllNotificationsAsArchivated(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNotificationsInfo(): Observable<BaseMessageNotificationDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationsInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationsInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationsInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseMessageNotificationDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseMessageNotificationDataDto[]>;
        }));
    }

    protected processGetNotificationsInfo(response: HttpResponseBase): Observable<BaseMessageNotificationDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BaseMessageNotificationDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param names (optional) 
     * @param users (optional) 
     * @param status (optional) 
     * @param tags (optional) 
     * @param readUnread (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllNotificationsByDate(dateFrom: moment.Moment | undefined, dateTo: moment.Moment | undefined, names: string[] | undefined, users: string[] | undefined, status: string[] | undefined, tags: string[] | undefined, readUnread: UserNotificationState[] | undefined, order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<BaseMessageNotificationDataDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetAllNotificationsByDate?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (names === null)
            throw new Error("The parameter 'names' cannot be null.");
        else if (names !== undefined)
            names && names.forEach(item => { url_ += "Names=" + encodeURIComponent("" + item) + "&"; });
        if (users === null)
            throw new Error("The parameter 'users' cannot be null.");
        else if (users !== undefined)
            users && users.forEach(item => { url_ += "Users=" + encodeURIComponent("" + item) + "&"; });
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            status && status.forEach(item => { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        if (tags === null)
            throw new Error("The parameter 'tags' cannot be null.");
        else if (tags !== undefined)
            tags && tags.forEach(item => { url_ += "Tags=" + encodeURIComponent("" + item) + "&"; });
        if (readUnread === null)
            throw new Error("The parameter 'readUnread' cannot be null.");
        else if (readUnread !== undefined)
            readUnread && readUnread.forEach(item => { url_ += "ReadUnread=" + encodeURIComponent("" + item) + "&"; });
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllNotificationsByDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNotificationsByDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseMessageNotificationDataDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseMessageNotificationDataDtoPagedResultDto>;
        }));
    }

    protected processGetAllNotificationsByDate(response: HttpResponseBase): Observable<BaseMessageNotificationDataDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseMessageNotificationDataDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NuptialsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<NuptialsDto> {
        let url_ = this.baseUrl + "/api/services/app/Nuptials/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NuptialsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NuptialsDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NuptialsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NuptialsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<NuptialsDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Nuptials/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NuptialsDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NuptialsDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<NuptialsDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NuptialsDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: NuptialsDto | undefined): Observable<NuptialsDto> {
        let url_ = this.baseUrl + "/api/services/app/Nuptials/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NuptialsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NuptialsDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<NuptialsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NuptialsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: NuptialsDto | undefined): Observable<NuptialsDto> {
        let url_ = this.baseUrl + "/api/services/app/Nuptials/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NuptialsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NuptialsDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<NuptialsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NuptialsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Nuptials/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OccupationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<OccupationDto> {
        let url_ = this.baseUrl + "/api/services/app/Occupation/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OccupationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OccupationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OccupationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OccupationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OccupationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Occupation/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OccupationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OccupationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OccupationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OccupationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: OccupationDto | undefined): Observable<OccupationDto> {
        let url_ = this.baseUrl + "/api/services/app/Occupation/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OccupationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OccupationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OccupationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OccupationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: OccupationDto | undefined): Observable<OccupationDto> {
        let url_ = this.baseUrl + "/api/services/app/Occupation/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OccupationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OccupationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OccupationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OccupationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Occupation/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PersonCompanyAssetDataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PersonCompanyAssetDataDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonCompanyAssetData/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonCompanyAssetDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonCompanyAssetDataDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PersonCompanyAssetDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonCompanyAssetDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PersonCompanyAssetDataDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonCompanyAssetData/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonCompanyAssetDataDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonCompanyAssetDataDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PersonCompanyAssetDataDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonCompanyAssetDataDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: PersonCompanyAssetDataDto | undefined): Observable<PersonCompanyAssetDataDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonCompanyAssetData/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonCompanyAssetDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonCompanyAssetDataDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PersonCompanyAssetDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonCompanyAssetDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: PersonCompanyAssetDataDto | undefined): Observable<PersonCompanyAssetDataDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonCompanyAssetData/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonCompanyAssetDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonCompanyAssetDataDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PersonCompanyAssetDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonCompanyAssetDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonCompanyAssetData/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PositionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PositionDto> {
        let url_ = this.baseUrl + "/api/services/app/Position/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PositionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PositionDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PositionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PositionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PositionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Position/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PositionDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PositionDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PositionDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PositionDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: PositionDto | undefined): Observable<PositionDto> {
        let url_ = this.baseUrl + "/api/services/app/Position/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PositionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PositionDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PositionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PositionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: PositionDto | undefined): Observable<PositionDto> {
        let url_ = this.baseUrl + "/api/services/app/Position/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PositionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PositionDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PositionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PositionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Position/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | undefined): Observable<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission === null)
            throw new Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleListDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleListDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleListDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<PermissionDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionDtoListResultDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<PermissionDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ShareTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ShareTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ShareType/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShareTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShareTypeDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ShareTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShareTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ShareTypeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ShareType/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShareTypeDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShareTypeDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ShareTypeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShareTypeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ShareTypeDto | undefined): Observable<ShareTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ShareType/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShareTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShareTypeDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ShareTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShareTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ShareTypeDto | undefined): Observable<ShareTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ShareType/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShareTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShareTypeDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ShareTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShareTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ShareType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TemplateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TemplateDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Template/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TemplateDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCustomFields(): Observable<CustomFieldDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Template/GetCustomFields";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomFields(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomFieldDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomFieldDto[]>;
        }));
    }

    protected processGetCustomFields(response: HttpResponseBase): Observable<CustomFieldDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomFieldDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getTypeFields(): Observable<TypeFieldDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Template/GetTypeFields";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTypeFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTypeFields(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TypeFieldDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TypeFieldDto[]>;
        }));
    }

    protected processGetTypeFields(response: HttpResponseBase): Observable<TypeFieldDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TypeFieldDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateTemplate(body: TemplateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Template/CreateOrUpdateTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTemplateForEdit(id: number | undefined): Observable<TemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/Template/GetTemplateForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplateForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplateForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateDto>;
        }));
    }

    protected processGetTemplateForEdit(response: HttpResponseBase): Observable<TemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/Template/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TemplateDto | undefined): Observable<TemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/Template/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TemplateDto | undefined): Observable<TemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/Template/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Template/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateTenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllForLoggedUser(): Observable<TenantDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAllForLoggedUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForLoggedUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForLoggedUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto[]>;
        }));
    }

    protected processGetAllForLoggedUser(response: HttpResponseBase): Observable<TenantDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TenantDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantFilteredId (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAndFilter(tenantFilteredId: number | undefined, order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAllAndFilter?";
        if (tenantFilteredId === null)
            throw new Error("The parameter 'tenantFilteredId' cannot be null.");
        else if (tenantFilteredId !== undefined)
            url_ += "tenantFilteredId=" + encodeURIComponent("" + tenantFilteredId) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAndFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAndFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDtoPagedResultDto>;
        }));
    }

    protected processGetAllAndFilter(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    migrateCompaniesToTenant(body: MigrateCompaniesDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/MigrateCompaniesToTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMigrateCompaniesToTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMigrateCompaniesToTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMigrateCompaniesToTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param selectedTenantId (optional) 
     * @param body (optional) 
     * @return Success
     */
    returnCompanyIfExistsInSelectedTenant(selectedTenantId: number | undefined, body: number[] | undefined): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ReturnCompanyIfExistsInSelectedTenant?";
        if (selectedTenantId === null)
            throw new Error("The parameter 'selectedTenantId' cannot be null.");
        else if (selectedTenantId !== undefined)
            url_ += "selectedTenantId=" + encodeURIComponent("" + selectedTenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReturnCompanyIfExistsInSelectedTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReturnCompanyIfExistsInSelectedTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDto>;
        }));
    }

    protected processReturnCompanyIfExistsInSelectedTenant(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isActive (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(isActive: boolean | undefined, order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    switchManager(body: string | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/SwitchManager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processSwitchManager(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TypeFieldServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TypeFieldDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TypeField/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TypeFieldDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TypeFieldDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TypeFieldDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TypeFieldDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TypeField/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TypeFieldDto> {
        let url_ = this.baseUrl + "/api/services/app/TypeField/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TypeFieldDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TypeFieldDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TypeFieldDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TypeFieldDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TypeFieldDto | undefined): Observable<TypeFieldDto> {
        let url_ = this.baseUrl + "/api/services/app/TypeField/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TypeFieldDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TypeFieldDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TypeFieldDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TypeFieldDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TypeFieldDto | undefined): Observable<TypeFieldDto> {
        let url_ = this.baseUrl + "/api/services/app/TypeField/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TypeFieldDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TypeFieldDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TypeFieldDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TypeFieldDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param companyId (optional) 
     * @return Success
     */
    getAllSelectableUsersForCompany(companyId: number | undefined): Observable<SelectableUserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAllSelectableUsersForCompany?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSelectableUsersForCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSelectableUsersForCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectableUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectableUserDto[]>;
        }));
    }

    protected processGetAllSelectableUsersForCompany(response: HttpResponseBase): Observable<SelectableUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SelectableUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyProfile(): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetMyProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGetMyProfile(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMyProfile(body: UserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateMyProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMyProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMyProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUpdateMyProfile(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activate(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deActivate(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeActivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRoles(): Observable<RoleDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param input (optional) 
     * @return Success
     */
    uploadProfilePhoto(userId: number | undefined, input: FileParameter | null | undefined): Observable<UploadProfilePhotoOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/User/UploadProfilePhoto?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (input !== null && input !== undefined)
            content_.append("input", input.data, input.fileName ? input.fileName : "input");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadProfilePhoto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadProfilePhoto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadProfilePhotoOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadProfilePhotoOutputDto>;
        }));
    }

    protected processUploadProfilePhoto(response: HttpResponseBase): Observable<UploadProfilePhotoOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadProfilePhotoOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    uploadMyProfilePhoto(input: FileParameter | null | undefined): Observable<UploadProfilePhotoOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/User/UploadMyProfilePhoto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (input !== null && input !== undefined)
            content_.append("input", input.data, input.fileName ? input.fileName : "input");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadMyProfilePhoto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadMyProfilePhoto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadProfilePhotoOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadProfilePhotoOutputDto>;
        }));
    }

    protected processUploadMyProfilePhoto(response: HttpResponseBase): Observable<UploadProfilePhotoOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadProfilePhotoOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    uploadNewProfilePhoto(input: FileParameter | null | undefined): Observable<UploadProfilePhotoOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/User/UploadNewProfilePhoto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (input !== null && input !== undefined)
            content_.append("input", input.data, input.fileName ? input.fileName : "input");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadNewProfilePhoto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadNewProfilePhoto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadProfilePhotoOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadProfilePhotoOutputDto>;
        }));
    }

    protected processUploadNewProfilePhoto(response: HttpResponseBase): Observable<UploadProfilePhotoOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadProfilePhotoOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getAdminUserByTenantId(tenantId: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAdminUserByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminUserByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminUserByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGetAdminUserByTenantId(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getExternalUsers(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ExternalUserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetExternalUsers?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalUserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalUserDtoPagedResultDto>;
        }));
    }

    protected processGetExternalUsers(response: HttpResponseBase): Observable<ExternalUserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalUserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isActive (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(isActive: boolean | undefined, order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserLibraryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUserPersonLibrary(): Observable<PersonLibraryResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserLibrary/GetUserPersonLibrary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPersonLibrary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPersonLibrary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonLibraryResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonLibraryResponseDto[]>;
        }));
    }

    protected processGetUserPersonLibrary(response: HttpResponseBase): Observable<PersonLibraryResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PersonLibraryResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getJuridicalPersonLibraryForUser(id: number | undefined): Observable<PersonLibraryResponseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserLibrary/GetJuridicalPersonLibraryForUser?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJuridicalPersonLibraryForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJuridicalPersonLibraryForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonLibraryResponseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonLibraryResponseDto[]>;
        }));
    }

    protected processGetJuridicalPersonLibraryForUser(response: HttpResponseBase): Observable<PersonLibraryResponseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PersonLibraryResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadUserLibraryFile(body: DownloadLibraryFileRequestDto | undefined): Observable<DownloadLibraryFileResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLibrary/DownloadUserLibraryFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadUserLibraryFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadUserLibraryFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DownloadLibraryFileResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DownloadLibraryFileResponseDto>;
        }));
    }

    protected processDownloadUserLibraryFile(response: HttpResponseBase): Observable<DownloadLibraryFileResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadLibraryFileResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param libraryFileOwnerId (optional) 
     * @param libraryConfigurationId (optional) 
     * @param libraryConfigurationKindId (optional) 
     * @param libraryConfigurationRoleId (optional) 
     * @param parentId (optional) 
     * @param libraryFileTypeId (optional) 
     * @param isVisble (optional) 
     * @param isChecked (optional) 
     * @param isShared (optional) 
     * @param name (optional) 
     * @param mIME (optional) 
     * @param fullNameExtension (optional) 
     * @param files (optional) 
     * @param companyId (optional) 
     * @param id (optional) 
     * @return Success
     */
    createLibraryItem(libraryFileOwnerId: number | null | undefined, libraryConfigurationId: number | null | undefined, libraryConfigurationKindId: number | null | undefined, libraryConfigurationRoleId: number | null | undefined, parentId: number | null | undefined, libraryFileTypeId: number | undefined, isVisble: boolean | undefined, isChecked: boolean | undefined, isShared: boolean | undefined, name: string | null | undefined, mIME: string | null | undefined, fullNameExtension: string | null | undefined, files: FileParameter[] | null | undefined, companyId: number | null | undefined, id: number | undefined): Observable<CreateLibraryItemOutDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserLibrary/CreateLibraryItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (libraryFileOwnerId !== null && libraryFileOwnerId !== undefined)
            content_.append("LibraryFileOwnerId", libraryFileOwnerId.toString());
        if (libraryConfigurationId !== null && libraryConfigurationId !== undefined)
            content_.append("LibraryConfigurationId", libraryConfigurationId.toString());
        if (libraryConfigurationKindId !== null && libraryConfigurationKindId !== undefined)
            content_.append("LibraryConfigurationKindId", libraryConfigurationKindId.toString());
        if (libraryConfigurationRoleId !== null && libraryConfigurationRoleId !== undefined)
            content_.append("LibraryConfigurationRoleId", libraryConfigurationRoleId.toString());
        if (parentId !== null && parentId !== undefined)
            content_.append("ParentId", parentId.toString());
        if (libraryFileTypeId === null || libraryFileTypeId === undefined)
            throw new Error("The parameter 'libraryFileTypeId' cannot be null.");
        else
            content_.append("LibraryFileTypeId", libraryFileTypeId.toString());
        if (isVisble === null || isVisble === undefined)
            throw new Error("The parameter 'isVisble' cannot be null.");
        else
            content_.append("IsVisble", isVisble.toString());
        if (isChecked === null || isChecked === undefined)
            throw new Error("The parameter 'isChecked' cannot be null.");
        else
            content_.append("IsChecked", isChecked.toString());
        if (isShared === null || isShared === undefined)
            throw new Error("The parameter 'isShared' cannot be null.");
        else
            content_.append("IsShared", isShared.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (mIME !== null && mIME !== undefined)
            content_.append("MIME", mIME.toString());
        if (fullNameExtension !== null && fullNameExtension !== undefined)
            content_.append("FullNameExtension", fullNameExtension.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (companyId !== null && companyId !== undefined)
            content_.append("CompanyId", companyId.toString());
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLibraryItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLibraryItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateLibraryItemOutDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateLibraryItemOutDto[]>;
        }));
    }

    protected processCreateLibraryItem(response: HttpResponseBase): Observable<CreateLibraryItemOutDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CreateLibraryItemOutDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userPassword (optional) 
     * @param id (optional) 
     * @return Success
     */
    deleteCompanyLibraryItem(userPassword: string | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLibrary/DeleteCompanyLibraryItem?";
        if (userPassword === null)
            throw new Error("The parameter 'userPassword' cannot be null.");
        else if (userPassword !== undefined)
            url_ += "UserPassword=" + encodeURIComponent("" + userPassword) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCompanyLibraryItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCompanyLibraryItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCompanyLibraryItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveLibraryItems(body: MoveLibraryItemRequestDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLibrary/MoveLibraryItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveLibraryItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveLibraryItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMoveLibraryItems(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserNotificationSettingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param bySociety (optional) 
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllUserNotificationSettingByUserSession(bySociety: boolean | undefined, order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserNotificationSettingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserNotificationSetting/GetAllUserNotificationSettingByUserSession?";
        if (bySociety === null)
            throw new Error("The parameter 'bySociety' cannot be null.");
        else if (bySociety !== undefined)
            url_ += "BySociety=" + encodeURIComponent("" + bySociety) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserNotificationSettingByUserSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserNotificationSettingByUserSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserNotificationSettingDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserNotificationSettingDtoPagedResultDto>;
        }));
    }

    protected processGetAllUserNotificationSettingByUserSession(response: HttpResponseBase): Observable<UserNotificationSettingDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserNotificationSettingDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserNotificationSetting(body: UserNotificationSettingDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserNotificationSetting/UpdateUserNotificationSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserNotificationSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserNotificationSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserNotificationSetting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ValueFieldServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveValueFields(body: ValueFieldDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ValueField/SaveValueFields";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveValueFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveValueFields(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveValueFields(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ValueFieldDto> {
        let url_ = this.baseUrl + "/api/services/app/ValueField/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValueFieldDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValueFieldDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ValueFieldDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValueFieldDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ValueFieldDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ValueField/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValueFieldDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValueFieldDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ValueFieldDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValueFieldDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ValueFieldDto | undefined): Observable<ValueFieldDto> {
        let url_ = this.baseUrl + "/api/services/app/ValueField/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValueFieldDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValueFieldDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ValueFieldDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValueFieldDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ValueFieldDto | undefined): Observable<ValueFieldDto> {
        let url_ = this.baseUrl + "/api/services/app/ValueField/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValueFieldDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValueFieldDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ValueFieldDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValueFieldDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ValueField/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WorkActivityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<WorkActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/WorkActivity/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WorkActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param order (optional) 
     * @param orderDirection (optional) 
     * @param keyword (optional) 
     * @param filters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(order: string | undefined, orderDirection: OrderDirectionEnum | undefined, keyword: string | undefined, filters: FilterFieldEntryDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<WorkActivityDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/WorkActivity/GetAll?";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "Order=" + encodeURIComponent("" + order) + "&";
        if (orderDirection === null)
            throw new Error("The parameter 'orderDirection' cannot be null.");
        else if (orderDirection !== undefined)
            url_ += "OrderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Filters[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<WorkActivityDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActivityDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: WorkActivityDto | undefined): Observable<WorkActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/WorkActivity/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<WorkActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: WorkActivityDto | undefined): Observable<WorkActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/WorkActivity/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkActivityDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<WorkActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WorkActivity/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class ActivateUserAccountDto implements IActivateUserAccountDto {
    emailAddress: string;
    activateUserCode: string;

    constructor(data?: IActivateUserAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.activateUserCode = _data["activateUserCode"];
        }
    }

    static fromJS(data: any): ActivateUserAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateUserAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["activateUserCode"] = this.activateUserCode;
        return data;
    }

    clone(): ActivateUserAccountDto {
        const json = this.toJSON();
        let result = new ActivateUserAccountDto();
        result.init(json);
        return result;
    }
}

export interface IActivateUserAccountDto {
    emailAddress: string;
    activateUserCode: string;
}

export class Address implements IAddress {
    id: number;
    countryId: number | undefined;
    country: Country;
    locationId: number | undefined;
    location: Location;
    street: string | undefined;
    number: string | undefined;
    apartment: string | undefined;
    locationText: string | undefined;
    others: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.countryId = _data["countryId"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.locationId = _data["locationId"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.street = _data["street"];
            this.number = _data["number"];
            this.apartment = _data["apartment"];
            this.locationText = _data["locationText"];
            this.others = _data["others"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["countryId"] = this.countryId;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["street"] = this.street;
        data["number"] = this.number;
        data["apartment"] = this.apartment;
        data["locationText"] = this.locationText;
        data["others"] = this.others;
        return data;
    }

    clone(): Address {
        const json = this.toJSON();
        let result = new Address();
        result.init(json);
        return result;
    }
}

export interface IAddress {
    id: number;
    countryId: number | undefined;
    country: Country;
    locationId: number | undefined;
    location: Location;
    street: string | undefined;
    number: string | undefined;
    apartment: string | undefined;
    locationText: string | undefined;
    others: string | undefined;
}

export class AddressDto implements IAddressDto {
    id: number;
    countryId: number | undefined;
    country: CountryDto;
    locationId: number | undefined;
    location: LocationDto;
    street: string | undefined;
    number: string | undefined;
    apartment: string | undefined;
    locationText: string | undefined;
    others: string | undefined;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.countryId = _data["countryId"];
            this.country = _data["country"] ? CountryDto.fromJS(_data["country"]) : <any>undefined;
            this.locationId = _data["locationId"];
            this.location = _data["location"] ? LocationDto.fromJS(_data["location"]) : <any>undefined;
            this.street = _data["street"];
            this.number = _data["number"];
            this.apartment = _data["apartment"];
            this.locationText = _data["locationText"];
            this.others = _data["others"];
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["countryId"] = this.countryId;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["street"] = this.street;
        data["number"] = this.number;
        data["apartment"] = this.apartment;
        data["locationText"] = this.locationText;
        data["others"] = this.others;
        return data;
    }

    clone(): AddressDto {
        const json = this.toJSON();
        let result = new AddressDto();
        result.init(json);
        return result;
    }
}

export interface IAddressDto {
    id: number;
    countryId: number | undefined;
    country: CountryDto;
    locationId: number | undefined;
    location: LocationDto;
    street: string | undefined;
    number: string | undefined;
    apartment: string | undefined;
    locationText: string | undefined;
    others: string | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)[key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;
}

export class AssetDto implements IAssetDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    value: number;
    currencyId: number | undefined;
    currencySymbol: string | undefined;
    assetStateId: number | undefined;
    assetState: AssetStateDto;
    templateId: number | undefined;
    template: TemplateDto;
    valueFields: ValueFieldDto[] | undefined;
    personCompanyAssetData: PersonCompanyAssetDataDto[] | undefined;

    constructor(data?: IAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.currencyId = _data["currencyId"];
            this.currencySymbol = _data["currencySymbol"];
            this.assetStateId = _data["assetStateId"];
            this.assetState = _data["assetState"] ? AssetStateDto.fromJS(_data["assetState"]) : <any>undefined;
            this.templateId = _data["templateId"];
            this.template = _data["template"] ? TemplateDto.fromJS(_data["template"]) : <any>undefined;
            if (Array.isArray(_data["valueFields"])) {
                this.valueFields = [] as any;
                for (let item of _data["valueFields"])
                    this.valueFields.push(ValueFieldDto.fromJS(item));
            }
            if (Array.isArray(_data["personCompanyAssetData"])) {
                this.personCompanyAssetData = [] as any;
                for (let item of _data["personCompanyAssetData"])
                    this.personCompanyAssetData.push(PersonCompanyAssetDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["currencyId"] = this.currencyId;
        data["currencySymbol"] = this.currencySymbol;
        data["assetStateId"] = this.assetStateId;
        data["assetState"] = this.assetState ? this.assetState.toJSON() : <any>undefined;
        data["templateId"] = this.templateId;
        data["template"] = this.template ? this.template.toJSON() : <any>undefined;
        if (Array.isArray(this.valueFields)) {
            data["valueFields"] = [];
            for (let item of this.valueFields)
                data["valueFields"].push(item.toJSON());
        }
        if (Array.isArray(this.personCompanyAssetData)) {
            data["personCompanyAssetData"] = [];
            for (let item of this.personCompanyAssetData)
                data["personCompanyAssetData"].push(item.toJSON());
        }
        return data;
    }

    clone(): AssetDto {
        const json = this.toJSON();
        let result = new AssetDto();
        result.init(json);
        return result;
    }
}

export interface IAssetDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    value: number;
    currencyId: number | undefined;
    currencySymbol: string | undefined;
    assetStateId: number | undefined;
    assetState: AssetStateDto;
    templateId: number | undefined;
    template: TemplateDto;
    valueFields: ValueFieldDto[] | undefined;
    personCompanyAssetData: PersonCompanyAssetDataDto[] | undefined;
}

export class AssetDtoPagedResultDto implements IAssetDtoPagedResultDto {
    items: AssetDto[] | undefined;
    totalCount: number;

    constructor(data?: IAssetDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AssetDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AssetDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AssetDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AssetDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAssetDtoPagedResultDto {
    items: AssetDto[] | undefined;
    totalCount: number;
}

export class AssetStateDto implements IAssetStateDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;

    constructor(data?: IAssetStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
        }
    }

    static fromJS(data: any): AssetStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        return data;
    }

    clone(): AssetStateDto {
        const json = this.toJSON();
        let result = new AssetStateDto();
        result.init(json);
        return result;
    }
}

export interface IAssetStateDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
}

export class AssetStateDtoPagedResultDto implements IAssetStateDtoPagedResultDto {
    items: AssetStateDto[] | undefined;
    totalCount: number;

    constructor(data?: IAssetStateDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AssetStateDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AssetStateDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetStateDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AssetStateDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AssetStateDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAssetStateDtoPagedResultDto {
    items: AssetStateDto[] | undefined;
    totalCount: number;
}

export class AssignableJuridicalPersonAssetDto implements IAssignableJuridicalPersonAssetDto {
    id: number;
    assetId: number;
    companyId: number | undefined;
    company: CompanyDto;
    naturalPersonId: number | undefined;
    naturalPerson: NaturalPersonDto;
    juridicalPersonId: number | undefined;
    juridicalPerson: CompanyDto;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    showEndDate: boolean;
    endDateString: string | undefined;
    participationPercentage: number;
    participationValue: number;
    guid: string;
    relatedPersonCompanyAssetDataGuid: string | undefined;
    inAsset: boolean;
    isChecked: boolean;
    isCompleted: boolean;

    constructor(data?: IAssignableJuridicalPersonAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assetId = _data["assetId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.naturalPersonId = _data["naturalPersonId"];
            this.naturalPerson = _data["naturalPerson"] ? NaturalPersonDto.fromJS(_data["naturalPerson"]) : <any>undefined;
            this.juridicalPersonId = _data["juridicalPersonId"];
            this.juridicalPerson = _data["juridicalPerson"] ? CompanyDto.fromJS(_data["juridicalPerson"]) : <any>undefined;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.showEndDate = _data["showEndDate"];
            this.endDateString = _data["endDateString"];
            this.participationPercentage = _data["participationPercentage"];
            this.participationValue = _data["participationValue"];
            this.guid = _data["guid"];
            this.relatedPersonCompanyAssetDataGuid = _data["relatedPersonCompanyAssetDataGuid"];
            this.inAsset = _data["inAsset"];
            this.isChecked = _data["isChecked"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): AssignableJuridicalPersonAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignableJuridicalPersonAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assetId"] = this.assetId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["naturalPersonId"] = this.naturalPersonId;
        data["naturalPerson"] = this.naturalPerson ? this.naturalPerson.toJSON() : <any>undefined;
        data["juridicalPersonId"] = this.juridicalPersonId;
        data["juridicalPerson"] = this.juridicalPerson ? this.juridicalPerson.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["showEndDate"] = this.showEndDate;
        data["endDateString"] = this.endDateString;
        data["participationPercentage"] = this.participationPercentage;
        data["participationValue"] = this.participationValue;
        data["guid"] = this.guid;
        data["relatedPersonCompanyAssetDataGuid"] = this.relatedPersonCompanyAssetDataGuid;
        data["inAsset"] = this.inAsset;
        data["isChecked"] = this.isChecked;
        data["isCompleted"] = this.isCompleted;
        return data;
    }

    clone(): AssignableJuridicalPersonAssetDto {
        const json = this.toJSON();
        let result = new AssignableJuridicalPersonAssetDto();
        result.init(json);
        return result;
    }
}

export interface IAssignableJuridicalPersonAssetDto {
    id: number;
    assetId: number;
    companyId: number | undefined;
    company: CompanyDto;
    naturalPersonId: number | undefined;
    naturalPerson: NaturalPersonDto;
    juridicalPersonId: number | undefined;
    juridicalPerson: CompanyDto;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    showEndDate: boolean;
    endDateString: string | undefined;
    participationPercentage: number;
    participationValue: number;
    guid: string;
    relatedPersonCompanyAssetDataGuid: string | undefined;
    inAsset: boolean;
    isChecked: boolean;
    isCompleted: boolean;
}

export class AssignableJuridicalPersonAssetDtoPagedResultDto implements IAssignableJuridicalPersonAssetDtoPagedResultDto {
    items: AssignableJuridicalPersonAssetDto[] | undefined;
    totalCount: number;

    constructor(data?: IAssignableJuridicalPersonAssetDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AssignableJuridicalPersonAssetDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AssignableJuridicalPersonAssetDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignableJuridicalPersonAssetDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AssignableJuridicalPersonAssetDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AssignableJuridicalPersonAssetDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAssignableJuridicalPersonAssetDtoPagedResultDto {
    items: AssignableJuridicalPersonAssetDto[] | undefined;
    totalCount: number;
}

export class AssignableJuridicalPersonDto implements IAssignableJuridicalPersonDto {
    id: number;
    companyId: number;
    naturalPersonId: number | undefined;
    naturalPerson: NaturalPersonDto;
    juridicalPersonId: number | undefined;
    juridicalPerson: CompanyDto;
    companyRoleId: number;
    companyRole: CompanyRoleDto;
    positionId: number | undefined;
    position: PositionDto;
    shareholding: number | undefined;
    nominalValue: number | undefined;
    effectiveDate: moment.Moment | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    grantDate: moment.Moment | undefined;
    revocationDate: moment.Moment | undefined;
    attorneyInFactTypeId: number | undefined;
    attorneyInFactType: AttorneyInFactTypeDto;
    attorneysInFact: boolean | undefined;
    functionalLinkId: number | undefined;
    functionalLink: FunctionalLinkDto;
    healthInsuranceId: number | undefined;
    healthInsurance: HealthInsuranceDto;
    relatedPersonCompanyRoleDatas: PersonCompanyRoleDataDto[] | undefined;
    relatedPersonCompanyRoleDataId: number | undefined;
    relatedPersonCompanyRoleDataGuid: string | undefined;
    relatedPersonCompanyRoleData: PersonCompanyRoleDataDto;
    finalBeneficiary: boolean | undefined;
    loadLessInfo: boolean | undefined;
    guid: string;
    showEndDate: boolean;
    endDateString: string | undefined;
    globalControl: number | undefined;
    inSociety: boolean;
    isChecked: boolean;
    isCompleted: boolean;

    constructor(data?: IAssignableJuridicalPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.naturalPersonId = _data["naturalPersonId"];
            this.naturalPerson = _data["naturalPerson"] ? NaturalPersonDto.fromJS(_data["naturalPerson"]) : <any>undefined;
            this.juridicalPersonId = _data["juridicalPersonId"];
            this.juridicalPerson = _data["juridicalPerson"] ? CompanyDto.fromJS(_data["juridicalPerson"]) : <any>undefined;
            this.companyRoleId = _data["companyRoleId"];
            this.companyRole = _data["companyRole"] ? CompanyRoleDto.fromJS(_data["companyRole"]) : <any>undefined;
            this.positionId = _data["positionId"];
            this.position = _data["position"] ? PositionDto.fromJS(_data["position"]) : <any>undefined;
            this.shareholding = _data["shareholding"];
            this.nominalValue = _data["nominalValue"];
            this.effectiveDate = _data["effectiveDate"] ? moment(_data["effectiveDate"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.grantDate = _data["grantDate"] ? moment(_data["grantDate"].toString()) : <any>undefined;
            this.revocationDate = _data["revocationDate"] ? moment(_data["revocationDate"].toString()) : <any>undefined;
            this.attorneyInFactTypeId = _data["attorneyInFactTypeId"];
            this.attorneyInFactType = _data["attorneyInFactType"] ? AttorneyInFactTypeDto.fromJS(_data["attorneyInFactType"]) : <any>undefined;
            this.attorneysInFact = _data["attorneysInFact"];
            this.functionalLinkId = _data["functionalLinkId"];
            this.functionalLink = _data["functionalLink"] ? FunctionalLinkDto.fromJS(_data["functionalLink"]) : <any>undefined;
            this.healthInsuranceId = _data["healthInsuranceId"];
            this.healthInsurance = _data["healthInsurance"] ? HealthInsuranceDto.fromJS(_data["healthInsurance"]) : <any>undefined;
            if (Array.isArray(_data["relatedPersonCompanyRoleDatas"])) {
                this.relatedPersonCompanyRoleDatas = [] as any;
                for (let item of _data["relatedPersonCompanyRoleDatas"])
                    this.relatedPersonCompanyRoleDatas.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            this.relatedPersonCompanyRoleDataId = _data["relatedPersonCompanyRoleDataId"];
            this.relatedPersonCompanyRoleDataGuid = _data["relatedPersonCompanyRoleDataGuid"];
            this.relatedPersonCompanyRoleData = _data["relatedPersonCompanyRoleData"] ? PersonCompanyRoleDataDto.fromJS(_data["relatedPersonCompanyRoleData"]) : <any>undefined;
            this.finalBeneficiary = _data["finalBeneficiary"];
            this.loadLessInfo = _data["loadLessInfo"];
            this.guid = _data["guid"];
            this.showEndDate = _data["showEndDate"];
            this.endDateString = _data["endDateString"];
            this.globalControl = _data["globalControl"];
            this.inSociety = _data["inSociety"];
            this.isChecked = _data["isChecked"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): AssignableJuridicalPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignableJuridicalPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["naturalPersonId"] = this.naturalPersonId;
        data["naturalPerson"] = this.naturalPerson ? this.naturalPerson.toJSON() : <any>undefined;
        data["juridicalPersonId"] = this.juridicalPersonId;
        data["juridicalPerson"] = this.juridicalPerson ? this.juridicalPerson.toJSON() : <any>undefined;
        data["companyRoleId"] = this.companyRoleId;
        data["companyRole"] = this.companyRole ? this.companyRole.toJSON() : <any>undefined;
        data["positionId"] = this.positionId;
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        data["shareholding"] = this.shareholding;
        data["nominalValue"] = this.nominalValue;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["grantDate"] = this.grantDate ? this.grantDate.toISOString() : <any>undefined;
        data["revocationDate"] = this.revocationDate ? this.revocationDate.toISOString() : <any>undefined;
        data["attorneyInFactTypeId"] = this.attorneyInFactTypeId;
        data["attorneyInFactType"] = this.attorneyInFactType ? this.attorneyInFactType.toJSON() : <any>undefined;
        data["attorneysInFact"] = this.attorneysInFact;
        data["functionalLinkId"] = this.functionalLinkId;
        data["functionalLink"] = this.functionalLink ? this.functionalLink.toJSON() : <any>undefined;
        data["healthInsuranceId"] = this.healthInsuranceId;
        data["healthInsurance"] = this.healthInsurance ? this.healthInsurance.toJSON() : <any>undefined;
        if (Array.isArray(this.relatedPersonCompanyRoleDatas)) {
            data["relatedPersonCompanyRoleDatas"] = [];
            for (let item of this.relatedPersonCompanyRoleDatas)
                data["relatedPersonCompanyRoleDatas"].push(item.toJSON());
        }
        data["relatedPersonCompanyRoleDataId"] = this.relatedPersonCompanyRoleDataId;
        data["relatedPersonCompanyRoleDataGuid"] = this.relatedPersonCompanyRoleDataGuid;
        data["relatedPersonCompanyRoleData"] = this.relatedPersonCompanyRoleData ? this.relatedPersonCompanyRoleData.toJSON() : <any>undefined;
        data["finalBeneficiary"] = this.finalBeneficiary;
        data["loadLessInfo"] = this.loadLessInfo;
        data["guid"] = this.guid;
        data["showEndDate"] = this.showEndDate;
        data["endDateString"] = this.endDateString;
        data["globalControl"] = this.globalControl;
        data["inSociety"] = this.inSociety;
        data["isChecked"] = this.isChecked;
        data["isCompleted"] = this.isCompleted;
        return data;
    }

    clone(): AssignableJuridicalPersonDto {
        const json = this.toJSON();
        let result = new AssignableJuridicalPersonDto();
        result.init(json);
        return result;
    }
}

export interface IAssignableJuridicalPersonDto {
    id: number;
    companyId: number;
    naturalPersonId: number | undefined;
    naturalPerson: NaturalPersonDto;
    juridicalPersonId: number | undefined;
    juridicalPerson: CompanyDto;
    companyRoleId: number;
    companyRole: CompanyRoleDto;
    positionId: number | undefined;
    position: PositionDto;
    shareholding: number | undefined;
    nominalValue: number | undefined;
    effectiveDate: moment.Moment | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    grantDate: moment.Moment | undefined;
    revocationDate: moment.Moment | undefined;
    attorneyInFactTypeId: number | undefined;
    attorneyInFactType: AttorneyInFactTypeDto;
    attorneysInFact: boolean | undefined;
    functionalLinkId: number | undefined;
    functionalLink: FunctionalLinkDto;
    healthInsuranceId: number | undefined;
    healthInsurance: HealthInsuranceDto;
    relatedPersonCompanyRoleDatas: PersonCompanyRoleDataDto[] | undefined;
    relatedPersonCompanyRoleDataId: number | undefined;
    relatedPersonCompanyRoleDataGuid: string | undefined;
    relatedPersonCompanyRoleData: PersonCompanyRoleDataDto;
    finalBeneficiary: boolean | undefined;
    loadLessInfo: boolean | undefined;
    guid: string;
    showEndDate: boolean;
    endDateString: string | undefined;
    globalControl: number | undefined;
    inSociety: boolean;
    isChecked: boolean;
    isCompleted: boolean;
}

export class AssignableJuridicalPersonDtoPagedResultDto implements IAssignableJuridicalPersonDtoPagedResultDto {
    items: AssignableJuridicalPersonDto[] | undefined;
    totalCount: number;

    constructor(data?: IAssignableJuridicalPersonDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AssignableJuridicalPersonDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AssignableJuridicalPersonDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignableJuridicalPersonDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AssignableJuridicalPersonDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AssignableJuridicalPersonDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAssignableJuridicalPersonDtoPagedResultDto {
    items: AssignableJuridicalPersonDto[] | undefined;
    totalCount: number;
}

export class AssignableNaturalPersonAssetDto implements IAssignableNaturalPersonAssetDto {
    id: number;
    assetId: number;
    companyId: number | undefined;
    company: CompanyDto;
    naturalPersonId: number | undefined;
    naturalPerson: NaturalPersonDto;
    juridicalPersonId: number | undefined;
    juridicalPerson: CompanyDto;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    showEndDate: boolean;
    endDateString: string | undefined;
    participationPercentage: number;
    participationValue: number;
    guid: string;
    relatedPersonCompanyAssetDataGuid: string | undefined;
    inAsset: boolean;
    isChecked: boolean;
    isCompleted: boolean;

    constructor(data?: IAssignableNaturalPersonAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assetId = _data["assetId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.naturalPersonId = _data["naturalPersonId"];
            this.naturalPerson = _data["naturalPerson"] ? NaturalPersonDto.fromJS(_data["naturalPerson"]) : <any>undefined;
            this.juridicalPersonId = _data["juridicalPersonId"];
            this.juridicalPerson = _data["juridicalPerson"] ? CompanyDto.fromJS(_data["juridicalPerson"]) : <any>undefined;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.showEndDate = _data["showEndDate"];
            this.endDateString = _data["endDateString"];
            this.participationPercentage = _data["participationPercentage"];
            this.participationValue = _data["participationValue"];
            this.guid = _data["guid"];
            this.relatedPersonCompanyAssetDataGuid = _data["relatedPersonCompanyAssetDataGuid"];
            this.inAsset = _data["inAsset"];
            this.isChecked = _data["isChecked"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): AssignableNaturalPersonAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignableNaturalPersonAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assetId"] = this.assetId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["naturalPersonId"] = this.naturalPersonId;
        data["naturalPerson"] = this.naturalPerson ? this.naturalPerson.toJSON() : <any>undefined;
        data["juridicalPersonId"] = this.juridicalPersonId;
        data["juridicalPerson"] = this.juridicalPerson ? this.juridicalPerson.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["showEndDate"] = this.showEndDate;
        data["endDateString"] = this.endDateString;
        data["participationPercentage"] = this.participationPercentage;
        data["participationValue"] = this.participationValue;
        data["guid"] = this.guid;
        data["relatedPersonCompanyAssetDataGuid"] = this.relatedPersonCompanyAssetDataGuid;
        data["inAsset"] = this.inAsset;
        data["isChecked"] = this.isChecked;
        data["isCompleted"] = this.isCompleted;
        return data;
    }

    clone(): AssignableNaturalPersonAssetDto {
        const json = this.toJSON();
        let result = new AssignableNaturalPersonAssetDto();
        result.init(json);
        return result;
    }
}

export interface IAssignableNaturalPersonAssetDto {
    id: number;
    assetId: number;
    companyId: number | undefined;
    company: CompanyDto;
    naturalPersonId: number | undefined;
    naturalPerson: NaturalPersonDto;
    juridicalPersonId: number | undefined;
    juridicalPerson: CompanyDto;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    showEndDate: boolean;
    endDateString: string | undefined;
    participationPercentage: number;
    participationValue: number;
    guid: string;
    relatedPersonCompanyAssetDataGuid: string | undefined;
    inAsset: boolean;
    isChecked: boolean;
    isCompleted: boolean;
}

export class AssignableNaturalPersonAssetDtoPagedResultDto implements IAssignableNaturalPersonAssetDtoPagedResultDto {
    items: AssignableNaturalPersonAssetDto[] | undefined;
    totalCount: number;

    constructor(data?: IAssignableNaturalPersonAssetDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AssignableNaturalPersonAssetDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AssignableNaturalPersonAssetDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignableNaturalPersonAssetDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AssignableNaturalPersonAssetDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AssignableNaturalPersonAssetDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAssignableNaturalPersonAssetDtoPagedResultDto {
    items: AssignableNaturalPersonAssetDto[] | undefined;
    totalCount: number;
}

export class AssignableNaturalPersonDto implements IAssignableNaturalPersonDto {
    id: number;
    companyId: number;
    naturalPersonId: number | undefined;
    naturalPerson: NaturalPersonDto;
    juridicalPersonId: number | undefined;
    juridicalPerson: CompanyDto;
    companyRoleId: number;
    companyRole: CompanyRoleDto;
    positionId: number | undefined;
    position: PositionDto;
    shareholding: number | undefined;
    nominalValue: number | undefined;
    effectiveDate: moment.Moment | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    grantDate: moment.Moment | undefined;
    revocationDate: moment.Moment | undefined;
    attorneyInFactTypeId: number | undefined;
    attorneyInFactType: AttorneyInFactTypeDto;
    attorneysInFact: boolean | undefined;
    functionalLinkId: number | undefined;
    functionalLink: FunctionalLinkDto;
    healthInsuranceId: number | undefined;
    healthInsurance: HealthInsuranceDto;
    relatedPersonCompanyRoleDatas: PersonCompanyRoleDataDto[] | undefined;
    relatedPersonCompanyRoleDataId: number | undefined;
    relatedPersonCompanyRoleDataGuid: string | undefined;
    relatedPersonCompanyRoleData: PersonCompanyRoleDataDto;
    finalBeneficiary: boolean | undefined;
    loadLessInfo: boolean | undefined;
    guid: string;
    showEndDate: boolean;
    endDateString: string | undefined;
    globalControl: number | undefined;
    inSociety: boolean;
    isChecked: boolean;
    isCompleted: boolean;

    constructor(data?: IAssignableNaturalPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.naturalPersonId = _data["naturalPersonId"];
            this.naturalPerson = _data["naturalPerson"] ? NaturalPersonDto.fromJS(_data["naturalPerson"]) : <any>undefined;
            this.juridicalPersonId = _data["juridicalPersonId"];
            this.juridicalPerson = _data["juridicalPerson"] ? CompanyDto.fromJS(_data["juridicalPerson"]) : <any>undefined;
            this.companyRoleId = _data["companyRoleId"];
            this.companyRole = _data["companyRole"] ? CompanyRoleDto.fromJS(_data["companyRole"]) : <any>undefined;
            this.positionId = _data["positionId"];
            this.position = _data["position"] ? PositionDto.fromJS(_data["position"]) : <any>undefined;
            this.shareholding = _data["shareholding"];
            this.nominalValue = _data["nominalValue"];
            this.effectiveDate = _data["effectiveDate"] ? moment(_data["effectiveDate"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.grantDate = _data["grantDate"] ? moment(_data["grantDate"].toString()) : <any>undefined;
            this.revocationDate = _data["revocationDate"] ? moment(_data["revocationDate"].toString()) : <any>undefined;
            this.attorneyInFactTypeId = _data["attorneyInFactTypeId"];
            this.attorneyInFactType = _data["attorneyInFactType"] ? AttorneyInFactTypeDto.fromJS(_data["attorneyInFactType"]) : <any>undefined;
            this.attorneysInFact = _data["attorneysInFact"];
            this.functionalLinkId = _data["functionalLinkId"];
            this.functionalLink = _data["functionalLink"] ? FunctionalLinkDto.fromJS(_data["functionalLink"]) : <any>undefined;
            this.healthInsuranceId = _data["healthInsuranceId"];
            this.healthInsurance = _data["healthInsurance"] ? HealthInsuranceDto.fromJS(_data["healthInsurance"]) : <any>undefined;
            if (Array.isArray(_data["relatedPersonCompanyRoleDatas"])) {
                this.relatedPersonCompanyRoleDatas = [] as any;
                for (let item of _data["relatedPersonCompanyRoleDatas"])
                    this.relatedPersonCompanyRoleDatas.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            this.relatedPersonCompanyRoleDataId = _data["relatedPersonCompanyRoleDataId"];
            this.relatedPersonCompanyRoleDataGuid = _data["relatedPersonCompanyRoleDataGuid"];
            this.relatedPersonCompanyRoleData = _data["relatedPersonCompanyRoleData"] ? PersonCompanyRoleDataDto.fromJS(_data["relatedPersonCompanyRoleData"]) : <any>undefined;
            this.finalBeneficiary = _data["finalBeneficiary"];
            this.loadLessInfo = _data["loadLessInfo"];
            this.guid = _data["guid"];
            this.showEndDate = _data["showEndDate"];
            this.endDateString = _data["endDateString"];
            this.globalControl = _data["globalControl"];
            this.inSociety = _data["inSociety"];
            this.isChecked = _data["isChecked"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): AssignableNaturalPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignableNaturalPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["naturalPersonId"] = this.naturalPersonId;
        data["naturalPerson"] = this.naturalPerson ? this.naturalPerson.toJSON() : <any>undefined;
        data["juridicalPersonId"] = this.juridicalPersonId;
        data["juridicalPerson"] = this.juridicalPerson ? this.juridicalPerson.toJSON() : <any>undefined;
        data["companyRoleId"] = this.companyRoleId;
        data["companyRole"] = this.companyRole ? this.companyRole.toJSON() : <any>undefined;
        data["positionId"] = this.positionId;
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        data["shareholding"] = this.shareholding;
        data["nominalValue"] = this.nominalValue;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["grantDate"] = this.grantDate ? this.grantDate.toISOString() : <any>undefined;
        data["revocationDate"] = this.revocationDate ? this.revocationDate.toISOString() : <any>undefined;
        data["attorneyInFactTypeId"] = this.attorneyInFactTypeId;
        data["attorneyInFactType"] = this.attorneyInFactType ? this.attorneyInFactType.toJSON() : <any>undefined;
        data["attorneysInFact"] = this.attorneysInFact;
        data["functionalLinkId"] = this.functionalLinkId;
        data["functionalLink"] = this.functionalLink ? this.functionalLink.toJSON() : <any>undefined;
        data["healthInsuranceId"] = this.healthInsuranceId;
        data["healthInsurance"] = this.healthInsurance ? this.healthInsurance.toJSON() : <any>undefined;
        if (Array.isArray(this.relatedPersonCompanyRoleDatas)) {
            data["relatedPersonCompanyRoleDatas"] = [];
            for (let item of this.relatedPersonCompanyRoleDatas)
                data["relatedPersonCompanyRoleDatas"].push(item.toJSON());
        }
        data["relatedPersonCompanyRoleDataId"] = this.relatedPersonCompanyRoleDataId;
        data["relatedPersonCompanyRoleDataGuid"] = this.relatedPersonCompanyRoleDataGuid;
        data["relatedPersonCompanyRoleData"] = this.relatedPersonCompanyRoleData ? this.relatedPersonCompanyRoleData.toJSON() : <any>undefined;
        data["finalBeneficiary"] = this.finalBeneficiary;
        data["loadLessInfo"] = this.loadLessInfo;
        data["guid"] = this.guid;
        data["showEndDate"] = this.showEndDate;
        data["endDateString"] = this.endDateString;
        data["globalControl"] = this.globalControl;
        data["inSociety"] = this.inSociety;
        data["isChecked"] = this.isChecked;
        data["isCompleted"] = this.isCompleted;
        return data;
    }

    clone(): AssignableNaturalPersonDto {
        const json = this.toJSON();
        let result = new AssignableNaturalPersonDto();
        result.init(json);
        return result;
    }
}

export interface IAssignableNaturalPersonDto {
    id: number;
    companyId: number;
    naturalPersonId: number | undefined;
    naturalPerson: NaturalPersonDto;
    juridicalPersonId: number | undefined;
    juridicalPerson: CompanyDto;
    companyRoleId: number;
    companyRole: CompanyRoleDto;
    positionId: number | undefined;
    position: PositionDto;
    shareholding: number | undefined;
    nominalValue: number | undefined;
    effectiveDate: moment.Moment | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    grantDate: moment.Moment | undefined;
    revocationDate: moment.Moment | undefined;
    attorneyInFactTypeId: number | undefined;
    attorneyInFactType: AttorneyInFactTypeDto;
    attorneysInFact: boolean | undefined;
    functionalLinkId: number | undefined;
    functionalLink: FunctionalLinkDto;
    healthInsuranceId: number | undefined;
    healthInsurance: HealthInsuranceDto;
    relatedPersonCompanyRoleDatas: PersonCompanyRoleDataDto[] | undefined;
    relatedPersonCompanyRoleDataId: number | undefined;
    relatedPersonCompanyRoleDataGuid: string | undefined;
    relatedPersonCompanyRoleData: PersonCompanyRoleDataDto;
    finalBeneficiary: boolean | undefined;
    loadLessInfo: boolean | undefined;
    guid: string;
    showEndDate: boolean;
    endDateString: string | undefined;
    globalControl: number | undefined;
    inSociety: boolean;
    isChecked: boolean;
    isCompleted: boolean;
}

export class AssignableNaturalPersonDtoPagedResultDto implements IAssignableNaturalPersonDtoPagedResultDto {
    items: AssignableNaturalPersonDto[] | undefined;
    totalCount: number;

    constructor(data?: IAssignableNaturalPersonDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AssignableNaturalPersonDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AssignableNaturalPersonDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignableNaturalPersonDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AssignableNaturalPersonDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AssignableNaturalPersonDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAssignableNaturalPersonDtoPagedResultDto {
    items: AssignableNaturalPersonDto[] | undefined;
    totalCount: number;
}

export class AttorneyInFactType implements IAttorneyInFactType {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;

    constructor(data?: IAttorneyInFactType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
        }
    }

    static fromJS(data: any): AttorneyInFactType {
        data = typeof data === 'object' ? data : {};
        let result = new AttorneyInFactType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        return data;
    }

    clone(): AttorneyInFactType {
        const json = this.toJSON();
        let result = new AttorneyInFactType();
        result.init(json);
        return result;
    }
}

export interface IAttorneyInFactType {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
}

export class AttorneyInFactTypeDto implements IAttorneyInFactTypeDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;

    constructor(data?: IAttorneyInFactTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
        }
    }

    static fromJS(data: any): AttorneyInFactTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttorneyInFactTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        return data;
    }

    clone(): AttorneyInFactTypeDto {
        const json = this.toJSON();
        let result = new AttorneyInFactTypeDto();
        result.init(json);
        return result;
    }
}

export interface IAttorneyInFactTypeDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
}

export class AttorneyInFactTypeDtoPagedResultDto implements IAttorneyInFactTypeDtoPagedResultDto {
    items: AttorneyInFactTypeDto[] | undefined;
    totalCount: number;

    constructor(data?: IAttorneyInFactTypeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AttorneyInFactTypeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AttorneyInFactTypeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttorneyInFactTypeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AttorneyInFactTypeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AttorneyInFactTypeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAttorneyInFactTypeDtoPagedResultDto {
    items: AttorneyInFactTypeDto[] | undefined;
    totalCount: number;
}

export class AuditLogDto implements IAuditLogDto {
    id: number;
    executionTime: moment.Moment;
    impersonatorUserId: number | undefined;
    exception: string | undefined;
    browserInfo: string | undefined;
    clientName: string | undefined;
    clientIpAddress: string | undefined;
    executionDuration: number;
    returnValue: string | undefined;
    tenantId: number | undefined;
    methodName: string | undefined;
    serviceName: string | undefined;
    user: UserDto;
    userId: number | undefined;
    impersonatorTenantId: number | undefined;
    parameters: string | undefined;
    customData: string | undefined;

    constructor(data?: IAuditLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.executionTime = _data["executionTime"] ? moment(_data["executionTime"].toString()) : <any>undefined;
            this.impersonatorUserId = _data["impersonatorUserId"];
            this.exception = _data["exception"];
            this.browserInfo = _data["browserInfo"];
            this.clientName = _data["clientName"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.executionDuration = _data["executionDuration"];
            this.returnValue = _data["returnValue"];
            this.tenantId = _data["tenantId"];
            this.methodName = _data["methodName"];
            this.serviceName = _data["serviceName"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.userId = _data["userId"];
            this.impersonatorTenantId = _data["impersonatorTenantId"];
            this.parameters = _data["parameters"];
            this.customData = _data["customData"];
        }
    }

    static fromJS(data: any): AuditLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["executionTime"] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["exception"] = this.exception;
        data["browserInfo"] = this.browserInfo;
        data["clientName"] = this.clientName;
        data["clientIpAddress"] = this.clientIpAddress;
        data["executionDuration"] = this.executionDuration;
        data["returnValue"] = this.returnValue;
        data["tenantId"] = this.tenantId;
        data["methodName"] = this.methodName;
        data["serviceName"] = this.serviceName;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["parameters"] = this.parameters;
        data["customData"] = this.customData;
        return data;
    }

    clone(): AuditLogDto {
        const json = this.toJSON();
        let result = new AuditLogDto();
        result.init(json);
        return result;
    }
}

export interface IAuditLogDto {
    id: number;
    executionTime: moment.Moment;
    impersonatorUserId: number | undefined;
    exception: string | undefined;
    browserInfo: string | undefined;
    clientName: string | undefined;
    clientIpAddress: string | undefined;
    executionDuration: number;
    returnValue: string | undefined;
    tenantId: number | undefined;
    methodName: string | undefined;
    serviceName: string | undefined;
    user: UserDto;
    userId: number | undefined;
    impersonatorTenantId: number | undefined;
    parameters: string | undefined;
    customData: string | undefined;
}

export class AuditLogDtoPagedResultDto implements IAuditLogDtoPagedResultDto {
    items: AuditLogDto[] | undefined;
    totalCount: number;

    constructor(data?: IAuditLogDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AuditLogDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AuditLogDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AuditLogDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AuditLogDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAuditLogDtoPagedResultDto {
    items: AuditLogDto[] | undefined;
    totalCount: number;
}

export class AuthenticateModel implements IAuthenticateModel {
    emailAddress: string;
    password: string;
    tenantName: string | undefined;
    rememberClient: boolean;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.tenantName = _data["tenantName"];
            this.rememberClient = _data["rememberClient"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["tenantName"] = this.tenantName;
        data["rememberClient"] = this.rememberClient;
        return data;
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    emailAddress: string;
    password: string;
    tenantName: string | undefined;
    rememberClient: boolean;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
    tenants: TenantDto[] | undefined;
    relatedCompanyIds: number[] | undefined;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants.push(TenantDto.fromJS(item));
            }
            if (Array.isArray(_data["relatedCompanyIds"])) {
                this.relatedCompanyIds = [] as any;
                for (let item of _data["relatedCompanyIds"])
                    this.relatedCompanyIds.push(item);
            }
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item.toJSON());
        }
        if (Array.isArray(this.relatedCompanyIds)) {
            data["relatedCompanyIds"] = [];
            for (let item of this.relatedCompanyIds)
                data["relatedCompanyIds"].push(item);
        }
        return data;
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
    tenants: TenantDto[] | undefined;
    relatedCompanyIds: number[] | undefined;
}

export class BaseMessageNotificationDataDto implements IBaseMessageNotificationDataDto {
    notificationType: NotificationTypeEnum;
    notificationName: string | undefined;
    status: string | undefined;
    notificationId: string;
    fullName: string | undefined;
    notificationSent: moment.Moment;
    subject: string | undefined;
    templateName: string | undefined;
    language: string | undefined;
    useLayout: boolean;
    recipientEmail: string | undefined;
    message: string | undefined;
    type: string | undefined;
    notificationState: UserNotificationState;
    userName: string | undefined;
    tenancyName: string | undefined;
    notificationPhoto: string | undefined;
    fileName: string | undefined;

    constructor(data?: IBaseMessageNotificationDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationType = _data["notificationType"];
            this.notificationName = _data["notificationName"];
            this.status = _data["status"];
            this.notificationId = _data["notificationId"];
            this.fullName = _data["fullName"];
            this.notificationSent = _data["notificationSent"] ? moment(_data["notificationSent"].toString()) : <any>undefined;
            this.subject = _data["subject"];
            this.templateName = _data["templateName"];
            this.language = _data["language"];
            this.useLayout = _data["useLayout"];
            this.recipientEmail = _data["recipientEmail"];
            this.message = _data["message"];
            this.type = _data["type"];
            this.notificationState = _data["notificationState"];
            this.userName = _data["userName"];
            this.tenancyName = _data["tenancyName"];
            this.notificationPhoto = _data["notificationPhoto"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): BaseMessageNotificationDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseMessageNotificationDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationType"] = this.notificationType;
        data["notificationName"] = this.notificationName;
        data["status"] = this.status;
        data["notificationId"] = this.notificationId;
        data["fullName"] = this.fullName;
        data["notificationSent"] = this.notificationSent ? this.notificationSent.toISOString() : <any>undefined;
        data["subject"] = this.subject;
        data["templateName"] = this.templateName;
        data["language"] = this.language;
        data["useLayout"] = this.useLayout;
        data["recipientEmail"] = this.recipientEmail;
        data["message"] = this.message;
        data["type"] = this.type;
        data["notificationState"] = this.notificationState;
        data["userName"] = this.userName;
        data["tenancyName"] = this.tenancyName;
        data["notificationPhoto"] = this.notificationPhoto;
        data["fileName"] = this.fileName;
        return data;
    }

    clone(): BaseMessageNotificationDataDto {
        const json = this.toJSON();
        let result = new BaseMessageNotificationDataDto();
        result.init(json);
        return result;
    }
}

export interface IBaseMessageNotificationDataDto {
    notificationType: NotificationTypeEnum;
    notificationName: string | undefined;
    status: string | undefined;
    notificationId: string;
    fullName: string | undefined;
    notificationSent: moment.Moment;
    subject: string | undefined;
    templateName: string | undefined;
    language: string | undefined;
    useLayout: boolean;
    recipientEmail: string | undefined;
    message: string | undefined;
    type: string | undefined;
    notificationState: UserNotificationState;
    userName: string | undefined;
    tenancyName: string | undefined;
    notificationPhoto: string | undefined;
    fileName: string | undefined;
}

export class BaseMessageNotificationDataDtoPagedResultDto implements IBaseMessageNotificationDataDtoPagedResultDto {
    items: BaseMessageNotificationDataDto[] | undefined;
    totalCount: number;

    constructor(data?: IBaseMessageNotificationDataDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(BaseMessageNotificationDataDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): BaseMessageNotificationDataDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseMessageNotificationDataDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): BaseMessageNotificationDataDtoPagedResultDto {
        const json = this.toJSON();
        let result = new BaseMessageNotificationDataDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IBaseMessageNotificationDataDtoPagedResultDto {
    items: BaseMessageNotificationDataDto[] | undefined;
    totalCount: number;
}

export class CategoryDto implements ICategoryDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    subcategories: CategoryDto[] | undefined;
    parentCategoryId: number | undefined;
    parentCategoryName: string | undefined;

    constructor(data?: ICategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            if (Array.isArray(_data["subcategories"])) {
                this.subcategories = [] as any;
                for (let item of _data["subcategories"])
                    this.subcategories.push(CategoryDto.fromJS(item));
            }
            this.parentCategoryId = _data["parentCategoryId"];
            this.parentCategoryName = _data["parentCategoryName"];
        }
    }

    static fromJS(data: any): CategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        if (Array.isArray(this.subcategories)) {
            data["subcategories"] = [];
            for (let item of this.subcategories)
                data["subcategories"].push(item.toJSON());
        }
        data["parentCategoryId"] = this.parentCategoryId;
        data["parentCategoryName"] = this.parentCategoryName;
        return data;
    }

    clone(): CategoryDto {
        const json = this.toJSON();
        let result = new CategoryDto();
        result.init(json);
        return result;
    }
}

export interface ICategoryDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    subcategories: CategoryDto[] | undefined;
    parentCategoryId: number | undefined;
    parentCategoryName: string | undefined;
}

export class CategoryDtoPagedResultDto implements ICategoryDtoPagedResultDto {
    items: CategoryDto[] | undefined;
    totalCount: number;

    constructor(data?: ICategoryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CategoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CategoryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CategoryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CategoryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICategoryDtoPagedResultDto {
    items: CategoryDto[] | undefined;
    totalCount: number;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword: string;
    newPassword: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme: UiThemeEnum;
    customPrimaryColor: string | undefined;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
            this.customPrimaryColor = _data["customPrimaryColor"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        data["customPrimaryColor"] = this.customPrimaryColor;
        return data;
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: UiThemeEnum;
    customPrimaryColor: string | undefined;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class Company implements ICompany {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    tenant: Tenant;
    managedCompany: boolean;
    name: string | undefined;
    tradeName: string | undefined;
    companyTypeId: number;
    companyType: CompanyType;
    incorporationDate: moment.Moment | undefined;
    countryId: number | undefined;
    country: Country;
    taxID: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    shareTypeId: number | undefined;
    shareType: ShareType;
    headquarterId: number | undefined;
    headquarter: Address;
    fiscalAddressId: number | undefined;
    fiscalAddress: Address;
    isFiscalSameAsHeadquarters: boolean;
    establishedAddressId: number | undefined;
    establishedAddress: Address;
    isEstablishedSameAsHeadquarters: boolean;
    isEstablishedSameAsFiscal: boolean;
    currencyId: number | undefined;
    currency: Currency;
    socialAmount: number;
    integratedAmount: number;
    balanceMonth: number | undefined;
    businessPurpose: string | undefined;
    representation: string | undefined;
    companyWorkActivities: CompanyWorkActivity[] | undefined;
    personCompanyRoleData: PersonCompanyRoleData[] | undefined;

    constructor(data?: ICompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.managedCompany = _data["managedCompany"];
            this.name = _data["name"];
            this.tradeName = _data["tradeName"];
            this.companyTypeId = _data["companyTypeId"];
            this.companyType = _data["companyType"] ? CompanyType.fromJS(_data["companyType"]) : <any>undefined;
            this.incorporationDate = _data["incorporationDate"] ? moment(_data["incorporationDate"].toString()) : <any>undefined;
            this.countryId = _data["countryId"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
            this.taxID = _data["taxID"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.shareTypeId = _data["shareTypeId"];
            this.shareType = _data["shareType"] ? ShareType.fromJS(_data["shareType"]) : <any>undefined;
            this.headquarterId = _data["headquarterId"];
            this.headquarter = _data["headquarter"] ? Address.fromJS(_data["headquarter"]) : <any>undefined;
            this.fiscalAddressId = _data["fiscalAddressId"];
            this.fiscalAddress = _data["fiscalAddress"] ? Address.fromJS(_data["fiscalAddress"]) : <any>undefined;
            this.isFiscalSameAsHeadquarters = _data["isFiscalSameAsHeadquarters"];
            this.establishedAddressId = _data["establishedAddressId"];
            this.establishedAddress = _data["establishedAddress"] ? Address.fromJS(_data["establishedAddress"]) : <any>undefined;
            this.isEstablishedSameAsHeadquarters = _data["isEstablishedSameAsHeadquarters"];
            this.isEstablishedSameAsFiscal = _data["isEstablishedSameAsFiscal"];
            this.currencyId = _data["currencyId"];
            this.currency = _data["currency"] ? Currency.fromJS(_data["currency"]) : <any>undefined;
            this.socialAmount = _data["socialAmount"];
            this.integratedAmount = _data["integratedAmount"];
            this.balanceMonth = _data["balanceMonth"];
            this.businessPurpose = _data["businessPurpose"];
            this.representation = _data["representation"];
            if (Array.isArray(_data["companyWorkActivities"])) {
                this.companyWorkActivities = [] as any;
                for (let item of _data["companyWorkActivities"])
                    this.companyWorkActivities.push(CompanyWorkActivity.fromJS(item));
            }
            if (Array.isArray(_data["personCompanyRoleData"])) {
                this.personCompanyRoleData = [] as any;
                for (let item of _data["personCompanyRoleData"])
                    this.personCompanyRoleData.push(PersonCompanyRoleData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Company {
        data = typeof data === 'object' ? data : {};
        let result = new Company();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["managedCompany"] = this.managedCompany;
        data["name"] = this.name;
        data["tradeName"] = this.tradeName;
        data["companyTypeId"] = this.companyTypeId;
        data["companyType"] = this.companyType ? this.companyType.toJSON() : <any>undefined;
        data["incorporationDate"] = this.incorporationDate ? this.incorporationDate.toISOString() : <any>undefined;
        data["countryId"] = this.countryId;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["taxID"] = this.taxID;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["shareTypeId"] = this.shareTypeId;
        data["shareType"] = this.shareType ? this.shareType.toJSON() : <any>undefined;
        data["headquarterId"] = this.headquarterId;
        data["headquarter"] = this.headquarter ? this.headquarter.toJSON() : <any>undefined;
        data["fiscalAddressId"] = this.fiscalAddressId;
        data["fiscalAddress"] = this.fiscalAddress ? this.fiscalAddress.toJSON() : <any>undefined;
        data["isFiscalSameAsHeadquarters"] = this.isFiscalSameAsHeadquarters;
        data["establishedAddressId"] = this.establishedAddressId;
        data["establishedAddress"] = this.establishedAddress ? this.establishedAddress.toJSON() : <any>undefined;
        data["isEstablishedSameAsHeadquarters"] = this.isEstablishedSameAsHeadquarters;
        data["isEstablishedSameAsFiscal"] = this.isEstablishedSameAsFiscal;
        data["currencyId"] = this.currencyId;
        data["currency"] = this.currency ? this.currency.toJSON() : <any>undefined;
        data["socialAmount"] = this.socialAmount;
        data["integratedAmount"] = this.integratedAmount;
        data["balanceMonth"] = this.balanceMonth;
        data["businessPurpose"] = this.businessPurpose;
        data["representation"] = this.representation;
        if (Array.isArray(this.companyWorkActivities)) {
            data["companyWorkActivities"] = [];
            for (let item of this.companyWorkActivities)
                data["companyWorkActivities"].push(item.toJSON());
        }
        if (Array.isArray(this.personCompanyRoleData)) {
            data["personCompanyRoleData"] = [];
            for (let item of this.personCompanyRoleData)
                data["personCompanyRoleData"].push(item.toJSON());
        }
        return data;
    }

    clone(): Company {
        const json = this.toJSON();
        let result = new Company();
        result.init(json);
        return result;
    }
}

export interface ICompany {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    tenant: Tenant;
    managedCompany: boolean;
    name: string | undefined;
    tradeName: string | undefined;
    companyTypeId: number;
    companyType: CompanyType;
    incorporationDate: moment.Moment | undefined;
    countryId: number | undefined;
    country: Country;
    taxID: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    shareTypeId: number | undefined;
    shareType: ShareType;
    headquarterId: number | undefined;
    headquarter: Address;
    fiscalAddressId: number | undefined;
    fiscalAddress: Address;
    isFiscalSameAsHeadquarters: boolean;
    establishedAddressId: number | undefined;
    establishedAddress: Address;
    isEstablishedSameAsHeadquarters: boolean;
    isEstablishedSameAsFiscal: boolean;
    currencyId: number | undefined;
    currency: Currency;
    socialAmount: number;
    integratedAmount: number;
    balanceMonth: number | undefined;
    businessPurpose: string | undefined;
    representation: string | undefined;
    companyWorkActivities: CompanyWorkActivity[] | undefined;
    personCompanyRoleData: PersonCompanyRoleData[] | undefined;
}

export class CompanyDto implements ICompanyDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    managedCompany: boolean;
    name: string;
    tradeName: string | undefined;
    companyTypeId: number;
    companyTypeName: string | undefined;
    companyTypeCode: string | undefined;
    incorporationDate: moment.Moment;
    countryId: number | undefined;
    countryName: string | undefined;
    countryISOAlpha2Code: string | undefined;
    taxID: string;
    phoneNumber: string | undefined;
    email: string | undefined;
    shareTypeId: number | undefined;
    shareType: ShareTypeDto;
    headquarterId: number | undefined;
    headquarter: AddressDto;
    fiscalAddressId: number | undefined;
    fiscalAddress: AddressDto;
    isFiscalSameAsHeadquarters: boolean;
    establishedAddressId: number | undefined;
    establishedAddress: AddressDto;
    isEstablishedSameAsHeadquarters: boolean;
    isEstablishedSameAsFiscal: boolean;
    currencyId: number | undefined;
    currencySymbol: string | undefined;
    socialAmount: number;
    integratedAmount: number;
    balanceMonth: number | undefined;
    businessPurpose: string | undefined;
    representation: string | undefined;
    companyWorkActivities: CompanyWorkActivityDto[] | undefined;
    personCompanyRoleData: PersonCompanyRoleDataDto[] | undefined;
    isVerified: boolean;
    hasRelations: boolean;
    juridicalPersonCopy: CompanyDto;
    selectedUsers: SelectableUserDto[] | undefined;

    constructor(data?: ICompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.managedCompany = _data["managedCompany"];
            this.name = _data["name"];
            this.tradeName = _data["tradeName"];
            this.companyTypeId = _data["companyTypeId"];
            this.companyTypeName = _data["companyTypeName"];
            this.companyTypeCode = _data["companyTypeCode"];
            this.incorporationDate = _data["incorporationDate"] ? moment(_data["incorporationDate"].toString()) : <any>undefined;
            this.countryId = _data["countryId"];
            this.countryName = _data["countryName"];
            this.countryISOAlpha2Code = _data["countryISOAlpha2Code"];
            this.taxID = _data["taxID"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.shareTypeId = _data["shareTypeId"];
            this.shareType = _data["shareType"] ? ShareTypeDto.fromJS(_data["shareType"]) : <any>undefined;
            this.headquarterId = _data["headquarterId"];
            this.headquarter = _data["headquarter"] ? AddressDto.fromJS(_data["headquarter"]) : <any>undefined;
            this.fiscalAddressId = _data["fiscalAddressId"];
            this.fiscalAddress = _data["fiscalAddress"] ? AddressDto.fromJS(_data["fiscalAddress"]) : <any>undefined;
            this.isFiscalSameAsHeadquarters = _data["isFiscalSameAsHeadquarters"];
            this.establishedAddressId = _data["establishedAddressId"];
            this.establishedAddress = _data["establishedAddress"] ? AddressDto.fromJS(_data["establishedAddress"]) : <any>undefined;
            this.isEstablishedSameAsHeadquarters = _data["isEstablishedSameAsHeadquarters"];
            this.isEstablishedSameAsFiscal = _data["isEstablishedSameAsFiscal"];
            this.currencyId = _data["currencyId"];
            this.currencySymbol = _data["currencySymbol"];
            this.socialAmount = _data["socialAmount"];
            this.integratedAmount = _data["integratedAmount"];
            this.balanceMonth = _data["balanceMonth"];
            this.businessPurpose = _data["businessPurpose"];
            this.representation = _data["representation"];
            if (Array.isArray(_data["companyWorkActivities"])) {
                this.companyWorkActivities = [] as any;
                for (let item of _data["companyWorkActivities"])
                    this.companyWorkActivities.push(CompanyWorkActivityDto.fromJS(item));
            }
            if (Array.isArray(_data["personCompanyRoleData"])) {
                this.personCompanyRoleData = [] as any;
                for (let item of _data["personCompanyRoleData"])
                    this.personCompanyRoleData.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            this.isVerified = _data["isVerified"];
            this.hasRelations = _data["hasRelations"];
            this.juridicalPersonCopy = _data["juridicalPersonCopy"] ? CompanyDto.fromJS(_data["juridicalPersonCopy"]) : <any>undefined;
            if (Array.isArray(_data["selectedUsers"])) {
                this.selectedUsers = [] as any;
                for (let item of _data["selectedUsers"])
                    this.selectedUsers.push(SelectableUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["managedCompany"] = this.managedCompany;
        data["name"] = this.name;
        data["tradeName"] = this.tradeName;
        data["companyTypeId"] = this.companyTypeId;
        data["companyTypeName"] = this.companyTypeName;
        data["companyTypeCode"] = this.companyTypeCode;
        data["incorporationDate"] = this.incorporationDate ? this.incorporationDate.toISOString() : <any>undefined;
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        data["countryISOAlpha2Code"] = this.countryISOAlpha2Code;
        data["taxID"] = this.taxID;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["shareTypeId"] = this.shareTypeId;
        data["shareType"] = this.shareType ? this.shareType.toJSON() : <any>undefined;
        data["headquarterId"] = this.headquarterId;
        data["headquarter"] = this.headquarter ? this.headquarter.toJSON() : <any>undefined;
        data["fiscalAddressId"] = this.fiscalAddressId;
        data["fiscalAddress"] = this.fiscalAddress ? this.fiscalAddress.toJSON() : <any>undefined;
        data["isFiscalSameAsHeadquarters"] = this.isFiscalSameAsHeadquarters;
        data["establishedAddressId"] = this.establishedAddressId;
        data["establishedAddress"] = this.establishedAddress ? this.establishedAddress.toJSON() : <any>undefined;
        data["isEstablishedSameAsHeadquarters"] = this.isEstablishedSameAsHeadquarters;
        data["isEstablishedSameAsFiscal"] = this.isEstablishedSameAsFiscal;
        data["currencyId"] = this.currencyId;
        data["currencySymbol"] = this.currencySymbol;
        data["socialAmount"] = this.socialAmount;
        data["integratedAmount"] = this.integratedAmount;
        data["balanceMonth"] = this.balanceMonth;
        data["businessPurpose"] = this.businessPurpose;
        data["representation"] = this.representation;
        if (Array.isArray(this.companyWorkActivities)) {
            data["companyWorkActivities"] = [];
            for (let item of this.companyWorkActivities)
                data["companyWorkActivities"].push(item.toJSON());
        }
        if (Array.isArray(this.personCompanyRoleData)) {
            data["personCompanyRoleData"] = [];
            for (let item of this.personCompanyRoleData)
                data["personCompanyRoleData"].push(item.toJSON());
        }
        data["isVerified"] = this.isVerified;
        data["hasRelations"] = this.hasRelations;
        data["juridicalPersonCopy"] = this.juridicalPersonCopy ? this.juridicalPersonCopy.toJSON() : <any>undefined;
        if (Array.isArray(this.selectedUsers)) {
            data["selectedUsers"] = [];
            for (let item of this.selectedUsers)
                data["selectedUsers"].push(item.toJSON());
        }
        return data;
    }

    clone(): CompanyDto {
        const json = this.toJSON();
        let result = new CompanyDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    managedCompany: boolean;
    name: string;
    tradeName: string | undefined;
    companyTypeId: number;
    companyTypeName: string | undefined;
    companyTypeCode: string | undefined;
    incorporationDate: moment.Moment;
    countryId: number | undefined;
    countryName: string | undefined;
    countryISOAlpha2Code: string | undefined;
    taxID: string;
    phoneNumber: string | undefined;
    email: string | undefined;
    shareTypeId: number | undefined;
    shareType: ShareTypeDto;
    headquarterId: number | undefined;
    headquarter: AddressDto;
    fiscalAddressId: number | undefined;
    fiscalAddress: AddressDto;
    isFiscalSameAsHeadquarters: boolean;
    establishedAddressId: number | undefined;
    establishedAddress: AddressDto;
    isEstablishedSameAsHeadquarters: boolean;
    isEstablishedSameAsFiscal: boolean;
    currencyId: number | undefined;
    currencySymbol: string | undefined;
    socialAmount: number;
    integratedAmount: number;
    balanceMonth: number | undefined;
    businessPurpose: string | undefined;
    representation: string | undefined;
    companyWorkActivities: CompanyWorkActivityDto[] | undefined;
    personCompanyRoleData: PersonCompanyRoleDataDto[] | undefined;
    isVerified: boolean;
    hasRelations: boolean;
    juridicalPersonCopy: CompanyDto;
    selectedUsers: SelectableUserDto[] | undefined;
}

export class CompanyDtoPagedResultDto implements ICompanyDtoPagedResultDto {
    items: CompanyDto[] | undefined;
    totalCount: number;

    constructor(data?: ICompanyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CompanyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CompanyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CompanyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CompanyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyDtoPagedResultDto {
    items: CompanyDto[] | undefined;
    totalCount: number;
}

export class CompanyRole implements ICompanyRole {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
    code: string | undefined;

    constructor(data?: ICompanyRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CompanyRole {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        data["code"] = this.code;
        return data;
    }

    clone(): CompanyRole {
        const json = this.toJSON();
        let result = new CompanyRole();
        result.init(json);
        return result;
    }
}

export interface ICompanyRole {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
    code: string | undefined;
}

export class CompanyRoleDto implements ICompanyRoleDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
    code: string | undefined;

    constructor(data?: ICompanyRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CompanyRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        data["code"] = this.code;
        return data;
    }

    clone(): CompanyRoleDto {
        const json = this.toJSON();
        let result = new CompanyRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyRoleDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
    code: string | undefined;
}

export class CompanyRoleDtoPagedResultDto implements ICompanyRoleDtoPagedResultDto {
    items: CompanyRoleDto[] | undefined;
    totalCount: number;

    constructor(data?: ICompanyRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CompanyRoleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CompanyRoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyRoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CompanyRoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CompanyRoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyRoleDtoPagedResultDto {
    items: CompanyRoleDto[] | undefined;
    totalCount: number;
}

export class CompanyType implements ICompanyType {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
    code: string | undefined;
    countryId: number;
    country: Country;

    constructor(data?: ICompanyType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
            this.code = _data["code"];
            this.countryId = _data["countryId"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompanyType {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        data["code"] = this.code;
        data["countryId"] = this.countryId;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        return data;
    }

    clone(): CompanyType {
        const json = this.toJSON();
        let result = new CompanyType();
        result.init(json);
        return result;
    }
}

export interface ICompanyType {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
    code: string | undefined;
    countryId: number;
    country: Country;
}

export class CompanyTypeDto implements ICompanyTypeDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
    code: string;
    countryId: number;
    country: CountryDto;

    constructor(data?: ICompanyTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
            this.code = _data["code"];
            this.countryId = _data["countryId"];
            this.country = _data["country"] ? CountryDto.fromJS(_data["country"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompanyTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        data["code"] = this.code;
        data["countryId"] = this.countryId;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        return data;
    }

    clone(): CompanyTypeDto {
        const json = this.toJSON();
        let result = new CompanyTypeDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyTypeDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
    code: string;
    countryId: number;
    country: CountryDto;
}

export class CompanyTypeDtoPagedResultDto implements ICompanyTypeDtoPagedResultDto {
    items: CompanyTypeDto[] | undefined;
    totalCount: number;

    constructor(data?: ICompanyTypeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CompanyTypeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CompanyTypeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyTypeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CompanyTypeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CompanyTypeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyTypeDtoPagedResultDto {
    items: CompanyTypeDto[] | undefined;
    totalCount: number;
}

export class CompanyWorkActivity implements ICompanyWorkActivity {
    id: number;
    companyId: number;
    company: Company;
    workActivityId: number | undefined;
    workActivity: WorkActivity;
    customActivityName: string | undefined;

    constructor(data?: ICompanyWorkActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.workActivityId = _data["workActivityId"];
            this.workActivity = _data["workActivity"] ? WorkActivity.fromJS(_data["workActivity"]) : <any>undefined;
            this.customActivityName = _data["customActivityName"];
        }
    }

    static fromJS(data: any): CompanyWorkActivity {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyWorkActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["workActivityId"] = this.workActivityId;
        data["workActivity"] = this.workActivity ? this.workActivity.toJSON() : <any>undefined;
        data["customActivityName"] = this.customActivityName;
        return data;
    }

    clone(): CompanyWorkActivity {
        const json = this.toJSON();
        let result = new CompanyWorkActivity();
        result.init(json);
        return result;
    }
}

export interface ICompanyWorkActivity {
    id: number;
    companyId: number;
    company: Company;
    workActivityId: number | undefined;
    workActivity: WorkActivity;
    customActivityName: string | undefined;
}

export class CompanyWorkActivityDto implements ICompanyWorkActivityDto {
    id: number;
    companyId: number;
    workActivityId: number | undefined;
    workActivity: WorkActivityDto;
    customActivityName: string | undefined;

    constructor(data?: ICompanyWorkActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.workActivityId = _data["workActivityId"];
            this.workActivity = _data["workActivity"] ? WorkActivityDto.fromJS(_data["workActivity"]) : <any>undefined;
            this.customActivityName = _data["customActivityName"];
        }
    }

    static fromJS(data: any): CompanyWorkActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyWorkActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["workActivityId"] = this.workActivityId;
        data["workActivity"] = this.workActivity ? this.workActivity.toJSON() : <any>undefined;
        data["customActivityName"] = this.customActivityName;
        return data;
    }

    clone(): CompanyWorkActivityDto {
        const json = this.toJSON();
        let result = new CompanyWorkActivityDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyWorkActivityDto {
    id: number;
    companyId: number;
    workActivityId: number | undefined;
    workActivity: WorkActivityDto;
    customActivityName: string | undefined;
}

export class Contact implements IContact {
    id: number;
    mainPhoneNumber: string | undefined;
    alternatePhoneNumber: string | undefined;
    emailAddress: string | undefined;
    contactPreferences: ContactPreferencesEnum;

    constructor(data?: IContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mainPhoneNumber = _data["mainPhoneNumber"];
            this.alternatePhoneNumber = _data["alternatePhoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.contactPreferences = _data["contactPreferences"];
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mainPhoneNumber"] = this.mainPhoneNumber;
        data["alternatePhoneNumber"] = this.alternatePhoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["contactPreferences"] = this.contactPreferences;
        return data;
    }

    clone(): Contact {
        const json = this.toJSON();
        let result = new Contact();
        result.init(json);
        return result;
    }
}

export interface IContact {
    id: number;
    mainPhoneNumber: string | undefined;
    alternatePhoneNumber: string | undefined;
    emailAddress: string | undefined;
    contactPreferences: ContactPreferencesEnum;
}

export class ContactDto implements IContactDto {
    id: number;
    mainPhoneNumber: string | undefined;
    alternatePhoneNumber: string | undefined;
    emailAddress: string | undefined;
    contactPreferences: ContactPreferencesEnum;

    constructor(data?: IContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mainPhoneNumber = _data["mainPhoneNumber"];
            this.alternatePhoneNumber = _data["alternatePhoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.contactPreferences = _data["contactPreferences"];
        }
    }

    static fromJS(data: any): ContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mainPhoneNumber"] = this.mainPhoneNumber;
        data["alternatePhoneNumber"] = this.alternatePhoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["contactPreferences"] = this.contactPreferences;
        return data;
    }

    clone(): ContactDto {
        const json = this.toJSON();
        let result = new ContactDto();
        result.init(json);
        return result;
    }
}

export interface IContactDto {
    id: number;
    mainPhoneNumber: string | undefined;
    alternatePhoneNumber: string | undefined;
    emailAddress: string | undefined;
    contactPreferences: ContactPreferencesEnum;
}

export enum ContactPreferencesEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class Country implements ICountry {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
    isoAlpha2Code: string | undefined;
    isoAlpha3Code: string | undefined;
    isounCode: string | undefined;

    constructor(data?: ICountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
            this.isoAlpha2Code = _data["isoAlpha2Code"];
            this.isoAlpha3Code = _data["isoAlpha3Code"];
            this.isounCode = _data["isounCode"];
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        data["isoAlpha2Code"] = this.isoAlpha2Code;
        data["isoAlpha3Code"] = this.isoAlpha3Code;
        data["isounCode"] = this.isounCode;
        return data;
    }

    clone(): Country {
        const json = this.toJSON();
        let result = new Country();
        result.init(json);
        return result;
    }
}

export interface ICountry {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
    isoAlpha2Code: string | undefined;
    isoAlpha3Code: string | undefined;
    isounCode: string | undefined;
}

export class CountryDto implements ICountryDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
    isoAlpha2Code: string;
    isoAlpha3Code: string;
    isounCode: string;

    constructor(data?: ICountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
            this.isoAlpha2Code = _data["isoAlpha2Code"];
            this.isoAlpha3Code = _data["isoAlpha3Code"];
            this.isounCode = _data["isounCode"];
        }
    }

    static fromJS(data: any): CountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        data["isoAlpha2Code"] = this.isoAlpha2Code;
        data["isoAlpha3Code"] = this.isoAlpha3Code;
        data["isounCode"] = this.isounCode;
        return data;
    }

    clone(): CountryDto {
        const json = this.toJSON();
        let result = new CountryDto();
        result.init(json);
        return result;
    }
}

export interface ICountryDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
    isoAlpha2Code: string;
    isoAlpha3Code: string;
    isounCode: string;
}

export class CountryDtoPagedResultDto implements ICountryDtoPagedResultDto {
    items: CountryDto[] | undefined;
    totalCount: number;

    constructor(data?: ICountryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CountryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CountryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CountryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CountryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICountryDtoPagedResultDto {
    items: CountryDto[] | undefined;
    totalCount: number;
}

export class CreateLibraryItemOutDto implements ICreateLibraryItemOutDto {
    id: number;
    libraryFileOwnerId: number | undefined;
    libraryConfigurationId: number | undefined;
    libraryConfigurationKindId: number | undefined;
    libraryConfigurationRoleId: number | undefined;
    parentId: number | undefined;
    libraryFileTypeId: number;
    isVisble: boolean;
    isChecked: boolean;
    isShared: boolean;
    name: string | undefined;
    mime: string | undefined;
    fullNameExtension: string | undefined;
    files: string[] | undefined;
    companyId: number | undefined;
    childs: LibraryFileDto[] | undefined;
    guid: string;
    isPersonalFolder: boolean;
    isUploaderSpace: boolean;
    isJP: boolean;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    size: number;
    userId: number | undefined;
    user: UserDto;

    constructor(data?: ICreateLibraryItemOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libraryFileOwnerId = _data["libraryFileOwnerId"];
            this.libraryConfigurationId = _data["libraryConfigurationId"];
            this.libraryConfigurationKindId = _data["libraryConfigurationKindId"];
            this.libraryConfigurationRoleId = _data["libraryConfigurationRoleId"];
            this.parentId = _data["parentId"];
            this.libraryFileTypeId = _data["libraryFileTypeId"];
            this.isVisble = _data["isVisble"];
            this.isChecked = _data["isChecked"];
            this.isShared = _data["isShared"];
            this.name = _data["name"];
            this.mime = _data["mime"];
            this.fullNameExtension = _data["fullNameExtension"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files.push(item);
            }
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["childs"])) {
                this.childs = [] as any;
                for (let item of _data["childs"])
                    this.childs.push(LibraryFileDto.fromJS(item));
            }
            this.guid = _data["guid"];
            this.isPersonalFolder = _data["isPersonalFolder"];
            this.isUploaderSpace = _data["isUploaderSpace"];
            this.isJP = _data["isJP"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.size = _data["size"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateLibraryItemOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLibraryItemOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libraryFileOwnerId"] = this.libraryFileOwnerId;
        data["libraryConfigurationId"] = this.libraryConfigurationId;
        data["libraryConfigurationKindId"] = this.libraryConfigurationKindId;
        data["libraryConfigurationRoleId"] = this.libraryConfigurationRoleId;
        data["parentId"] = this.parentId;
        data["libraryFileTypeId"] = this.libraryFileTypeId;
        data["isVisble"] = this.isVisble;
        data["isChecked"] = this.isChecked;
        data["isShared"] = this.isShared;
        data["name"] = this.name;
        data["mime"] = this.mime;
        data["fullNameExtension"] = this.fullNameExtension;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item);
        }
        data["companyId"] = this.companyId;
        if (Array.isArray(this.childs)) {
            data["childs"] = [];
            for (let item of this.childs)
                data["childs"].push(item.toJSON());
        }
        data["guid"] = this.guid;
        data["isPersonalFolder"] = this.isPersonalFolder;
        data["isUploaderSpace"] = this.isUploaderSpace;
        data["isJP"] = this.isJP;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["size"] = this.size;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateLibraryItemOutDto {
        const json = this.toJSON();
        let result = new CreateLibraryItemOutDto();
        result.init(json);
        return result;
    }
}

export interface ICreateLibraryItemOutDto {
    id: number;
    libraryFileOwnerId: number | undefined;
    libraryConfigurationId: number | undefined;
    libraryConfigurationKindId: number | undefined;
    libraryConfigurationRoleId: number | undefined;
    parentId: number | undefined;
    libraryFileTypeId: number;
    isVisble: boolean;
    isChecked: boolean;
    isShared: boolean;
    name: string | undefined;
    mime: string | undefined;
    fullNameExtension: string | undefined;
    files: string[] | undefined;
    companyId: number | undefined;
    childs: LibraryFileDto[] | undefined;
    guid: string;
    isPersonalFolder: boolean;
    isUploaderSpace: boolean;
    isJP: boolean;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    size: number;
    userId: number | undefined;
    user: UserDto;
}

export class CreateOrUpdateCompanyDto implements ICreateOrUpdateCompanyDto {
    id: number;
    name: string;
    tradeName: string | undefined;
    companyTypeId: number;
    companyTypeName: string | undefined;
    companyTypeCode: string | undefined;
    countryISOAlpha2Code: string | undefined;
    incorporationDate: moment.Moment;
    countryId: number;
    countryName: string | undefined;
    taxID: string;
    phoneNumber: string;
    email: string;
    shareTypeId: number | undefined;
    shareType: ShareTypeDto;
    headquarterId: number;
    headquarter: AddressDto;
    fiscalAddressId: number;
    fiscalAddress: AddressDto;
    isFiscalSameAsHeadquarters: boolean;
    establishedAddressId: number;
    establishedAddress: AddressDto;
    isEstablishedSameAsHeadquarters: boolean;
    isEstablishedSameAsFiscal: boolean;
    currencyId: number | undefined;
    currencySymbol: string | undefined;
    socialAmount: number;
    integratedAmount: number;
    balanceMonth: number | undefined;
    businessPurpose: string | undefined;
    representation: string | undefined;
    companyWorkActivities: CompanyWorkActivityDto[] | undefined;
    personCompanyRoleData: PersonCompanyRoleDataDto[] | undefined;
    selectedUsers: SelectableUserDto[] | undefined;

    constructor(data?: ICreateOrUpdateCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.tradeName = _data["tradeName"];
            this.companyTypeId = _data["companyTypeId"];
            this.companyTypeName = _data["companyTypeName"];
            this.companyTypeCode = _data["companyTypeCode"];
            this.countryISOAlpha2Code = _data["countryISOAlpha2Code"];
            this.incorporationDate = _data["incorporationDate"] ? moment(_data["incorporationDate"].toString()) : <any>undefined;
            this.countryId = _data["countryId"];
            this.countryName = _data["countryName"];
            this.taxID = _data["taxID"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.shareTypeId = _data["shareTypeId"];
            this.shareType = _data["shareType"] ? ShareTypeDto.fromJS(_data["shareType"]) : <any>undefined;
            this.headquarterId = _data["headquarterId"];
            this.headquarter = _data["headquarter"] ? AddressDto.fromJS(_data["headquarter"]) : <any>undefined;
            this.fiscalAddressId = _data["fiscalAddressId"];
            this.fiscalAddress = _data["fiscalAddress"] ? AddressDto.fromJS(_data["fiscalAddress"]) : <any>undefined;
            this.isFiscalSameAsHeadquarters = _data["isFiscalSameAsHeadquarters"];
            this.establishedAddressId = _data["establishedAddressId"];
            this.establishedAddress = _data["establishedAddress"] ? AddressDto.fromJS(_data["establishedAddress"]) : <any>undefined;
            this.isEstablishedSameAsHeadquarters = _data["isEstablishedSameAsHeadquarters"];
            this.isEstablishedSameAsFiscal = _data["isEstablishedSameAsFiscal"];
            this.currencyId = _data["currencyId"];
            this.currencySymbol = _data["currencySymbol"];
            this.socialAmount = _data["socialAmount"];
            this.integratedAmount = _data["integratedAmount"];
            this.balanceMonth = _data["balanceMonth"];
            this.businessPurpose = _data["businessPurpose"];
            this.representation = _data["representation"];
            if (Array.isArray(_data["companyWorkActivities"])) {
                this.companyWorkActivities = [] as any;
                for (let item of _data["companyWorkActivities"])
                    this.companyWorkActivities.push(CompanyWorkActivityDto.fromJS(item));
            }
            if (Array.isArray(_data["personCompanyRoleData"])) {
                this.personCompanyRoleData = [] as any;
                for (let item of _data["personCompanyRoleData"])
                    this.personCompanyRoleData.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            if (Array.isArray(_data["selectedUsers"])) {
                this.selectedUsers = [] as any;
                for (let item of _data["selectedUsers"])
                    this.selectedUsers.push(SelectableUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["tradeName"] = this.tradeName;
        data["companyTypeId"] = this.companyTypeId;
        data["companyTypeName"] = this.companyTypeName;
        data["companyTypeCode"] = this.companyTypeCode;
        data["countryISOAlpha2Code"] = this.countryISOAlpha2Code;
        data["incorporationDate"] = this.incorporationDate ? this.incorporationDate.toISOString() : <any>undefined;
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        data["taxID"] = this.taxID;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["shareTypeId"] = this.shareTypeId;
        data["shareType"] = this.shareType ? this.shareType.toJSON() : <any>undefined;
        data["headquarterId"] = this.headquarterId;
        data["headquarter"] = this.headquarter ? this.headquarter.toJSON() : <any>undefined;
        data["fiscalAddressId"] = this.fiscalAddressId;
        data["fiscalAddress"] = this.fiscalAddress ? this.fiscalAddress.toJSON() : <any>undefined;
        data["isFiscalSameAsHeadquarters"] = this.isFiscalSameAsHeadquarters;
        data["establishedAddressId"] = this.establishedAddressId;
        data["establishedAddress"] = this.establishedAddress ? this.establishedAddress.toJSON() : <any>undefined;
        data["isEstablishedSameAsHeadquarters"] = this.isEstablishedSameAsHeadquarters;
        data["isEstablishedSameAsFiscal"] = this.isEstablishedSameAsFiscal;
        data["currencyId"] = this.currencyId;
        data["currencySymbol"] = this.currencySymbol;
        data["socialAmount"] = this.socialAmount;
        data["integratedAmount"] = this.integratedAmount;
        data["balanceMonth"] = this.balanceMonth;
        data["businessPurpose"] = this.businessPurpose;
        data["representation"] = this.representation;
        if (Array.isArray(this.companyWorkActivities)) {
            data["companyWorkActivities"] = [];
            for (let item of this.companyWorkActivities)
                data["companyWorkActivities"].push(item.toJSON());
        }
        if (Array.isArray(this.personCompanyRoleData)) {
            data["personCompanyRoleData"] = [];
            for (let item of this.personCompanyRoleData)
                data["personCompanyRoleData"].push(item.toJSON());
        }
        if (Array.isArray(this.selectedUsers)) {
            data["selectedUsers"] = [];
            for (let item of this.selectedUsers)
                data["selectedUsers"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateOrUpdateCompanyDto {
        const json = this.toJSON();
        let result = new CreateOrUpdateCompanyDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateCompanyDto {
    id: number;
    name: string;
    tradeName: string | undefined;
    companyTypeId: number;
    companyTypeName: string | undefined;
    companyTypeCode: string | undefined;
    countryISOAlpha2Code: string | undefined;
    incorporationDate: moment.Moment;
    countryId: number;
    countryName: string | undefined;
    taxID: string;
    phoneNumber: string;
    email: string;
    shareTypeId: number | undefined;
    shareType: ShareTypeDto;
    headquarterId: number;
    headquarter: AddressDto;
    fiscalAddressId: number;
    fiscalAddress: AddressDto;
    isFiscalSameAsHeadquarters: boolean;
    establishedAddressId: number;
    establishedAddress: AddressDto;
    isEstablishedSameAsHeadquarters: boolean;
    isEstablishedSameAsFiscal: boolean;
    currencyId: number | undefined;
    currencySymbol: string | undefined;
    socialAmount: number;
    integratedAmount: number;
    balanceMonth: number | undefined;
    businessPurpose: string | undefined;
    representation: string | undefined;
    companyWorkActivities: CompanyWorkActivityDto[] | undefined;
    personCompanyRoleData: PersonCompanyRoleDataDto[] | undefined;
    selectedUsers: SelectableUserDto[] | undefined;
}

export class CreateOrUpdateJuridicalPersonDto implements ICreateOrUpdateJuridicalPersonDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    managedCompany: boolean;
    name: string;
    tradeName: string | undefined;
    companyTypeId: number;
    companyTypeName: string | undefined;
    companyTypeCode: string | undefined;
    incorporationDate: moment.Moment;
    countryId: number | undefined;
    countryName: string | undefined;
    countryISOAlpha2Code: string | undefined;
    taxID: string;
    phoneNumber: string | undefined;
    email: string | undefined;
    shareTypeId: number | undefined;
    shareType: ShareTypeDto;
    headquarterId: number | undefined;
    headquarter: AddressDto;
    fiscalAddressId: number | undefined;
    fiscalAddress: AddressDto;
    isFiscalSameAsHeadquarters: boolean;
    establishedAddressId: number | undefined;
    establishedAddress: AddressDto;
    isEstablishedSameAsHeadquarters: boolean;
    isEstablishedSameAsFiscal: boolean;
    currencyId: number | undefined;
    currencySymbol: string | undefined;
    socialAmount: number;
    integratedAmount: number;
    balanceMonth: number | undefined;
    businessPurpose: string | undefined;
    representation: string | undefined;
    companyWorkActivities: CompanyWorkActivityDto[] | undefined;
    personCompanyRoleData: PersonCompanyRoleDataDto[] | undefined;
    isVerified: boolean;
    hasRelations: boolean;
    juridicalPersonCopy: CompanyDto;
    selectedUsers: SelectableUserDto[] | undefined;
    companyType: CompanyTypeDto;
    country: CountryDto;
    roles: PersonCompanyRoleDataDto[] | undefined;
    directors: PersonCompanyRoleDataDto[] | undefined;
    shareholders: PersonCompanyRoleDataDto[] | undefined;
    attorneys: PersonCompanyRoleDataDto[] | undefined;
    finalBeneficiaries: PersonCompanyRoleDataDto[] | undefined;

    constructor(data?: ICreateOrUpdateJuridicalPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.managedCompany = _data["managedCompany"];
            this.name = _data["name"];
            this.tradeName = _data["tradeName"];
            this.companyTypeId = _data["companyTypeId"];
            this.companyTypeName = _data["companyTypeName"];
            this.companyTypeCode = _data["companyTypeCode"];
            this.incorporationDate = _data["incorporationDate"] ? moment(_data["incorporationDate"].toString()) : <any>undefined;
            this.countryId = _data["countryId"];
            this.countryName = _data["countryName"];
            this.countryISOAlpha2Code = _data["countryISOAlpha2Code"];
            this.taxID = _data["taxID"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.shareTypeId = _data["shareTypeId"];
            this.shareType = _data["shareType"] ? ShareTypeDto.fromJS(_data["shareType"]) : <any>undefined;
            this.headquarterId = _data["headquarterId"];
            this.headquarter = _data["headquarter"] ? AddressDto.fromJS(_data["headquarter"]) : <any>undefined;
            this.fiscalAddressId = _data["fiscalAddressId"];
            this.fiscalAddress = _data["fiscalAddress"] ? AddressDto.fromJS(_data["fiscalAddress"]) : <any>undefined;
            this.isFiscalSameAsHeadquarters = _data["isFiscalSameAsHeadquarters"];
            this.establishedAddressId = _data["establishedAddressId"];
            this.establishedAddress = _data["establishedAddress"] ? AddressDto.fromJS(_data["establishedAddress"]) : <any>undefined;
            this.isEstablishedSameAsHeadquarters = _data["isEstablishedSameAsHeadquarters"];
            this.isEstablishedSameAsFiscal = _data["isEstablishedSameAsFiscal"];
            this.currencyId = _data["currencyId"];
            this.currencySymbol = _data["currencySymbol"];
            this.socialAmount = _data["socialAmount"];
            this.integratedAmount = _data["integratedAmount"];
            this.balanceMonth = _data["balanceMonth"];
            this.businessPurpose = _data["businessPurpose"];
            this.representation = _data["representation"];
            if (Array.isArray(_data["companyWorkActivities"])) {
                this.companyWorkActivities = [] as any;
                for (let item of _data["companyWorkActivities"])
                    this.companyWorkActivities.push(CompanyWorkActivityDto.fromJS(item));
            }
            if (Array.isArray(_data["personCompanyRoleData"])) {
                this.personCompanyRoleData = [] as any;
                for (let item of _data["personCompanyRoleData"])
                    this.personCompanyRoleData.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            this.isVerified = _data["isVerified"];
            this.hasRelations = _data["hasRelations"];
            this.juridicalPersonCopy = _data["juridicalPersonCopy"] ? CompanyDto.fromJS(_data["juridicalPersonCopy"]) : <any>undefined;
            if (Array.isArray(_data["selectedUsers"])) {
                this.selectedUsers = [] as any;
                for (let item of _data["selectedUsers"])
                    this.selectedUsers.push(SelectableUserDto.fromJS(item));
            }
            this.companyType = _data["companyType"] ? CompanyTypeDto.fromJS(_data["companyType"]) : <any>undefined;
            this.country = _data["country"] ? CountryDto.fromJS(_data["country"]) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            if (Array.isArray(_data["directors"])) {
                this.directors = [] as any;
                for (let item of _data["directors"])
                    this.directors.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            if (Array.isArray(_data["shareholders"])) {
                this.shareholders = [] as any;
                for (let item of _data["shareholders"])
                    this.shareholders.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            if (Array.isArray(_data["attorneys"])) {
                this.attorneys = [] as any;
                for (let item of _data["attorneys"])
                    this.attorneys.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            if (Array.isArray(_data["finalBeneficiaries"])) {
                this.finalBeneficiaries = [] as any;
                for (let item of _data["finalBeneficiaries"])
                    this.finalBeneficiaries.push(PersonCompanyRoleDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateJuridicalPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateJuridicalPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["managedCompany"] = this.managedCompany;
        data["name"] = this.name;
        data["tradeName"] = this.tradeName;
        data["companyTypeId"] = this.companyTypeId;
        data["companyTypeName"] = this.companyTypeName;
        data["companyTypeCode"] = this.companyTypeCode;
        data["incorporationDate"] = this.incorporationDate ? this.incorporationDate.toISOString() : <any>undefined;
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        data["countryISOAlpha2Code"] = this.countryISOAlpha2Code;
        data["taxID"] = this.taxID;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["shareTypeId"] = this.shareTypeId;
        data["shareType"] = this.shareType ? this.shareType.toJSON() : <any>undefined;
        data["headquarterId"] = this.headquarterId;
        data["headquarter"] = this.headquarter ? this.headquarter.toJSON() : <any>undefined;
        data["fiscalAddressId"] = this.fiscalAddressId;
        data["fiscalAddress"] = this.fiscalAddress ? this.fiscalAddress.toJSON() : <any>undefined;
        data["isFiscalSameAsHeadquarters"] = this.isFiscalSameAsHeadquarters;
        data["establishedAddressId"] = this.establishedAddressId;
        data["establishedAddress"] = this.establishedAddress ? this.establishedAddress.toJSON() : <any>undefined;
        data["isEstablishedSameAsHeadquarters"] = this.isEstablishedSameAsHeadquarters;
        data["isEstablishedSameAsFiscal"] = this.isEstablishedSameAsFiscal;
        data["currencyId"] = this.currencyId;
        data["currencySymbol"] = this.currencySymbol;
        data["socialAmount"] = this.socialAmount;
        data["integratedAmount"] = this.integratedAmount;
        data["balanceMonth"] = this.balanceMonth;
        data["businessPurpose"] = this.businessPurpose;
        data["representation"] = this.representation;
        if (Array.isArray(this.companyWorkActivities)) {
            data["companyWorkActivities"] = [];
            for (let item of this.companyWorkActivities)
                data["companyWorkActivities"].push(item.toJSON());
        }
        if (Array.isArray(this.personCompanyRoleData)) {
            data["personCompanyRoleData"] = [];
            for (let item of this.personCompanyRoleData)
                data["personCompanyRoleData"].push(item.toJSON());
        }
        data["isVerified"] = this.isVerified;
        data["hasRelations"] = this.hasRelations;
        data["juridicalPersonCopy"] = this.juridicalPersonCopy ? this.juridicalPersonCopy.toJSON() : <any>undefined;
        if (Array.isArray(this.selectedUsers)) {
            data["selectedUsers"] = [];
            for (let item of this.selectedUsers)
                data["selectedUsers"].push(item.toJSON());
        }
        data["companyType"] = this.companyType ? this.companyType.toJSON() : <any>undefined;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.directors)) {
            data["directors"] = [];
            for (let item of this.directors)
                data["directors"].push(item.toJSON());
        }
        if (Array.isArray(this.shareholders)) {
            data["shareholders"] = [];
            for (let item of this.shareholders)
                data["shareholders"].push(item.toJSON());
        }
        if (Array.isArray(this.attorneys)) {
            data["attorneys"] = [];
            for (let item of this.attorneys)
                data["attorneys"].push(item.toJSON());
        }
        if (Array.isArray(this.finalBeneficiaries)) {
            data["finalBeneficiaries"] = [];
            for (let item of this.finalBeneficiaries)
                data["finalBeneficiaries"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateOrUpdateJuridicalPersonDto {
        const json = this.toJSON();
        let result = new CreateOrUpdateJuridicalPersonDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateJuridicalPersonDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    managedCompany: boolean;
    name: string;
    tradeName: string | undefined;
    companyTypeId: number;
    companyTypeName: string | undefined;
    companyTypeCode: string | undefined;
    incorporationDate: moment.Moment;
    countryId: number | undefined;
    countryName: string | undefined;
    countryISOAlpha2Code: string | undefined;
    taxID: string;
    phoneNumber: string | undefined;
    email: string | undefined;
    shareTypeId: number | undefined;
    shareType: ShareTypeDto;
    headquarterId: number | undefined;
    headquarter: AddressDto;
    fiscalAddressId: number | undefined;
    fiscalAddress: AddressDto;
    isFiscalSameAsHeadquarters: boolean;
    establishedAddressId: number | undefined;
    establishedAddress: AddressDto;
    isEstablishedSameAsHeadquarters: boolean;
    isEstablishedSameAsFiscal: boolean;
    currencyId: number | undefined;
    currencySymbol: string | undefined;
    socialAmount: number;
    integratedAmount: number;
    balanceMonth: number | undefined;
    businessPurpose: string | undefined;
    representation: string | undefined;
    companyWorkActivities: CompanyWorkActivityDto[] | undefined;
    personCompanyRoleData: PersonCompanyRoleDataDto[] | undefined;
    isVerified: boolean;
    hasRelations: boolean;
    juridicalPersonCopy: CompanyDto;
    selectedUsers: SelectableUserDto[] | undefined;
    companyType: CompanyTypeDto;
    country: CountryDto;
    roles: PersonCompanyRoleDataDto[] | undefined;
    directors: PersonCompanyRoleDataDto[] | undefined;
    shareholders: PersonCompanyRoleDataDto[] | undefined;
    attorneys: PersonCompanyRoleDataDto[] | undefined;
    finalBeneficiaries: PersonCompanyRoleDataDto[] | undefined;
}

export class CreateOrUpdateNaturalPersonDto implements ICreateOrUpdateNaturalPersonDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    tenant: TenantDto;
    emailAddress: string | undefined;
    personCompanyRoleData: PersonCompanyRoleDataDto[] | undefined;
    fullName: string | undefined;
    identificationDocumentId: number;
    nationalityName: string | undefined;
    residenceCountryName: string | undefined;
    occupationName: string | undefined;
    maritalStatusName: string | undefined;
    nuptialsName: string | undefined;
    marriageRegimeName: string | undefined;
    phoneNumber: string | undefined;
    companies: string[] | undefined;
    haveExternalUser: boolean;
    isInitiallyExternalUser: boolean;
    hasRelations: boolean;
    naturalPersonCopy: NaturalPersonDto;
    names: string;
    surnames: string;
    identificationDocument: IdentificationDocumentDto;
    birthdate: moment.Moment | undefined;
    nationalityId: number | undefined;
    nationality: NationalityDto;
    countryId: number | undefined;
    residenceCountry: CountryDto;
    occupationId: number | undefined;
    occupation: OccupationDto;
    occupationOther: string | undefined;
    maritalStatusId: number | undefined;
    maritalStatus: MaritalStatusDto;
    nuptialsId: number | undefined;
    nuptials: NuptialsDto;
    marriageRegimeId: number | undefined;
    marriageRegime: MarriageRegimeDto;
    spouseId: number | undefined;
    spouse: SpouseDto;
    addressId: number | undefined;
    address: AddressDto;
    contactId: number | undefined;
    contact: ContactDto;
    finalBeneficiary: boolean | undefined;
    politicallyExposedPerson: boolean | undefined;

    constructor(data?: ICreateOrUpdateNaturalPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? TenantDto.fromJS(_data["tenant"]) : <any>undefined;
            this.emailAddress = _data["emailAddress"];
            if (Array.isArray(_data["personCompanyRoleData"])) {
                this.personCompanyRoleData = [] as any;
                for (let item of _data["personCompanyRoleData"])
                    this.personCompanyRoleData.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            this.fullName = _data["fullName"];
            this.identificationDocumentId = _data["identificationDocumentId"];
            this.nationalityName = _data["nationalityName"];
            this.residenceCountryName = _data["residenceCountryName"];
            this.occupationName = _data["occupationName"];
            this.maritalStatusName = _data["maritalStatusName"];
            this.nuptialsName = _data["nuptialsName"];
            this.marriageRegimeName = _data["marriageRegimeName"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies.push(item);
            }
            this.haveExternalUser = _data["haveExternalUser"];
            this.isInitiallyExternalUser = _data["isInitiallyExternalUser"];
            this.hasRelations = _data["hasRelations"];
            this.naturalPersonCopy = _data["naturalPersonCopy"] ? NaturalPersonDto.fromJS(_data["naturalPersonCopy"]) : <any>undefined;
            this.names = _data["names"];
            this.surnames = _data["surnames"];
            this.identificationDocument = _data["identificationDocument"] ? IdentificationDocumentDto.fromJS(_data["identificationDocument"]) : <any>undefined;
            this.birthdate = _data["birthdate"] ? moment(_data["birthdate"].toString()) : <any>undefined;
            this.nationalityId = _data["nationalityId"];
            this.nationality = _data["nationality"] ? NationalityDto.fromJS(_data["nationality"]) : <any>undefined;
            this.countryId = _data["countryId"];
            this.residenceCountry = _data["residenceCountry"] ? CountryDto.fromJS(_data["residenceCountry"]) : <any>undefined;
            this.occupationId = _data["occupationId"];
            this.occupation = _data["occupation"] ? OccupationDto.fromJS(_data["occupation"]) : <any>undefined;
            this.occupationOther = _data["occupationOther"];
            this.maritalStatusId = _data["maritalStatusId"];
            this.maritalStatus = _data["maritalStatus"] ? MaritalStatusDto.fromJS(_data["maritalStatus"]) : <any>undefined;
            this.nuptialsId = _data["nuptialsId"];
            this.nuptials = _data["nuptials"] ? NuptialsDto.fromJS(_data["nuptials"]) : <any>undefined;
            this.marriageRegimeId = _data["marriageRegimeId"];
            this.marriageRegime = _data["marriageRegime"] ? MarriageRegimeDto.fromJS(_data["marriageRegime"]) : <any>undefined;
            this.spouseId = _data["spouseId"];
            this.spouse = _data["spouse"] ? SpouseDto.fromJS(_data["spouse"]) : <any>undefined;
            this.addressId = _data["addressId"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            this.contactId = _data["contactId"];
            this.contact = _data["contact"] ? ContactDto.fromJS(_data["contact"]) : <any>undefined;
            this.finalBeneficiary = _data["finalBeneficiary"];
            this.politicallyExposedPerson = _data["politicallyExposedPerson"];
        }
    }

    static fromJS(data: any): CreateOrUpdateNaturalPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateNaturalPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        if (Array.isArray(this.personCompanyRoleData)) {
            data["personCompanyRoleData"] = [];
            for (let item of this.personCompanyRoleData)
                data["personCompanyRoleData"].push(item.toJSON());
        }
        data["fullName"] = this.fullName;
        data["identificationDocumentId"] = this.identificationDocumentId;
        data["nationalityName"] = this.nationalityName;
        data["residenceCountryName"] = this.residenceCountryName;
        data["occupationName"] = this.occupationName;
        data["maritalStatusName"] = this.maritalStatusName;
        data["nuptialsName"] = this.nuptialsName;
        data["marriageRegimeName"] = this.marriageRegimeName;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item);
        }
        data["haveExternalUser"] = this.haveExternalUser;
        data["isInitiallyExternalUser"] = this.isInitiallyExternalUser;
        data["hasRelations"] = this.hasRelations;
        data["naturalPersonCopy"] = this.naturalPersonCopy ? this.naturalPersonCopy.toJSON() : <any>undefined;
        data["names"] = this.names;
        data["surnames"] = this.surnames;
        data["identificationDocument"] = this.identificationDocument ? this.identificationDocument.toJSON() : <any>undefined;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : <any>undefined;
        data["nationalityId"] = this.nationalityId;
        data["nationality"] = this.nationality ? this.nationality.toJSON() : <any>undefined;
        data["countryId"] = this.countryId;
        data["residenceCountry"] = this.residenceCountry ? this.residenceCountry.toJSON() : <any>undefined;
        data["occupationId"] = this.occupationId;
        data["occupation"] = this.occupation ? this.occupation.toJSON() : <any>undefined;
        data["occupationOther"] = this.occupationOther;
        data["maritalStatusId"] = this.maritalStatusId;
        data["maritalStatus"] = this.maritalStatus ? this.maritalStatus.toJSON() : <any>undefined;
        data["nuptialsId"] = this.nuptialsId;
        data["nuptials"] = this.nuptials ? this.nuptials.toJSON() : <any>undefined;
        data["marriageRegimeId"] = this.marriageRegimeId;
        data["marriageRegime"] = this.marriageRegime ? this.marriageRegime.toJSON() : <any>undefined;
        data["spouseId"] = this.spouseId;
        data["spouse"] = this.spouse ? this.spouse.toJSON() : <any>undefined;
        data["addressId"] = this.addressId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["contactId"] = this.contactId;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["finalBeneficiary"] = this.finalBeneficiary;
        data["politicallyExposedPerson"] = this.politicallyExposedPerson;
        return data;
    }

    clone(): CreateOrUpdateNaturalPersonDto {
        const json = this.toJSON();
        let result = new CreateOrUpdateNaturalPersonDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateNaturalPersonDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    tenant: TenantDto;
    emailAddress: string | undefined;
    personCompanyRoleData: PersonCompanyRoleDataDto[] | undefined;
    fullName: string | undefined;
    identificationDocumentId: number;
    nationalityName: string | undefined;
    residenceCountryName: string | undefined;
    occupationName: string | undefined;
    maritalStatusName: string | undefined;
    nuptialsName: string | undefined;
    marriageRegimeName: string | undefined;
    phoneNumber: string | undefined;
    companies: string[] | undefined;
    haveExternalUser: boolean;
    isInitiallyExternalUser: boolean;
    hasRelations: boolean;
    naturalPersonCopy: NaturalPersonDto;
    names: string;
    surnames: string;
    identificationDocument: IdentificationDocumentDto;
    birthdate: moment.Moment | undefined;
    nationalityId: number | undefined;
    nationality: NationalityDto;
    countryId: number | undefined;
    residenceCountry: CountryDto;
    occupationId: number | undefined;
    occupation: OccupationDto;
    occupationOther: string | undefined;
    maritalStatusId: number | undefined;
    maritalStatus: MaritalStatusDto;
    nuptialsId: number | undefined;
    nuptials: NuptialsDto;
    marriageRegimeId: number | undefined;
    marriageRegime: MarriageRegimeDto;
    spouseId: number | undefined;
    spouse: SpouseDto;
    addressId: number | undefined;
    address: AddressDto;
    contactId: number | undefined;
    contact: ContactDto;
    finalBeneficiary: boolean | undefined;
    politicallyExposedPerson: boolean | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string;
    connectionString: string | undefined;
    isActive: boolean;
    phoneNumber: string | undefined;
    alternativePhoneNumber: string | undefined;
    documentNumber: string | undefined;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.adminPassword = _data["adminPassword"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
            this.phoneNumber = _data["phoneNumber"];
            this.alternativePhoneNumber = _data["alternativePhoneNumber"];
            this.documentNumber = _data["documentNumber"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["phoneNumber"] = this.phoneNumber;
        data["alternativePhoneNumber"] = this.alternativePhoneNumber;
        data["documentNumber"] = this.documentNumber;
        return data;
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string;
    connectionString: string | undefined;
    isActive: boolean;
    phoneNumber: string | undefined;
    alternativePhoneNumber: string | undefined;
    documentNumber: string | undefined;
}

export class CreateTenantLibraryConfigurationItemOutDto implements ICreateTenantLibraryConfigurationItemOutDto {
    id: number;
    libraryConfigurationId: number | undefined;
    libraryConfigurationKindId: number | undefined;
    libraryConfigurationRoleId: number | undefined;
    parentId: number | undefined;
    libraryFileTypeId: number;
    isVisble: boolean;
    isChecked: boolean;
    isRetroactive: boolean;
    isShared: boolean;
    name: string | undefined;
    mime: string | undefined;
    fullNameExtension: string | undefined;
    files: string[] | undefined;
    isUploaderSpace: boolean;
    isJP: boolean;
    childs: LibraryFileDto[] | undefined;
    guid: string;
    libraryFileOwnerId: number | undefined;
    isPersonalFolder: boolean;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    size: number;
    userId: number | undefined;
    user: UserDto;

    constructor(data?: ICreateTenantLibraryConfigurationItemOutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libraryConfigurationId = _data["libraryConfigurationId"];
            this.libraryConfigurationKindId = _data["libraryConfigurationKindId"];
            this.libraryConfigurationRoleId = _data["libraryConfigurationRoleId"];
            this.parentId = _data["parentId"];
            this.libraryFileTypeId = _data["libraryFileTypeId"];
            this.isVisble = _data["isVisble"];
            this.isChecked = _data["isChecked"];
            this.isRetroactive = _data["isRetroactive"];
            this.isShared = _data["isShared"];
            this.name = _data["name"];
            this.mime = _data["mime"];
            this.fullNameExtension = _data["fullNameExtension"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files.push(item);
            }
            this.isUploaderSpace = _data["isUploaderSpace"];
            this.isJP = _data["isJP"];
            if (Array.isArray(_data["childs"])) {
                this.childs = [] as any;
                for (let item of _data["childs"])
                    this.childs.push(LibraryFileDto.fromJS(item));
            }
            this.guid = _data["guid"];
            this.libraryFileOwnerId = _data["libraryFileOwnerId"];
            this.isPersonalFolder = _data["isPersonalFolder"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.size = _data["size"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateTenantLibraryConfigurationItemOutDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantLibraryConfigurationItemOutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libraryConfigurationId"] = this.libraryConfigurationId;
        data["libraryConfigurationKindId"] = this.libraryConfigurationKindId;
        data["libraryConfigurationRoleId"] = this.libraryConfigurationRoleId;
        data["parentId"] = this.parentId;
        data["libraryFileTypeId"] = this.libraryFileTypeId;
        data["isVisble"] = this.isVisble;
        data["isChecked"] = this.isChecked;
        data["isRetroactive"] = this.isRetroactive;
        data["isShared"] = this.isShared;
        data["name"] = this.name;
        data["mime"] = this.mime;
        data["fullNameExtension"] = this.fullNameExtension;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item);
        }
        data["isUploaderSpace"] = this.isUploaderSpace;
        data["isJP"] = this.isJP;
        if (Array.isArray(this.childs)) {
            data["childs"] = [];
            for (let item of this.childs)
                data["childs"].push(item.toJSON());
        }
        data["guid"] = this.guid;
        data["libraryFileOwnerId"] = this.libraryFileOwnerId;
        data["isPersonalFolder"] = this.isPersonalFolder;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["size"] = this.size;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateTenantLibraryConfigurationItemOutDto {
        const json = this.toJSON();
        let result = new CreateTenantLibraryConfigurationItemOutDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantLibraryConfigurationItemOutDto {
    id: number;
    libraryConfigurationId: number | undefined;
    libraryConfigurationKindId: number | undefined;
    libraryConfigurationRoleId: number | undefined;
    parentId: number | undefined;
    libraryFileTypeId: number;
    isVisble: boolean;
    isChecked: boolean;
    isRetroactive: boolean;
    isShared: boolean;
    name: string | undefined;
    mime: string | undefined;
    fullNameExtension: string | undefined;
    files: string[] | undefined;
    isUploaderSpace: boolean;
    isJP: boolean;
    childs: LibraryFileDto[] | undefined;
    guid: string;
    libraryFileOwnerId: number | undefined;
    isPersonalFolder: boolean;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    size: number;
    userId: number | undefined;
    user: UserDto;
}

export class CreateUserDto implements ICreateUserDto {
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string;
    profilePhoto: string | undefined;
    mimeType: string | undefined;
    profilePhotoBytes: string | undefined;
    selectedCompaniesIds: number[] | undefined;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.password = _data["password"];
            this.profilePhoto = _data["profilePhoto"];
            this.mimeType = _data["mimeType"];
            this.profilePhotoBytes = _data["profilePhotoBytes"];
            if (Array.isArray(_data["selectedCompaniesIds"])) {
                this.selectedCompaniesIds = [] as any;
                for (let item of _data["selectedCompaniesIds"])
                    this.selectedCompaniesIds.push(item);
            }
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["password"] = this.password;
        data["profilePhoto"] = this.profilePhoto;
        data["mimeType"] = this.mimeType;
        data["profilePhotoBytes"] = this.profilePhotoBytes;
        if (Array.isArray(this.selectedCompaniesIds)) {
            data["selectedCompaniesIds"] = [];
            for (let item of this.selectedCompaniesIds)
                data["selectedCompaniesIds"].push(item);
        }
        return data;
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string;
    profilePhoto: string | undefined;
    mimeType: string | undefined;
    profilePhotoBytes: string | undefined;
    selectedCompaniesIds: number[] | undefined;
}

export class CreateUserWithoutCompanyDto implements ICreateUserWithoutCompanyDto {
    isAvailable: boolean;

    constructor(data?: ICreateUserWithoutCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAvailable = _data["isAvailable"];
        }
    }

    static fromJS(data: any): CreateUserWithoutCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserWithoutCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAvailable"] = this.isAvailable;
        return data;
    }

    clone(): CreateUserWithoutCompanyDto {
        const json = this.toJSON();
        let result = new CreateUserWithoutCompanyDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserWithoutCompanyDto {
    isAvailable: boolean;
}

export class Currency implements ICurrency {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
    symbol: string | undefined;

    constructor(data?: ICurrency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
            this.symbol = _data["symbol"];
        }
    }

    static fromJS(data: any): Currency {
        data = typeof data === 'object' ? data : {};
        let result = new Currency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        data["symbol"] = this.symbol;
        return data;
    }

    clone(): Currency {
        const json = this.toJSON();
        let result = new Currency();
        result.init(json);
        return result;
    }
}

export interface ICurrency {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
    symbol: string | undefined;
}

export class CurrencyDto implements ICurrencyDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
    symbol: string | undefined;

    constructor(data?: ICurrencyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
            this.symbol = _data["symbol"];
        }
    }

    static fromJS(data: any): CurrencyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        data["symbol"] = this.symbol;
        return data;
    }

    clone(): CurrencyDto {
        const json = this.toJSON();
        let result = new CurrencyDto();
        result.init(json);
        return result;
    }
}

export interface ICurrencyDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
    symbol: string | undefined;
}

export class CurrencyDtoPagedResultDto implements ICurrencyDtoPagedResultDto {
    items: CurrencyDto[] | undefined;
    totalCount: number;

    constructor(data?: ICurrencyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CurrencyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CurrencyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CurrencyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CurrencyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICurrencyDtoPagedResultDto {
    items: CurrencyDto[] | undefined;
    totalCount: number;
}

export class CustomFieldDto implements ICustomFieldDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    isComboBox: boolean;
    typeFieldId: number | undefined;
    typeField: TypeFieldDto;
    customFieldOptions: CustomFieldOptionDto[] | undefined;
    dateFormat: string | undefined;

    constructor(data?: ICustomFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isComboBox = _data["isComboBox"];
            this.typeFieldId = _data["typeFieldId"];
            this.typeField = _data["typeField"] ? TypeFieldDto.fromJS(_data["typeField"]) : <any>undefined;
            if (Array.isArray(_data["customFieldOptions"])) {
                this.customFieldOptions = [] as any;
                for (let item of _data["customFieldOptions"])
                    this.customFieldOptions.push(CustomFieldOptionDto.fromJS(item));
            }
            this.dateFormat = _data["dateFormat"];
        }
    }

    static fromJS(data: any): CustomFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isComboBox"] = this.isComboBox;
        data["typeFieldId"] = this.typeFieldId;
        data["typeField"] = this.typeField ? this.typeField.toJSON() : <any>undefined;
        if (Array.isArray(this.customFieldOptions)) {
            data["customFieldOptions"] = [];
            for (let item of this.customFieldOptions)
                data["customFieldOptions"].push(item.toJSON());
        }
        data["dateFormat"] = this.dateFormat;
        return data;
    }

    clone(): CustomFieldDto {
        const json = this.toJSON();
        let result = new CustomFieldDto();
        result.init(json);
        return result;
    }
}

export interface ICustomFieldDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    isComboBox: boolean;
    typeFieldId: number | undefined;
    typeField: TypeFieldDto;
    customFieldOptions: CustomFieldOptionDto[] | undefined;
    dateFormat: string | undefined;
}

export class CustomFieldDtoPagedResultDto implements ICustomFieldDtoPagedResultDto {
    items: CustomFieldDto[] | undefined;
    totalCount: number;

    constructor(data?: ICustomFieldDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CustomFieldDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomFieldDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomFieldDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CustomFieldDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CustomFieldDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICustomFieldDtoPagedResultDto {
    items: CustomFieldDto[] | undefined;
    totalCount: number;
}

export class CustomFieldOptionDto implements ICustomFieldOptionDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    tenant: Tenant;
    name: string | undefined;

    constructor(data?: ICustomFieldOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CustomFieldOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomFieldOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["name"] = this.name;
        return data;
    }

    clone(): CustomFieldOptionDto {
        const json = this.toJSON();
        let result = new CustomFieldOptionDto();
        result.init(json);
        return result;
    }
}

export interface ICustomFieldOptionDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    tenant: Tenant;
    name: string | undefined;
}

export class CustomFieldOptionDtoPagedResultDto implements ICustomFieldOptionDtoPagedResultDto {
    items: CustomFieldOptionDto[] | undefined;
    totalCount: number;

    constructor(data?: ICustomFieldOptionDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CustomFieldOptionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomFieldOptionDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomFieldOptionDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CustomFieldOptionDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CustomFieldOptionDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICustomFieldOptionDtoPagedResultDto {
    items: CustomFieldOptionDto[] | undefined;
    totalCount: number;
}

export class DocumentType implements IDocumentType {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;

    constructor(data?: IDocumentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
        }
    }

    static fromJS(data: any): DocumentType {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        return data;
    }

    clone(): DocumentType {
        const json = this.toJSON();
        let result = new DocumentType();
        result.init(json);
        return result;
    }
}

export interface IDocumentType {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
}

export class DocumentTypeDto implements IDocumentTypeDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;

    constructor(data?: IDocumentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
        }
    }

    static fromJS(data: any): DocumentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        return data;
    }

    clone(): DocumentTypeDto {
        const json = this.toJSON();
        let result = new DocumentTypeDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentTypeDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
}

export class DocumentTypeDtoPagedResultDto implements IDocumentTypeDtoPagedResultDto {
    items: DocumentTypeDto[] | undefined;
    totalCount: number;

    constructor(data?: IDocumentTypeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DocumentTypeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DocumentTypeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DocumentTypeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DocumentTypeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentTypeDtoPagedResultDto {
    items: DocumentTypeDto[] | undefined;
    totalCount: number;
}

export class DownloadLibraryFileRequestDto implements IDownloadLibraryFileRequestDto {
    guid: string;

    constructor(data?: IDownloadLibraryFileRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
        }
    }

    static fromJS(data: any): DownloadLibraryFileRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadLibraryFileRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        return data;
    }

    clone(): DownloadLibraryFileRequestDto {
        const json = this.toJSON();
        let result = new DownloadLibraryFileRequestDto();
        result.init(json);
        return result;
    }
}

export interface IDownloadLibraryFileRequestDto {
    guid: string;
}

export class DownloadLibraryFileResponseDto implements IDownloadLibraryFileResponseDto {
    guid: string;
    fileData: string | undefined;
    contentType: string | undefined;
    fileName: string | undefined;

    constructor(data?: IDownloadLibraryFileResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.fileData = _data["fileData"];
            this.contentType = _data["contentType"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): DownloadLibraryFileResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadLibraryFileResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["fileData"] = this.fileData;
        data["contentType"] = this.contentType;
        data["fileName"] = this.fileName;
        return data;
    }

    clone(): DownloadLibraryFileResponseDto {
        const json = this.toJSON();
        let result = new DownloadLibraryFileResponseDto();
        result.init(json);
        return result;
    }
}

export interface IDownloadLibraryFileResponseDto {
    guid: string;
    fileData: string | undefined;
    contentType: string | undefined;
    fileName: string | undefined;
}

export class EditCompanyAddressesDto implements IEditCompanyAddressesDto {
    id: number;
    tenantId: number;
    headquarterId: number;
    headquarter: AddressDto;
    fiscalAddressId: number;
    fiscalAddress: AddressDto;
    establishedAddressId: number;
    establishedAddress: AddressDto;

    constructor(data?: IEditCompanyAddressesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.headquarterId = _data["headquarterId"];
            this.headquarter = _data["headquarter"] ? AddressDto.fromJS(_data["headquarter"]) : <any>undefined;
            this.fiscalAddressId = _data["fiscalAddressId"];
            this.fiscalAddress = _data["fiscalAddress"] ? AddressDto.fromJS(_data["fiscalAddress"]) : <any>undefined;
            this.establishedAddressId = _data["establishedAddressId"];
            this.establishedAddress = _data["establishedAddress"] ? AddressDto.fromJS(_data["establishedAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditCompanyAddressesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditCompanyAddressesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["headquarterId"] = this.headquarterId;
        data["headquarter"] = this.headquarter ? this.headquarter.toJSON() : <any>undefined;
        data["fiscalAddressId"] = this.fiscalAddressId;
        data["fiscalAddress"] = this.fiscalAddress ? this.fiscalAddress.toJSON() : <any>undefined;
        data["establishedAddressId"] = this.establishedAddressId;
        data["establishedAddress"] = this.establishedAddress ? this.establishedAddress.toJSON() : <any>undefined;
        return data;
    }

    clone(): EditCompanyAddressesDto {
        const json = this.toJSON();
        let result = new EditCompanyAddressesDto();
        result.init(json);
        return result;
    }
}

export interface IEditCompanyAddressesDto {
    id: number;
    tenantId: number;
    headquarterId: number;
    headquarter: AddressDto;
    fiscalAddressId: number;
    fiscalAddress: AddressDto;
    establishedAddressId: number;
    establishedAddress: AddressDto;
}

export class EditCompanySummaryDto implements IEditCompanySummaryDto {
    id: number;
    tenantId: number;
    name: string;
    tradeName: string | undefined;
    companyTypeId: number;
    countryId: number;
    taxID: string;
    incorporationDate: moment.Moment;
    phoneNumber: string;
    email: string;

    constructor(data?: IEditCompanySummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.tradeName = _data["tradeName"];
            this.companyTypeId = _data["companyTypeId"];
            this.countryId = _data["countryId"];
            this.taxID = _data["taxID"];
            this.incorporationDate = _data["incorporationDate"] ? moment(_data["incorporationDate"].toString()) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): EditCompanySummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditCompanySummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["tradeName"] = this.tradeName;
        data["companyTypeId"] = this.companyTypeId;
        data["countryId"] = this.countryId;
        data["taxID"] = this.taxID;
        data["incorporationDate"] = this.incorporationDate ? this.incorporationDate.toISOString() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        return data;
    }

    clone(): EditCompanySummaryDto {
        const json = this.toJSON();
        let result = new EditCompanySummaryDto();
        result.init(json);
        return result;
    }
}

export interface IEditCompanySummaryDto {
    id: number;
    tenantId: number;
    name: string;
    tradeName: string | undefined;
    companyTypeId: number;
    countryId: number;
    taxID: string;
    incorporationDate: moment.Moment;
    phoneNumber: string;
    email: string;
}

export class Edition implements IEdition {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string;
    displayName: string;

    constructor(data?: IEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): Edition {
        data = typeof data === 'object' ? data : {};
        let result = new Edition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        return data;
    }

    clone(): Edition {
        const json = this.toJSON();
        let result = new Edition();
        result.init(json);
        return result;
    }
}

export interface IEdition {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string;
    displayName: string;
}

export class ExternalUserDto implements IExternalUserDto {
    id: number;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;
    profilePhoto: string | undefined;
    mimeType: string | undefined;
    profilePhotoBytes: string | undefined;
    selectedCompaniesIds: number[] | undefined;

    constructor(data?: IExternalUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.fullName = _data["fullName"];
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.profilePhoto = _data["profilePhoto"];
            this.mimeType = _data["mimeType"];
            this.profilePhotoBytes = _data["profilePhotoBytes"];
            if (Array.isArray(_data["selectedCompaniesIds"])) {
                this.selectedCompaniesIds = [] as any;
                for (let item of _data["selectedCompaniesIds"])
                    this.selectedCompaniesIds.push(item);
            }
        }
    }

    static fromJS(data: any): ExternalUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["profilePhoto"] = this.profilePhoto;
        data["mimeType"] = this.mimeType;
        data["profilePhotoBytes"] = this.profilePhotoBytes;
        if (Array.isArray(this.selectedCompaniesIds)) {
            data["selectedCompaniesIds"] = [];
            for (let item of this.selectedCompaniesIds)
                data["selectedCompaniesIds"].push(item);
        }
        return data;
    }

    clone(): ExternalUserDto {
        const json = this.toJSON();
        let result = new ExternalUserDto();
        result.init(json);
        return result;
    }
}

export interface IExternalUserDto {
    id: number;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;
    profilePhoto: string | undefined;
    mimeType: string | undefined;
    profilePhotoBytes: string | undefined;
    selectedCompaniesIds: number[] | undefined;
}

export class ExternalUserDtoPagedResultDto implements IExternalUserDtoPagedResultDto {
    items: ExternalUserDto[] | undefined;
    totalCount: number;

    constructor(data?: IExternalUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ExternalUserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ExternalUserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalUserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ExternalUserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ExternalUserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IExternalUserDtoPagedResultDto {
    items: ExternalUserDto[] | undefined;
    totalCount: number;
}

export enum FieldComparatorEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum FieldTypeEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class FilterFieldEntryDto implements IFilterFieldEntryDto {
    fieldName: string | undefined;
    fieldType: FieldTypeEnum;
    fieldComparator: FieldComparatorEnum;
    value: string | undefined;

    constructor(data?: IFilterFieldEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["fieldName"];
            this.fieldType = _data["fieldType"];
            this.fieldComparator = _data["fieldComparator"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FilterFieldEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterFieldEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName;
        data["fieldType"] = this.fieldType;
        data["fieldComparator"] = this.fieldComparator;
        data["value"] = this.value;
        return data;
    }

    clone(): FilterFieldEntryDto {
        const json = this.toJSON();
        let result = new FilterFieldEntryDto();
        result.init(json);
        return result;
    }
}

export interface IFilterFieldEntryDto {
    fieldName: string | undefined;
    fieldType: FieldTypeEnum;
    fieldComparator: FieldComparatorEnum;
    value: string | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class FunctionalLink implements IFunctionalLink {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
    code: number;
    countryId: number;
    country: Country;

    constructor(data?: IFunctionalLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
            this.code = _data["code"];
            this.countryId = _data["countryId"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FunctionalLink {
        data = typeof data === 'object' ? data : {};
        let result = new FunctionalLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        data["code"] = this.code;
        data["countryId"] = this.countryId;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        return data;
    }

    clone(): FunctionalLink {
        const json = this.toJSON();
        let result = new FunctionalLink();
        result.init(json);
        return result;
    }
}

export interface IFunctionalLink {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
    code: number;
    countryId: number;
    country: Country;
}

export class FunctionalLinkDto implements IFunctionalLinkDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
    code: number;
    countryId: number;
    country: CountryDto;

    constructor(data?: IFunctionalLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
            this.code = _data["code"];
            this.countryId = _data["countryId"];
            this.country = _data["country"] ? CountryDto.fromJS(_data["country"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FunctionalLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new FunctionalLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        data["code"] = this.code;
        data["countryId"] = this.countryId;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        return data;
    }

    clone(): FunctionalLinkDto {
        const json = this.toJSON();
        let result = new FunctionalLinkDto();
        result.init(json);
        return result;
    }
}

export interface IFunctionalLinkDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
    code: number;
    countryId: number;
    country: CountryDto;
}

export class FunctionalLinkDtoPagedResultDto implements IFunctionalLinkDtoPagedResultDto {
    items: FunctionalLinkDto[] | undefined;
    totalCount: number;

    constructor(data?: IFunctionalLinkDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(FunctionalLinkDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): FunctionalLinkDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FunctionalLinkDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): FunctionalLinkDtoPagedResultDto {
        const json = this.toJSON();
        let result = new FunctionalLinkDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFunctionalLinkDtoPagedResultDto {
    items: FunctionalLinkDto[] | undefined;
    totalCount: number;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class HealthInsurance implements IHealthInsurance {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
    code: number;
    countryId: number;
    country: Country;

    constructor(data?: IHealthInsurance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
            this.code = _data["code"];
            this.countryId = _data["countryId"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HealthInsurance {
        data = typeof data === 'object' ? data : {};
        let result = new HealthInsurance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        data["code"] = this.code;
        data["countryId"] = this.countryId;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        return data;
    }

    clone(): HealthInsurance {
        const json = this.toJSON();
        let result = new HealthInsurance();
        result.init(json);
        return result;
    }
}

export interface IHealthInsurance {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
    code: number;
    countryId: number;
    country: Country;
}

export class HealthInsuranceDto implements IHealthInsuranceDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
    code: number;
    countryId: number;
    country: CountryDto;

    constructor(data?: IHealthInsuranceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
            this.code = _data["code"];
            this.countryId = _data["countryId"];
            this.country = _data["country"] ? CountryDto.fromJS(_data["country"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HealthInsuranceDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthInsuranceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        data["code"] = this.code;
        data["countryId"] = this.countryId;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        return data;
    }

    clone(): HealthInsuranceDto {
        const json = this.toJSON();
        let result = new HealthInsuranceDto();
        result.init(json);
        return result;
    }
}

export interface IHealthInsuranceDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
    code: number;
    countryId: number;
    country: CountryDto;
}

export class HealthInsuranceDtoPagedResultDto implements IHealthInsuranceDtoPagedResultDto {
    items: HealthInsuranceDto[] | undefined;
    totalCount: number;

    constructor(data?: IHealthInsuranceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(HealthInsuranceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): HealthInsuranceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthInsuranceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): HealthInsuranceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new HealthInsuranceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IHealthInsuranceDtoPagedResultDto {
    items: HealthInsuranceDto[] | undefined;
    totalCount: number;
}

export class IdentificationDocument implements IIdentificationDocument {
    id: number;
    documentTypeId: number | undefined;
    documentType: DocumentType;
    documentNumber: string | undefined;

    constructor(data?: IIdentificationDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentTypeId = _data["documentTypeId"];
            this.documentType = _data["documentType"] ? DocumentType.fromJS(_data["documentType"]) : <any>undefined;
            this.documentNumber = _data["documentNumber"];
        }
    }

    static fromJS(data: any): IdentificationDocument {
        data = typeof data === 'object' ? data : {};
        let result = new IdentificationDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentTypeId"] = this.documentTypeId;
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        data["documentNumber"] = this.documentNumber;
        return data;
    }

    clone(): IdentificationDocument {
        const json = this.toJSON();
        let result = new IdentificationDocument();
        result.init(json);
        return result;
    }
}

export interface IIdentificationDocument {
    id: number;
    documentTypeId: number | undefined;
    documentType: DocumentType;
    documentNumber: string | undefined;
}

export class IdentificationDocumentDto implements IIdentificationDocumentDto {
    id: number;
    documentTypeId: number | undefined;
    documentType: DocumentTypeDto;
    documentNumber: string | undefined;

    constructor(data?: IIdentificationDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentTypeId = _data["documentTypeId"];
            this.documentType = _data["documentType"] ? DocumentTypeDto.fromJS(_data["documentType"]) : <any>undefined;
            this.documentNumber = _data["documentNumber"];
        }
    }

    static fromJS(data: any): IdentificationDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdentificationDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentTypeId"] = this.documentTypeId;
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        data["documentNumber"] = this.documentNumber;
        return data;
    }

    clone(): IdentificationDocumentDto {
        const json = this.toJSON();
        let result = new IdentificationDocumentDto();
        result.init(json);
        return result;
    }
}

export interface IIdentificationDocumentDto {
    id: number;
    documentTypeId: number | undefined;
    documentType: DocumentTypeDto;
    documentNumber: string | undefined;
}

export class Int64EntityDto implements IInt64EntityDto {
    id: number;

    constructor(data?: IInt64EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Int64EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int64EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): Int64EntityDto {
        const json = this.toJSON();
        let result = new Int64EntityDto();
        result.init(json);
        return result;
    }
}

export interface IInt64EntityDto {
    id: number;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
}

export class JuridicalPersonInfoDto implements IJuridicalPersonInfoDto {
    id: number;
    name: string | undefined;
    tradeName: string | undefined;
    currencySymbol: string | undefined;
    capitalAmount: string | undefined;
    shareholding: string | undefined;
    companyRole: string | undefined;
    companyRoleCode: string | undefined;
    workActivity: string | undefined;
    nominalValue: string | undefined;
    socialAmount: string | undefined;
    integratedAmount: string | undefined;
    position: string | undefined;
    globalControl: number | undefined;
    capitalAmountNumber: number | undefined;
    socialAmountNumber: number | undefined;
    nominalValueNumber: number | undefined;
    integratedAmountNumber: number | undefined;
    shareholdingNumber: number | undefined;

    constructor(data?: IJuridicalPersonInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.tradeName = _data["tradeName"];
            this.currencySymbol = _data["currencySymbol"];
            this.capitalAmount = _data["capitalAmount"];
            this.shareholding = _data["shareholding"];
            this.companyRole = _data["companyRole"];
            this.companyRoleCode = _data["companyRoleCode"];
            this.workActivity = _data["workActivity"];
            this.nominalValue = _data["nominalValue"];
            this.socialAmount = _data["socialAmount"];
            this.integratedAmount = _data["integratedAmount"];
            this.position = _data["position"];
            this.globalControl = _data["globalControl"];
            this.capitalAmountNumber = _data["capitalAmountNumber"];
            this.socialAmountNumber = _data["socialAmountNumber"];
            this.nominalValueNumber = _data["nominalValueNumber"];
            this.integratedAmountNumber = _data["integratedAmountNumber"];
            this.shareholdingNumber = _data["shareholdingNumber"];
        }
    }

    static fromJS(data: any): JuridicalPersonInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new JuridicalPersonInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["tradeName"] = this.tradeName;
        data["currencySymbol"] = this.currencySymbol;
        data["capitalAmount"] = this.capitalAmount;
        data["shareholding"] = this.shareholding;
        data["companyRole"] = this.companyRole;
        data["companyRoleCode"] = this.companyRoleCode;
        data["workActivity"] = this.workActivity;
        data["nominalValue"] = this.nominalValue;
        data["socialAmount"] = this.socialAmount;
        data["integratedAmount"] = this.integratedAmount;
        data["position"] = this.position;
        data["globalControl"] = this.globalControl;
        data["capitalAmountNumber"] = this.capitalAmountNumber;
        data["socialAmountNumber"] = this.socialAmountNumber;
        data["nominalValueNumber"] = this.nominalValueNumber;
        data["integratedAmountNumber"] = this.integratedAmountNumber;
        data["shareholdingNumber"] = this.shareholdingNumber;
        return data;
    }

    clone(): JuridicalPersonInfoDto {
        const json = this.toJSON();
        let result = new JuridicalPersonInfoDto();
        result.init(json);
        return result;
    }
}

export interface IJuridicalPersonInfoDto {
    id: number;
    name: string | undefined;
    tradeName: string | undefined;
    currencySymbol: string | undefined;
    capitalAmount: string | undefined;
    shareholding: string | undefined;
    companyRole: string | undefined;
    companyRoleCode: string | undefined;
    workActivity: string | undefined;
    nominalValue: string | undefined;
    socialAmount: string | undefined;
    integratedAmount: string | undefined;
    position: string | undefined;
    globalControl: number | undefined;
    capitalAmountNumber: number | undefined;
    socialAmountNumber: number | undefined;
    nominalValueNumber: number | undefined;
    integratedAmountNumber: number | undefined;
    shareholdingNumber: number | undefined;
}

export class LibraryFileDto implements ILibraryFileDto {
    id: number;
    libraryFileOwnerId: number | undefined;
    libraryConfigurationId: number | undefined;
    libraryConfigurationKindId: number | undefined;
    parentId: number | undefined;
    libraryFileTypeId: number;
    isVisble: boolean;
    isChecked: boolean;
    isShared: boolean;
    name: string | undefined;
    mime: string | undefined;
    guid: string;
    fullNameExtension: string | undefined;
    childs: LibraryFileDto[] | undefined;
    isPersonalFolder: boolean;
    isUploaderSpace: boolean;
    isJP: boolean;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    size: number;
    userId: number | undefined;
    user: UserDto;

    constructor(data?: ILibraryFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libraryFileOwnerId = _data["libraryFileOwnerId"];
            this.libraryConfigurationId = _data["libraryConfigurationId"];
            this.libraryConfigurationKindId = _data["libraryConfigurationKindId"];
            this.parentId = _data["parentId"];
            this.libraryFileTypeId = _data["libraryFileTypeId"];
            this.isVisble = _data["isVisble"];
            this.isChecked = _data["isChecked"];
            this.isShared = _data["isShared"];
            this.name = _data["name"];
            this.mime = _data["mime"];
            this.guid = _data["guid"];
            this.fullNameExtension = _data["fullNameExtension"];
            if (Array.isArray(_data["childs"])) {
                this.childs = [] as any;
                for (let item of _data["childs"])
                    this.childs.push(LibraryFileDto.fromJS(item));
            }
            this.isPersonalFolder = _data["isPersonalFolder"];
            this.isUploaderSpace = _data["isUploaderSpace"];
            this.isJP = _data["isJP"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.size = _data["size"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LibraryFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new LibraryFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libraryFileOwnerId"] = this.libraryFileOwnerId;
        data["libraryConfigurationId"] = this.libraryConfigurationId;
        data["libraryConfigurationKindId"] = this.libraryConfigurationKindId;
        data["parentId"] = this.parentId;
        data["libraryFileTypeId"] = this.libraryFileTypeId;
        data["isVisble"] = this.isVisble;
        data["isChecked"] = this.isChecked;
        data["isShared"] = this.isShared;
        data["name"] = this.name;
        data["mime"] = this.mime;
        data["guid"] = this.guid;
        data["fullNameExtension"] = this.fullNameExtension;
        if (Array.isArray(this.childs)) {
            data["childs"] = [];
            for (let item of this.childs)
                data["childs"].push(item.toJSON());
        }
        data["isPersonalFolder"] = this.isPersonalFolder;
        data["isUploaderSpace"] = this.isUploaderSpace;
        data["isJP"] = this.isJP;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["size"] = this.size;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }

    clone(): LibraryFileDto {
        const json = this.toJSON();
        let result = new LibraryFileDto();
        result.init(json);
        return result;
    }
}

export interface ILibraryFileDto {
    id: number;
    libraryFileOwnerId: number | undefined;
    libraryConfigurationId: number | undefined;
    libraryConfigurationKindId: number | undefined;
    parentId: number | undefined;
    libraryFileTypeId: number;
    isVisble: boolean;
    isChecked: boolean;
    isShared: boolean;
    name: string | undefined;
    mime: string | undefined;
    guid: string;
    fullNameExtension: string | undefined;
    childs: LibraryFileDto[] | undefined;
    isPersonalFolder: boolean;
    isUploaderSpace: boolean;
    isJP: boolean;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    size: number;
    userId: number | undefined;
    user: UserDto;
}

export class LibraryFileOwnerDto implements ILibraryFileOwnerDto {
    id: number;
    companyId: number | undefined;
    company: CompanyDto;
    juridicalPersonId: number | undefined;
    juridicalPerson: CompanyDto;
    naturalPersonId: number | undefined;
    naturalPerson: NaturalPersonDto;
    libraryFiles: LibraryFileDto[] | undefined;

    constructor(data?: ILibraryFileOwnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.juridicalPersonId = _data["juridicalPersonId"];
            this.juridicalPerson = _data["juridicalPerson"] ? CompanyDto.fromJS(_data["juridicalPerson"]) : <any>undefined;
            this.naturalPersonId = _data["naturalPersonId"];
            this.naturalPerson = _data["naturalPerson"] ? NaturalPersonDto.fromJS(_data["naturalPerson"]) : <any>undefined;
            if (Array.isArray(_data["libraryFiles"])) {
                this.libraryFiles = [] as any;
                for (let item of _data["libraryFiles"])
                    this.libraryFiles.push(LibraryFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LibraryFileOwnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new LibraryFileOwnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["juridicalPersonId"] = this.juridicalPersonId;
        data["juridicalPerson"] = this.juridicalPerson ? this.juridicalPerson.toJSON() : <any>undefined;
        data["naturalPersonId"] = this.naturalPersonId;
        data["naturalPerson"] = this.naturalPerson ? this.naturalPerson.toJSON() : <any>undefined;
        if (Array.isArray(this.libraryFiles)) {
            data["libraryFiles"] = [];
            for (let item of this.libraryFiles)
                data["libraryFiles"].push(item.toJSON());
        }
        return data;
    }

    clone(): LibraryFileOwnerDto {
        const json = this.toJSON();
        let result = new LibraryFileOwnerDto();
        result.init(json);
        return result;
    }
}

export interface ILibraryFileOwnerDto {
    id: number;
    companyId: number | undefined;
    company: CompanyDto;
    juridicalPersonId: number | undefined;
    juridicalPerson: CompanyDto;
    naturalPersonId: number | undefined;
    naturalPerson: NaturalPersonDto;
    libraryFiles: LibraryFileDto[] | undefined;
}

export class Location implements ILocation {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
    countryId: number;
    country: Country;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
            this.countryId = _data["countryId"];
            this.country = _data["country"] ? Country.fromJS(_data["country"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        data["countryId"] = this.countryId;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        return data;
    }

    clone(): Location {
        const json = this.toJSON();
        let result = new Location();
        result.init(json);
        return result;
    }
}

export interface ILocation {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
    countryId: number;
    country: Country;
}

export class LocationDto implements ILocationDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
    countryId: number;
    country: CountryDto;

    constructor(data?: ILocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
            this.countryId = _data["countryId"];
            this.country = _data["country"] ? CountryDto.fromJS(_data["country"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        data["countryId"] = this.countryId;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        return data;
    }

    clone(): LocationDto {
        const json = this.toJSON();
        let result = new LocationDto();
        result.init(json);
        return result;
    }
}

export interface ILocationDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
    countryId: number;
    country: CountryDto;
}

export class LocationDtoPagedResultDto implements ILocationDtoPagedResultDto {
    items: LocationDto[] | undefined;
    totalCount: number;

    constructor(data?: ILocationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LocationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): LocationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): LocationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new LocationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ILocationDtoPagedResultDto {
    items: LocationDto[] | undefined;
    totalCount: number;
}

export class MaritalStatus implements IMaritalStatus {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;

    constructor(data?: IMaritalStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
        }
    }

    static fromJS(data: any): MaritalStatus {
        data = typeof data === 'object' ? data : {};
        let result = new MaritalStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        return data;
    }

    clone(): MaritalStatus {
        const json = this.toJSON();
        let result = new MaritalStatus();
        result.init(json);
        return result;
    }
}

export interface IMaritalStatus {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
}

export class MaritalStatusDto implements IMaritalStatusDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;

    constructor(data?: IMaritalStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
        }
    }

    static fromJS(data: any): MaritalStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaritalStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        return data;
    }

    clone(): MaritalStatusDto {
        const json = this.toJSON();
        let result = new MaritalStatusDto();
        result.init(json);
        return result;
    }
}

export interface IMaritalStatusDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
}

export class MaritalStatusDtoPagedResultDto implements IMaritalStatusDtoPagedResultDto {
    items: MaritalStatusDto[] | undefined;
    totalCount: number;

    constructor(data?: IMaritalStatusDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(MaritalStatusDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MaritalStatusDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaritalStatusDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MaritalStatusDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MaritalStatusDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMaritalStatusDtoPagedResultDto {
    items: MaritalStatusDto[] | undefined;
    totalCount: number;
}

export class MarriageRegime implements IMarriageRegime {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;

    constructor(data?: IMarriageRegime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
        }
    }

    static fromJS(data: any): MarriageRegime {
        data = typeof data === 'object' ? data : {};
        let result = new MarriageRegime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        return data;
    }

    clone(): MarriageRegime {
        const json = this.toJSON();
        let result = new MarriageRegime();
        result.init(json);
        return result;
    }
}

export interface IMarriageRegime {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
}

export class MarriageRegimeDto implements IMarriageRegimeDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;

    constructor(data?: IMarriageRegimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
        }
    }

    static fromJS(data: any): MarriageRegimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarriageRegimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        return data;
    }

    clone(): MarriageRegimeDto {
        const json = this.toJSON();
        let result = new MarriageRegimeDto();
        result.init(json);
        return result;
    }
}

export interface IMarriageRegimeDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
}

export class MarriageRegimeDtoPagedResultDto implements IMarriageRegimeDtoPagedResultDto {
    items: MarriageRegimeDto[] | undefined;
    totalCount: number;

    constructor(data?: IMarriageRegimeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(MarriageRegimeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MarriageRegimeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarriageRegimeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MarriageRegimeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MarriageRegimeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMarriageRegimeDtoPagedResultDto {
    items: MarriageRegimeDto[] | undefined;
    totalCount: number;
}

export class MigrateCompaniesDto implements IMigrateCompaniesDto {
    selectedCompaniesIds: number[] | undefined;
    selectedTenantId: number;

    constructor(data?: IMigrateCompaniesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["selectedCompaniesIds"])) {
                this.selectedCompaniesIds = [] as any;
                for (let item of _data["selectedCompaniesIds"])
                    this.selectedCompaniesIds.push(item);
            }
            this.selectedTenantId = _data["selectedTenantId"];
        }
    }

    static fromJS(data: any): MigrateCompaniesDto {
        data = typeof data === 'object' ? data : {};
        let result = new MigrateCompaniesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectedCompaniesIds)) {
            data["selectedCompaniesIds"] = [];
            for (let item of this.selectedCompaniesIds)
                data["selectedCompaniesIds"].push(item);
        }
        data["selectedTenantId"] = this.selectedTenantId;
        return data;
    }

    clone(): MigrateCompaniesDto {
        const json = this.toJSON();
        let result = new MigrateCompaniesDto();
        result.init(json);
        return result;
    }
}

export interface IMigrateCompaniesDto {
    selectedCompaniesIds: number[] | undefined;
    selectedTenantId: number;
}

export class MoveLibraryItemRequestDto implements IMoveLibraryItemRequestDto {
    id: number;
    isVisible: boolean;
    libraryItem: string;
    destination: string;

    constructor(data?: IMoveLibraryItemRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isVisible = _data["isVisible"];
            this.libraryItem = _data["libraryItem"];
            this.destination = _data["destination"];
        }
    }

    static fromJS(data: any): MoveLibraryItemRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveLibraryItemRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isVisible"] = this.isVisible;
        data["libraryItem"] = this.libraryItem;
        data["destination"] = this.destination;
        return data;
    }

    clone(): MoveLibraryItemRequestDto {
        const json = this.toJSON();
        let result = new MoveLibraryItemRequestDto();
        result.init(json);
        return result;
    }
}

export interface IMoveLibraryItemRequestDto {
    id: number;
    isVisible: boolean;
    libraryItem: string;
    destination: string;
}

export class MoveLibraryItemResponseDto implements IMoveLibraryItemResponseDto {
    id: number;
    libraryItem: string;
    parentId: number | undefined;
    parentGuid: string;

    constructor(data?: IMoveLibraryItemResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libraryItem = _data["libraryItem"];
            this.parentId = _data["parentId"];
            this.parentGuid = _data["parentGuid"];
        }
    }

    static fromJS(data: any): MoveLibraryItemResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveLibraryItemResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libraryItem"] = this.libraryItem;
        data["parentId"] = this.parentId;
        data["parentGuid"] = this.parentGuid;
        return data;
    }

    clone(): MoveLibraryItemResponseDto {
        const json = this.toJSON();
        let result = new MoveLibraryItemResponseDto();
        result.init(json);
        return result;
    }
}

export interface IMoveLibraryItemResponseDto {
    id: number;
    libraryItem: string;
    parentId: number | undefined;
    parentGuid: string;
}

export class Nationality implements INationality {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
    isoAlpha2Code: string | undefined;
    isoAlpha3Code: string | undefined;
    isounCode: string | undefined;

    constructor(data?: INationality) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
            this.isoAlpha2Code = _data["isoAlpha2Code"];
            this.isoAlpha3Code = _data["isoAlpha3Code"];
            this.isounCode = _data["isounCode"];
        }
    }

    static fromJS(data: any): Nationality {
        data = typeof data === 'object' ? data : {};
        let result = new Nationality();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        data["isoAlpha2Code"] = this.isoAlpha2Code;
        data["isoAlpha3Code"] = this.isoAlpha3Code;
        data["isounCode"] = this.isounCode;
        return data;
    }

    clone(): Nationality {
        const json = this.toJSON();
        let result = new Nationality();
        result.init(json);
        return result;
    }
}

export interface INationality {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
    isoAlpha2Code: string | undefined;
    isoAlpha3Code: string | undefined;
    isounCode: string | undefined;
}

export class NationalityDto implements INationalityDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
    isoAlpha2Code: string;
    isoAlpha3Code: string;
    isounCode: string;

    constructor(data?: INationalityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
            this.isoAlpha2Code = _data["isoAlpha2Code"];
            this.isoAlpha3Code = _data["isoAlpha3Code"];
            this.isounCode = _data["isounCode"];
        }
    }

    static fromJS(data: any): NationalityDto {
        data = typeof data === 'object' ? data : {};
        let result = new NationalityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        data["isoAlpha2Code"] = this.isoAlpha2Code;
        data["isoAlpha3Code"] = this.isoAlpha3Code;
        data["isounCode"] = this.isounCode;
        return data;
    }

    clone(): NationalityDto {
        const json = this.toJSON();
        let result = new NationalityDto();
        result.init(json);
        return result;
    }
}

export interface INationalityDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
    isoAlpha2Code: string;
    isoAlpha3Code: string;
    isounCode: string;
}

export class NationalityDtoPagedResultDto implements INationalityDtoPagedResultDto {
    items: NationalityDto[] | undefined;
    totalCount: number;

    constructor(data?: INationalityDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(NationalityDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): NationalityDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NationalityDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): NationalityDtoPagedResultDto {
        const json = this.toJSON();
        let result = new NationalityDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface INationalityDtoPagedResultDto {
    items: NationalityDto[] | undefined;
    totalCount: number;
}

export class NaturalPerson implements INaturalPerson {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    tenant: Tenant;
    emailAddress: string | undefined;
    personCompanyRoleData: PersonCompanyRoleData[] | undefined;
    names: string | undefined;
    surnames: string | undefined;
    identificationDocumentId: number | undefined;
    identificationDocument: IdentificationDocument;
    birthdate: moment.Moment | undefined;
    nationalityId: number | undefined;
    nationality: Nationality;
    countryId: number | undefined;
    residenceCountry: Country;
    occupationId: number | undefined;
    occupation: Occupation;
    occupationOther: string | undefined;
    maritalStatusId: number | undefined;
    maritalStatus: MaritalStatus;
    nuptialsId: number | undefined;
    nuptials: Nuptials;
    marriageRegimeId: number | undefined;
    marriageRegime: MarriageRegime;
    spouseId: number | undefined;
    spouse: Spouse;
    addressId: number | undefined;
    address: Address;
    contactId: number | undefined;
    contact: Contact;
    politicallyExposedPerson: boolean | undefined;

    constructor(data?: INaturalPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.emailAddress = _data["emailAddress"];
            if (Array.isArray(_data["personCompanyRoleData"])) {
                this.personCompanyRoleData = [] as any;
                for (let item of _data["personCompanyRoleData"])
                    this.personCompanyRoleData.push(PersonCompanyRoleData.fromJS(item));
            }
            this.names = _data["names"];
            this.surnames = _data["surnames"];
            this.identificationDocumentId = _data["identificationDocumentId"];
            this.identificationDocument = _data["identificationDocument"] ? IdentificationDocument.fromJS(_data["identificationDocument"]) : <any>undefined;
            this.birthdate = _data["birthdate"] ? moment(_data["birthdate"].toString()) : <any>undefined;
            this.nationalityId = _data["nationalityId"];
            this.nationality = _data["nationality"] ? Nationality.fromJS(_data["nationality"]) : <any>undefined;
            this.countryId = _data["countryId"];
            this.residenceCountry = _data["residenceCountry"] ? Country.fromJS(_data["residenceCountry"]) : <any>undefined;
            this.occupationId = _data["occupationId"];
            this.occupation = _data["occupation"] ? Occupation.fromJS(_data["occupation"]) : <any>undefined;
            this.occupationOther = _data["occupationOther"];
            this.maritalStatusId = _data["maritalStatusId"];
            this.maritalStatus = _data["maritalStatus"] ? MaritalStatus.fromJS(_data["maritalStatus"]) : <any>undefined;
            this.nuptialsId = _data["nuptialsId"];
            this.nuptials = _data["nuptials"] ? Nuptials.fromJS(_data["nuptials"]) : <any>undefined;
            this.marriageRegimeId = _data["marriageRegimeId"];
            this.marriageRegime = _data["marriageRegime"] ? MarriageRegime.fromJS(_data["marriageRegime"]) : <any>undefined;
            this.spouseId = _data["spouseId"];
            this.spouse = _data["spouse"] ? Spouse.fromJS(_data["spouse"]) : <any>undefined;
            this.addressId = _data["addressId"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.contactId = _data["contactId"];
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : <any>undefined;
            this.politicallyExposedPerson = _data["politicallyExposedPerson"];
        }
    }

    static fromJS(data: any): NaturalPerson {
        data = typeof data === 'object' ? data : {};
        let result = new NaturalPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        if (Array.isArray(this.personCompanyRoleData)) {
            data["personCompanyRoleData"] = [];
            for (let item of this.personCompanyRoleData)
                data["personCompanyRoleData"].push(item.toJSON());
        }
        data["names"] = this.names;
        data["surnames"] = this.surnames;
        data["identificationDocumentId"] = this.identificationDocumentId;
        data["identificationDocument"] = this.identificationDocument ? this.identificationDocument.toJSON() : <any>undefined;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : <any>undefined;
        data["nationalityId"] = this.nationalityId;
        data["nationality"] = this.nationality ? this.nationality.toJSON() : <any>undefined;
        data["countryId"] = this.countryId;
        data["residenceCountry"] = this.residenceCountry ? this.residenceCountry.toJSON() : <any>undefined;
        data["occupationId"] = this.occupationId;
        data["occupation"] = this.occupation ? this.occupation.toJSON() : <any>undefined;
        data["occupationOther"] = this.occupationOther;
        data["maritalStatusId"] = this.maritalStatusId;
        data["maritalStatus"] = this.maritalStatus ? this.maritalStatus.toJSON() : <any>undefined;
        data["nuptialsId"] = this.nuptialsId;
        data["nuptials"] = this.nuptials ? this.nuptials.toJSON() : <any>undefined;
        data["marriageRegimeId"] = this.marriageRegimeId;
        data["marriageRegime"] = this.marriageRegime ? this.marriageRegime.toJSON() : <any>undefined;
        data["spouseId"] = this.spouseId;
        data["spouse"] = this.spouse ? this.spouse.toJSON() : <any>undefined;
        data["addressId"] = this.addressId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["contactId"] = this.contactId;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["politicallyExposedPerson"] = this.politicallyExposedPerson;
        return data;
    }

    clone(): NaturalPerson {
        const json = this.toJSON();
        let result = new NaturalPerson();
        result.init(json);
        return result;
    }
}

export interface INaturalPerson {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    tenant: Tenant;
    emailAddress: string | undefined;
    personCompanyRoleData: PersonCompanyRoleData[] | undefined;
    names: string | undefined;
    surnames: string | undefined;
    identificationDocumentId: number | undefined;
    identificationDocument: IdentificationDocument;
    birthdate: moment.Moment | undefined;
    nationalityId: number | undefined;
    nationality: Nationality;
    countryId: number | undefined;
    residenceCountry: Country;
    occupationId: number | undefined;
    occupation: Occupation;
    occupationOther: string | undefined;
    maritalStatusId: number | undefined;
    maritalStatus: MaritalStatus;
    nuptialsId: number | undefined;
    nuptials: Nuptials;
    marriageRegimeId: number | undefined;
    marriageRegime: MarriageRegime;
    spouseId: number | undefined;
    spouse: Spouse;
    addressId: number | undefined;
    address: Address;
    contactId: number | undefined;
    contact: Contact;
    politicallyExposedPerson: boolean | undefined;
}

export class NaturalPersonDto implements INaturalPersonDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    tenant: TenantDto;
    emailAddress: string | undefined;
    personCompanyRoleData: PersonCompanyRoleDataDto[] | undefined;
    names: string;
    surnames: string;
    fullName: string | undefined;
    identificationDocumentId: number | undefined;
    identificationDocument: IdentificationDocumentDto;
    birthdate: moment.Moment | undefined;
    nationalityId: number | undefined;
    nationalityName: string | undefined;
    countryId: number | undefined;
    residenceCountryName: string | undefined;
    occupationId: number | undefined;
    occupationName: string | undefined;
    occupationOther: string | undefined;
    maritalStatusId: number | undefined;
    maritalStatusName: string | undefined;
    nuptialsId: number | undefined;
    nuptialsName: string | undefined;
    marriageRegimeId: number | undefined;
    marriageRegimeName: string | undefined;
    spouseId: number | undefined;
    spouse: SpouseDto;
    addressId: number | undefined;
    address: AddressDto;
    contactId: number | undefined;
    contact: ContactDto;
    phoneNumber: string | undefined;
    politicallyExposedPerson: boolean | undefined;
    companies: string[] | undefined;
    haveExternalUser: boolean;
    isInitiallyExternalUser: boolean;
    hasRelations: boolean;
    naturalPersonCopy: NaturalPersonDto;

    constructor(data?: INaturalPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? TenantDto.fromJS(_data["tenant"]) : <any>undefined;
            this.emailAddress = _data["emailAddress"];
            if (Array.isArray(_data["personCompanyRoleData"])) {
                this.personCompanyRoleData = [] as any;
                for (let item of _data["personCompanyRoleData"])
                    this.personCompanyRoleData.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            this.names = _data["names"];
            this.surnames = _data["surnames"];
            this.fullName = _data["fullName"];
            this.identificationDocumentId = _data["identificationDocumentId"];
            this.identificationDocument = _data["identificationDocument"] ? IdentificationDocumentDto.fromJS(_data["identificationDocument"]) : <any>undefined;
            this.birthdate = _data["birthdate"] ? moment(_data["birthdate"].toString()) : <any>undefined;
            this.nationalityId = _data["nationalityId"];
            this.nationalityName = _data["nationalityName"];
            this.countryId = _data["countryId"];
            this.residenceCountryName = _data["residenceCountryName"];
            this.occupationId = _data["occupationId"];
            this.occupationName = _data["occupationName"];
            this.occupationOther = _data["occupationOther"];
            this.maritalStatusId = _data["maritalStatusId"];
            this.maritalStatusName = _data["maritalStatusName"];
            this.nuptialsId = _data["nuptialsId"];
            this.nuptialsName = _data["nuptialsName"];
            this.marriageRegimeId = _data["marriageRegimeId"];
            this.marriageRegimeName = _data["marriageRegimeName"];
            this.spouseId = _data["spouseId"];
            this.spouse = _data["spouse"] ? SpouseDto.fromJS(_data["spouse"]) : <any>undefined;
            this.addressId = _data["addressId"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            this.contactId = _data["contactId"];
            this.contact = _data["contact"] ? ContactDto.fromJS(_data["contact"]) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.politicallyExposedPerson = _data["politicallyExposedPerson"];
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies.push(item);
            }
            this.haveExternalUser = _data["haveExternalUser"];
            this.isInitiallyExternalUser = _data["isInitiallyExternalUser"];
            this.hasRelations = _data["hasRelations"];
            this.naturalPersonCopy = _data["naturalPersonCopy"] ? NaturalPersonDto.fromJS(_data["naturalPersonCopy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NaturalPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new NaturalPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        if (Array.isArray(this.personCompanyRoleData)) {
            data["personCompanyRoleData"] = [];
            for (let item of this.personCompanyRoleData)
                data["personCompanyRoleData"].push(item.toJSON());
        }
        data["names"] = this.names;
        data["surnames"] = this.surnames;
        data["fullName"] = this.fullName;
        data["identificationDocumentId"] = this.identificationDocumentId;
        data["identificationDocument"] = this.identificationDocument ? this.identificationDocument.toJSON() : <any>undefined;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : <any>undefined;
        data["nationalityId"] = this.nationalityId;
        data["nationalityName"] = this.nationalityName;
        data["countryId"] = this.countryId;
        data["residenceCountryName"] = this.residenceCountryName;
        data["occupationId"] = this.occupationId;
        data["occupationName"] = this.occupationName;
        data["occupationOther"] = this.occupationOther;
        data["maritalStatusId"] = this.maritalStatusId;
        data["maritalStatusName"] = this.maritalStatusName;
        data["nuptialsId"] = this.nuptialsId;
        data["nuptialsName"] = this.nuptialsName;
        data["marriageRegimeId"] = this.marriageRegimeId;
        data["marriageRegimeName"] = this.marriageRegimeName;
        data["spouseId"] = this.spouseId;
        data["spouse"] = this.spouse ? this.spouse.toJSON() : <any>undefined;
        data["addressId"] = this.addressId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["contactId"] = this.contactId;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["politicallyExposedPerson"] = this.politicallyExposedPerson;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item);
        }
        data["haveExternalUser"] = this.haveExternalUser;
        data["isInitiallyExternalUser"] = this.isInitiallyExternalUser;
        data["hasRelations"] = this.hasRelations;
        data["naturalPersonCopy"] = this.naturalPersonCopy ? this.naturalPersonCopy.toJSON() : <any>undefined;
        return data;
    }

    clone(): NaturalPersonDto {
        const json = this.toJSON();
        let result = new NaturalPersonDto();
        result.init(json);
        return result;
    }
}

export interface INaturalPersonDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    tenant: TenantDto;
    emailAddress: string | undefined;
    personCompanyRoleData: PersonCompanyRoleDataDto[] | undefined;
    names: string;
    surnames: string;
    fullName: string | undefined;
    identificationDocumentId: number | undefined;
    identificationDocument: IdentificationDocumentDto;
    birthdate: moment.Moment | undefined;
    nationalityId: number | undefined;
    nationalityName: string | undefined;
    countryId: number | undefined;
    residenceCountryName: string | undefined;
    occupationId: number | undefined;
    occupationName: string | undefined;
    occupationOther: string | undefined;
    maritalStatusId: number | undefined;
    maritalStatusName: string | undefined;
    nuptialsId: number | undefined;
    nuptialsName: string | undefined;
    marriageRegimeId: number | undefined;
    marriageRegimeName: string | undefined;
    spouseId: number | undefined;
    spouse: SpouseDto;
    addressId: number | undefined;
    address: AddressDto;
    contactId: number | undefined;
    contact: ContactDto;
    phoneNumber: string | undefined;
    politicallyExposedPerson: boolean | undefined;
    companies: string[] | undefined;
    haveExternalUser: boolean;
    isInitiallyExternalUser: boolean;
    hasRelations: boolean;
    naturalPersonCopy: NaturalPersonDto;
}

export class NaturalPersonDtoPagedResultDto implements INaturalPersonDtoPagedResultDto {
    items: NaturalPersonDto[] | undefined;
    totalCount: number;

    constructor(data?: INaturalPersonDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(NaturalPersonDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): NaturalPersonDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NaturalPersonDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): NaturalPersonDtoPagedResultDto {
        const json = this.toJSON();
        let result = new NaturalPersonDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface INaturalPersonDtoPagedResultDto {
    items: NaturalPersonDto[] | undefined;
    totalCount: number;
}

export class NaturalPersonInfoDto implements INaturalPersonInfoDto {
    id: number;
    fullName: string | undefined;
    nationalityName: string | undefined;
    residenceCountryName: string | undefined;
    companyRole: string | undefined;
    companyRoleCode: string | undefined;
    shareholding: string | undefined;
    ocupation: string | undefined;
    nominalValue: string | undefined;
    position: string | undefined;
    isFinalBeneficary: boolean;
    globalControl: number | undefined;
    nominalValueNumber: number | undefined;
    shareholdingNumber: number | undefined;

    constructor(data?: INaturalPersonInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.nationalityName = _data["nationalityName"];
            this.residenceCountryName = _data["residenceCountryName"];
            this.companyRole = _data["companyRole"];
            this.companyRoleCode = _data["companyRoleCode"];
            this.shareholding = _data["shareholding"];
            this.ocupation = _data["ocupation"];
            this.nominalValue = _data["nominalValue"];
            this.position = _data["position"];
            this.isFinalBeneficary = _data["isFinalBeneficary"];
            this.globalControl = _data["globalControl"];
            this.nominalValueNumber = _data["nominalValueNumber"];
            this.shareholdingNumber = _data["shareholdingNumber"];
        }
    }

    static fromJS(data: any): NaturalPersonInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new NaturalPersonInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["nationalityName"] = this.nationalityName;
        data["residenceCountryName"] = this.residenceCountryName;
        data["companyRole"] = this.companyRole;
        data["companyRoleCode"] = this.companyRoleCode;
        data["shareholding"] = this.shareholding;
        data["ocupation"] = this.ocupation;
        data["nominalValue"] = this.nominalValue;
        data["position"] = this.position;
        data["isFinalBeneficary"] = this.isFinalBeneficary;
        data["globalControl"] = this.globalControl;
        data["nominalValueNumber"] = this.nominalValueNumber;
        data["shareholdingNumber"] = this.shareholdingNumber;
        return data;
    }

    clone(): NaturalPersonInfoDto {
        const json = this.toJSON();
        let result = new NaturalPersonInfoDto();
        result.init(json);
        return result;
    }
}

export interface INaturalPersonInfoDto {
    id: number;
    fullName: string | undefined;
    nationalityName: string | undefined;
    residenceCountryName: string | undefined;
    companyRole: string | undefined;
    companyRoleCode: string | undefined;
    shareholding: string | undefined;
    ocupation: string | undefined;
    nominalValue: string | undefined;
    position: string | undefined;
    isFinalBeneficary: boolean;
    globalControl: number | undefined;
    nominalValueNumber: number | undefined;
    shareholdingNumber: number | undefined;
}

export class NodeMapDto implements INodeMapDto {
    nationalityFlag: string | undefined;
    naturalPersonInfo: NaturalPersonInfoDto;
    juridicalPersonInfo: JuridicalPersonInfoDto;
    childs: NodeMapDto[] | undefined;
    depth: number;

    constructor(data?: INodeMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nationalityFlag = _data["nationalityFlag"];
            this.naturalPersonInfo = _data["naturalPersonInfo"] ? NaturalPersonInfoDto.fromJS(_data["naturalPersonInfo"]) : <any>undefined;
            this.juridicalPersonInfo = _data["juridicalPersonInfo"] ? JuridicalPersonInfoDto.fromJS(_data["juridicalPersonInfo"]) : <any>undefined;
            if (Array.isArray(_data["childs"])) {
                this.childs = [] as any;
                for (let item of _data["childs"])
                    this.childs.push(NodeMapDto.fromJS(item));
            }
            this.depth = _data["depth"];
        }
    }

    static fromJS(data: any): NodeMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new NodeMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nationalityFlag"] = this.nationalityFlag;
        data["naturalPersonInfo"] = this.naturalPersonInfo ? this.naturalPersonInfo.toJSON() : <any>undefined;
        data["juridicalPersonInfo"] = this.juridicalPersonInfo ? this.juridicalPersonInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.childs)) {
            data["childs"] = [];
            for (let item of this.childs)
                data["childs"].push(item.toJSON());
        }
        data["depth"] = this.depth;
        return data;
    }

    clone(): NodeMapDto {
        const json = this.toJSON();
        let result = new NodeMapDto();
        result.init(json);
        return result;
    }
}

export interface INodeMapDto {
    nationalityFlag: string | undefined;
    naturalPersonInfo: NaturalPersonInfoDto;
    juridicalPersonInfo: JuridicalPersonInfoDto;
    childs: NodeMapDto[] | undefined;
    depth: number;
}

export enum NotificationChannelEnum {
    _0 = 0,
    _1 = 1,
}

export class NotificationTypeDto implements INotificationTypeDto {
    id: number;
    localizationKeyName: string | undefined;
    details: string | undefined;
    general: boolean;
    showInSettings: boolean;
    showDaysInAdvance: boolean;

    constructor(data?: INotificationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.localizationKeyName = _data["localizationKeyName"];
            this.details = _data["details"];
            this.general = _data["general"];
            this.showInSettings = _data["showInSettings"];
            this.showDaysInAdvance = _data["showDaysInAdvance"];
        }
    }

    static fromJS(data: any): NotificationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["localizationKeyName"] = this.localizationKeyName;
        data["details"] = this.details;
        data["general"] = this.general;
        data["showInSettings"] = this.showInSettings;
        data["showDaysInAdvance"] = this.showDaysInAdvance;
        return data;
    }

    clone(): NotificationTypeDto {
        const json = this.toJSON();
        let result = new NotificationTypeDto();
        result.init(json);
        return result;
    }
}

export interface INotificationTypeDto {
    id: number;
    localizationKeyName: string | undefined;
    details: string | undefined;
    general: boolean;
    showInSettings: boolean;
    showDaysInAdvance: boolean;
}

export enum NotificationTypeEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _14 = 14,
    _15 = 15,
    _16 = 16,
    _17 = 17,
    _18 = 18,
    _19 = 19,
}

export class Nuptials implements INuptials {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;

    constructor(data?: INuptials) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
        }
    }

    static fromJS(data: any): Nuptials {
        data = typeof data === 'object' ? data : {};
        let result = new Nuptials();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        return data;
    }

    clone(): Nuptials {
        const json = this.toJSON();
        let result = new Nuptials();
        result.init(json);
        return result;
    }
}

export interface INuptials {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
}

export class NuptialsDto implements INuptialsDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;

    constructor(data?: INuptialsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
        }
    }

    static fromJS(data: any): NuptialsDto {
        data = typeof data === 'object' ? data : {};
        let result = new NuptialsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        return data;
    }

    clone(): NuptialsDto {
        const json = this.toJSON();
        let result = new NuptialsDto();
        result.init(json);
        return result;
    }
}

export interface INuptialsDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
}

export class NuptialsDtoPagedResultDto implements INuptialsDtoPagedResultDto {
    items: NuptialsDto[] | undefined;
    totalCount: number;

    constructor(data?: INuptialsDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(NuptialsDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): NuptialsDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NuptialsDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): NuptialsDtoPagedResultDto {
        const json = this.toJSON();
        let result = new NuptialsDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface INuptialsDtoPagedResultDto {
    items: NuptialsDto[] | undefined;
    totalCount: number;
}

export class Occupation implements IOccupation {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;

    constructor(data?: IOccupation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
        }
    }

    static fromJS(data: any): Occupation {
        data = typeof data === 'object' ? data : {};
        let result = new Occupation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        return data;
    }

    clone(): Occupation {
        const json = this.toJSON();
        let result = new Occupation();
        result.init(json);
        return result;
    }
}

export interface IOccupation {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
}

export class OccupationDto implements IOccupationDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;

    constructor(data?: IOccupationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
        }
    }

    static fromJS(data: any): OccupationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OccupationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        return data;
    }

    clone(): OccupationDto {
        const json = this.toJSON();
        let result = new OccupationDto();
        result.init(json);
        return result;
    }
}

export interface IOccupationDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
}

export class OccupationDtoPagedResultDto implements IOccupationDtoPagedResultDto {
    items: OccupationDto[] | undefined;
    totalCount: number;

    constructor(data?: IOccupationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OccupationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): OccupationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OccupationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): OccupationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OccupationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOccupationDtoPagedResultDto {
    items: OccupationDto[] | undefined;
    totalCount: number;
}

export enum OrderDirectionEnum {
    _0 = 0,
    _1 = 1,
}

export class PermissionDto implements IPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class PermissionDtoListResultDto implements IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;

    constructor(data?: IPermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PermissionDtoListResultDto {
        const json = this.toJSON();
        let result = new PermissionDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;
}

export class PersonCompanyAssetDataDto implements IPersonCompanyAssetDataDto {
    id: number;
    assetId: number;
    companyId: number | undefined;
    company: CompanyDto;
    naturalPersonId: number | undefined;
    naturalPerson: NaturalPersonDto;
    juridicalPersonId: number | undefined;
    juridicalPerson: CompanyDto;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    showEndDate: boolean;
    endDateString: string | undefined;
    participationPercentage: number;
    participationValue: number;
    guid: string;
    relatedPersonCompanyAssetDataGuid: string | undefined;

    constructor(data?: IPersonCompanyAssetDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assetId = _data["assetId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.naturalPersonId = _data["naturalPersonId"];
            this.naturalPerson = _data["naturalPerson"] ? NaturalPersonDto.fromJS(_data["naturalPerson"]) : <any>undefined;
            this.juridicalPersonId = _data["juridicalPersonId"];
            this.juridicalPerson = _data["juridicalPerson"] ? CompanyDto.fromJS(_data["juridicalPerson"]) : <any>undefined;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.showEndDate = _data["showEndDate"];
            this.endDateString = _data["endDateString"];
            this.participationPercentage = _data["participationPercentage"];
            this.participationValue = _data["participationValue"];
            this.guid = _data["guid"];
            this.relatedPersonCompanyAssetDataGuid = _data["relatedPersonCompanyAssetDataGuid"];
        }
    }

    static fromJS(data: any): PersonCompanyAssetDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonCompanyAssetDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assetId"] = this.assetId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["naturalPersonId"] = this.naturalPersonId;
        data["naturalPerson"] = this.naturalPerson ? this.naturalPerson.toJSON() : <any>undefined;
        data["juridicalPersonId"] = this.juridicalPersonId;
        data["juridicalPerson"] = this.juridicalPerson ? this.juridicalPerson.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["showEndDate"] = this.showEndDate;
        data["endDateString"] = this.endDateString;
        data["participationPercentage"] = this.participationPercentage;
        data["participationValue"] = this.participationValue;
        data["guid"] = this.guid;
        data["relatedPersonCompanyAssetDataGuid"] = this.relatedPersonCompanyAssetDataGuid;
        return data;
    }

    clone(): PersonCompanyAssetDataDto {
        const json = this.toJSON();
        let result = new PersonCompanyAssetDataDto();
        result.init(json);
        return result;
    }
}

export interface IPersonCompanyAssetDataDto {
    id: number;
    assetId: number;
    companyId: number | undefined;
    company: CompanyDto;
    naturalPersonId: number | undefined;
    naturalPerson: NaturalPersonDto;
    juridicalPersonId: number | undefined;
    juridicalPerson: CompanyDto;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    showEndDate: boolean;
    endDateString: string | undefined;
    participationPercentage: number;
    participationValue: number;
    guid: string;
    relatedPersonCompanyAssetDataGuid: string | undefined;
}

export class PersonCompanyAssetDataDtoPagedResultDto implements IPersonCompanyAssetDataDtoPagedResultDto {
    items: PersonCompanyAssetDataDto[] | undefined;
    totalCount: number;

    constructor(data?: IPersonCompanyAssetDataDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PersonCompanyAssetDataDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PersonCompanyAssetDataDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonCompanyAssetDataDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PersonCompanyAssetDataDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PersonCompanyAssetDataDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPersonCompanyAssetDataDtoPagedResultDto {
    items: PersonCompanyAssetDataDto[] | undefined;
    totalCount: number;
}

export class PersonCompanyRoleData implements IPersonCompanyRoleData {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    companyId: number;
    company: Company;
    personId: number | undefined;
    naturalPerson: NaturalPerson;
    juridicalPersonId: number | undefined;
    juridicalPerson: Company;
    relatedPersonCompanyRoleDatas: PersonCompanyRoleData[] | undefined;
    relatedPersonCompanyRoleDataId: number | undefined;
    relatedPersonCompanyRoleData: PersonCompanyRoleData;
    companyRoleId: number;
    companyRole: CompanyRole;
    positionId: number | undefined;
    position: Position;
    shareholding: number | undefined;
    nominalValue: number | undefined;
    effectiveDate: moment.Moment | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    grantDate: moment.Moment | undefined;
    revocationDate: moment.Moment | undefined;
    attorneyInFactTypeId: number | undefined;
    attorneyInFactType: AttorneyInFactType;
    attorneysInFact: boolean | undefined;
    functionalLinkId: number | undefined;
    functionalLink: FunctionalLink;
    healthInsuranceId: number | undefined;
    healthInsurance: HealthInsurance;
    finalBeneficiary: boolean | undefined;
    loadLessInfo: boolean | undefined;
    guid: string;
    globalControl: number | undefined;

    constructor(data?: IPersonCompanyRoleData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.personId = _data["personId"];
            this.naturalPerson = _data["naturalPerson"] ? NaturalPerson.fromJS(_data["naturalPerson"]) : <any>undefined;
            this.juridicalPersonId = _data["juridicalPersonId"];
            this.juridicalPerson = _data["juridicalPerson"] ? Company.fromJS(_data["juridicalPerson"]) : <any>undefined;
            if (Array.isArray(_data["relatedPersonCompanyRoleDatas"])) {
                this.relatedPersonCompanyRoleDatas = [] as any;
                for (let item of _data["relatedPersonCompanyRoleDatas"])
                    this.relatedPersonCompanyRoleDatas.push(PersonCompanyRoleData.fromJS(item));
            }
            this.relatedPersonCompanyRoleDataId = _data["relatedPersonCompanyRoleDataId"];
            this.relatedPersonCompanyRoleData = _data["relatedPersonCompanyRoleData"] ? PersonCompanyRoleData.fromJS(_data["relatedPersonCompanyRoleData"]) : <any>undefined;
            this.companyRoleId = _data["companyRoleId"];
            this.companyRole = _data["companyRole"] ? CompanyRole.fromJS(_data["companyRole"]) : <any>undefined;
            this.positionId = _data["positionId"];
            this.position = _data["position"] ? Position.fromJS(_data["position"]) : <any>undefined;
            this.shareholding = _data["shareholding"];
            this.nominalValue = _data["nominalValue"];
            this.effectiveDate = _data["effectiveDate"] ? moment(_data["effectiveDate"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.grantDate = _data["grantDate"] ? moment(_data["grantDate"].toString()) : <any>undefined;
            this.revocationDate = _data["revocationDate"] ? moment(_data["revocationDate"].toString()) : <any>undefined;
            this.attorneyInFactTypeId = _data["attorneyInFactTypeId"];
            this.attorneyInFactType = _data["attorneyInFactType"] ? AttorneyInFactType.fromJS(_data["attorneyInFactType"]) : <any>undefined;
            this.attorneysInFact = _data["attorneysInFact"];
            this.functionalLinkId = _data["functionalLinkId"];
            this.functionalLink = _data["functionalLink"] ? FunctionalLink.fromJS(_data["functionalLink"]) : <any>undefined;
            this.healthInsuranceId = _data["healthInsuranceId"];
            this.healthInsurance = _data["healthInsurance"] ? HealthInsurance.fromJS(_data["healthInsurance"]) : <any>undefined;
            this.finalBeneficiary = _data["finalBeneficiary"];
            this.loadLessInfo = _data["loadLessInfo"];
            this.guid = _data["guid"];
            this.globalControl = _data["globalControl"];
        }
    }

    static fromJS(data: any): PersonCompanyRoleData {
        data = typeof data === 'object' ? data : {};
        let result = new PersonCompanyRoleData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["personId"] = this.personId;
        data["naturalPerson"] = this.naturalPerson ? this.naturalPerson.toJSON() : <any>undefined;
        data["juridicalPersonId"] = this.juridicalPersonId;
        data["juridicalPerson"] = this.juridicalPerson ? this.juridicalPerson.toJSON() : <any>undefined;
        if (Array.isArray(this.relatedPersonCompanyRoleDatas)) {
            data["relatedPersonCompanyRoleDatas"] = [];
            for (let item of this.relatedPersonCompanyRoleDatas)
                data["relatedPersonCompanyRoleDatas"].push(item.toJSON());
        }
        data["relatedPersonCompanyRoleDataId"] = this.relatedPersonCompanyRoleDataId;
        data["relatedPersonCompanyRoleData"] = this.relatedPersonCompanyRoleData ? this.relatedPersonCompanyRoleData.toJSON() : <any>undefined;
        data["companyRoleId"] = this.companyRoleId;
        data["companyRole"] = this.companyRole ? this.companyRole.toJSON() : <any>undefined;
        data["positionId"] = this.positionId;
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        data["shareholding"] = this.shareholding;
        data["nominalValue"] = this.nominalValue;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["grantDate"] = this.grantDate ? this.grantDate.toISOString() : <any>undefined;
        data["revocationDate"] = this.revocationDate ? this.revocationDate.toISOString() : <any>undefined;
        data["attorneyInFactTypeId"] = this.attorneyInFactTypeId;
        data["attorneyInFactType"] = this.attorneyInFactType ? this.attorneyInFactType.toJSON() : <any>undefined;
        data["attorneysInFact"] = this.attorneysInFact;
        data["functionalLinkId"] = this.functionalLinkId;
        data["functionalLink"] = this.functionalLink ? this.functionalLink.toJSON() : <any>undefined;
        data["healthInsuranceId"] = this.healthInsuranceId;
        data["healthInsurance"] = this.healthInsurance ? this.healthInsurance.toJSON() : <any>undefined;
        data["finalBeneficiary"] = this.finalBeneficiary;
        data["loadLessInfo"] = this.loadLessInfo;
        data["guid"] = this.guid;
        data["globalControl"] = this.globalControl;
        return data;
    }

    clone(): PersonCompanyRoleData {
        const json = this.toJSON();
        let result = new PersonCompanyRoleData();
        result.init(json);
        return result;
    }
}

export interface IPersonCompanyRoleData {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    companyId: number;
    company: Company;
    personId: number | undefined;
    naturalPerson: NaturalPerson;
    juridicalPersonId: number | undefined;
    juridicalPerson: Company;
    relatedPersonCompanyRoleDatas: PersonCompanyRoleData[] | undefined;
    relatedPersonCompanyRoleDataId: number | undefined;
    relatedPersonCompanyRoleData: PersonCompanyRoleData;
    companyRoleId: number;
    companyRole: CompanyRole;
    positionId: number | undefined;
    position: Position;
    shareholding: number | undefined;
    nominalValue: number | undefined;
    effectiveDate: moment.Moment | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    grantDate: moment.Moment | undefined;
    revocationDate: moment.Moment | undefined;
    attorneyInFactTypeId: number | undefined;
    attorneyInFactType: AttorneyInFactType;
    attorneysInFact: boolean | undefined;
    functionalLinkId: number | undefined;
    functionalLink: FunctionalLink;
    healthInsuranceId: number | undefined;
    healthInsurance: HealthInsurance;
    finalBeneficiary: boolean | undefined;
    loadLessInfo: boolean | undefined;
    guid: string;
    globalControl: number | undefined;
}

export class PersonCompanyRoleDataDto implements IPersonCompanyRoleDataDto {
    id: number;
    companyId: number;
    naturalPersonId: number | undefined;
    naturalPerson: NaturalPersonDto;
    juridicalPersonId: number | undefined;
    juridicalPerson: CompanyDto;
    companyRoleId: number;
    companyRole: CompanyRoleDto;
    positionId: number | undefined;
    position: PositionDto;
    shareholding: number | undefined;
    nominalValue: number | undefined;
    effectiveDate: moment.Moment | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    grantDate: moment.Moment | undefined;
    revocationDate: moment.Moment | undefined;
    attorneyInFactTypeId: number | undefined;
    attorneyInFactType: AttorneyInFactTypeDto;
    attorneysInFact: boolean | undefined;
    functionalLinkId: number | undefined;
    functionalLink: FunctionalLinkDto;
    healthInsuranceId: number | undefined;
    healthInsurance: HealthInsuranceDto;
    relatedPersonCompanyRoleDatas: PersonCompanyRoleDataDto[] | undefined;
    relatedPersonCompanyRoleDataId: number | undefined;
    relatedPersonCompanyRoleDataGuid: string | undefined;
    relatedPersonCompanyRoleData: PersonCompanyRoleDataDto;
    finalBeneficiary: boolean | undefined;
    loadLessInfo: boolean | undefined;
    guid: string;
    showEndDate: boolean;
    endDateString: string | undefined;
    globalControl: number | undefined;

    constructor(data?: IPersonCompanyRoleDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.naturalPersonId = _data["naturalPersonId"];
            this.naturalPerson = _data["naturalPerson"] ? NaturalPersonDto.fromJS(_data["naturalPerson"]) : <any>undefined;
            this.juridicalPersonId = _data["juridicalPersonId"];
            this.juridicalPerson = _data["juridicalPerson"] ? CompanyDto.fromJS(_data["juridicalPerson"]) : <any>undefined;
            this.companyRoleId = _data["companyRoleId"];
            this.companyRole = _data["companyRole"] ? CompanyRoleDto.fromJS(_data["companyRole"]) : <any>undefined;
            this.positionId = _data["positionId"];
            this.position = _data["position"] ? PositionDto.fromJS(_data["position"]) : <any>undefined;
            this.shareholding = _data["shareholding"];
            this.nominalValue = _data["nominalValue"];
            this.effectiveDate = _data["effectiveDate"] ? moment(_data["effectiveDate"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.grantDate = _data["grantDate"] ? moment(_data["grantDate"].toString()) : <any>undefined;
            this.revocationDate = _data["revocationDate"] ? moment(_data["revocationDate"].toString()) : <any>undefined;
            this.attorneyInFactTypeId = _data["attorneyInFactTypeId"];
            this.attorneyInFactType = _data["attorneyInFactType"] ? AttorneyInFactTypeDto.fromJS(_data["attorneyInFactType"]) : <any>undefined;
            this.attorneysInFact = _data["attorneysInFact"];
            this.functionalLinkId = _data["functionalLinkId"];
            this.functionalLink = _data["functionalLink"] ? FunctionalLinkDto.fromJS(_data["functionalLink"]) : <any>undefined;
            this.healthInsuranceId = _data["healthInsuranceId"];
            this.healthInsurance = _data["healthInsurance"] ? HealthInsuranceDto.fromJS(_data["healthInsurance"]) : <any>undefined;
            if (Array.isArray(_data["relatedPersonCompanyRoleDatas"])) {
                this.relatedPersonCompanyRoleDatas = [] as any;
                for (let item of _data["relatedPersonCompanyRoleDatas"])
                    this.relatedPersonCompanyRoleDatas.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            this.relatedPersonCompanyRoleDataId = _data["relatedPersonCompanyRoleDataId"];
            this.relatedPersonCompanyRoleDataGuid = _data["relatedPersonCompanyRoleDataGuid"];
            this.relatedPersonCompanyRoleData = _data["relatedPersonCompanyRoleData"] ? PersonCompanyRoleDataDto.fromJS(_data["relatedPersonCompanyRoleData"]) : <any>undefined;
            this.finalBeneficiary = _data["finalBeneficiary"];
            this.loadLessInfo = _data["loadLessInfo"];
            this.guid = _data["guid"];
            this.showEndDate = _data["showEndDate"];
            this.endDateString = _data["endDateString"];
            this.globalControl = _data["globalControl"];
        }
    }

    static fromJS(data: any): PersonCompanyRoleDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonCompanyRoleDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["naturalPersonId"] = this.naturalPersonId;
        data["naturalPerson"] = this.naturalPerson ? this.naturalPerson.toJSON() : <any>undefined;
        data["juridicalPersonId"] = this.juridicalPersonId;
        data["juridicalPerson"] = this.juridicalPerson ? this.juridicalPerson.toJSON() : <any>undefined;
        data["companyRoleId"] = this.companyRoleId;
        data["companyRole"] = this.companyRole ? this.companyRole.toJSON() : <any>undefined;
        data["positionId"] = this.positionId;
        data["position"] = this.position ? this.position.toJSON() : <any>undefined;
        data["shareholding"] = this.shareholding;
        data["nominalValue"] = this.nominalValue;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["grantDate"] = this.grantDate ? this.grantDate.toISOString() : <any>undefined;
        data["revocationDate"] = this.revocationDate ? this.revocationDate.toISOString() : <any>undefined;
        data["attorneyInFactTypeId"] = this.attorneyInFactTypeId;
        data["attorneyInFactType"] = this.attorneyInFactType ? this.attorneyInFactType.toJSON() : <any>undefined;
        data["attorneysInFact"] = this.attorneysInFact;
        data["functionalLinkId"] = this.functionalLinkId;
        data["functionalLink"] = this.functionalLink ? this.functionalLink.toJSON() : <any>undefined;
        data["healthInsuranceId"] = this.healthInsuranceId;
        data["healthInsurance"] = this.healthInsurance ? this.healthInsurance.toJSON() : <any>undefined;
        if (Array.isArray(this.relatedPersonCompanyRoleDatas)) {
            data["relatedPersonCompanyRoleDatas"] = [];
            for (let item of this.relatedPersonCompanyRoleDatas)
                data["relatedPersonCompanyRoleDatas"].push(item.toJSON());
        }
        data["relatedPersonCompanyRoleDataId"] = this.relatedPersonCompanyRoleDataId;
        data["relatedPersonCompanyRoleDataGuid"] = this.relatedPersonCompanyRoleDataGuid;
        data["relatedPersonCompanyRoleData"] = this.relatedPersonCompanyRoleData ? this.relatedPersonCompanyRoleData.toJSON() : <any>undefined;
        data["finalBeneficiary"] = this.finalBeneficiary;
        data["loadLessInfo"] = this.loadLessInfo;
        data["guid"] = this.guid;
        data["showEndDate"] = this.showEndDate;
        data["endDateString"] = this.endDateString;
        data["globalControl"] = this.globalControl;
        return data;
    }

    clone(): PersonCompanyRoleDataDto {
        const json = this.toJSON();
        let result = new PersonCompanyRoleDataDto();
        result.init(json);
        return result;
    }
}

export interface IPersonCompanyRoleDataDto {
    id: number;
    companyId: number;
    naturalPersonId: number | undefined;
    naturalPerson: NaturalPersonDto;
    juridicalPersonId: number | undefined;
    juridicalPerson: CompanyDto;
    companyRoleId: number;
    companyRole: CompanyRoleDto;
    positionId: number | undefined;
    position: PositionDto;
    shareholding: number | undefined;
    nominalValue: number | undefined;
    effectiveDate: moment.Moment | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    grantDate: moment.Moment | undefined;
    revocationDate: moment.Moment | undefined;
    attorneyInFactTypeId: number | undefined;
    attorneyInFactType: AttorneyInFactTypeDto;
    attorneysInFact: boolean | undefined;
    functionalLinkId: number | undefined;
    functionalLink: FunctionalLinkDto;
    healthInsuranceId: number | undefined;
    healthInsurance: HealthInsuranceDto;
    relatedPersonCompanyRoleDatas: PersonCompanyRoleDataDto[] | undefined;
    relatedPersonCompanyRoleDataId: number | undefined;
    relatedPersonCompanyRoleDataGuid: string | undefined;
    relatedPersonCompanyRoleData: PersonCompanyRoleDataDto;
    finalBeneficiary: boolean | undefined;
    loadLessInfo: boolean | undefined;
    guid: string;
    showEndDate: boolean;
    endDateString: string | undefined;
    globalControl: number | undefined;
}

export class PersonLibraryResponseDto implements IPersonLibraryResponseDto {
    id: number;
    companyId: number | undefined;
    company: CompanyDto;
    juridicalPersonId: number | undefined;
    juridicalPerson: CompanyDto;
    naturalPersonId: number | undefined;
    naturalPerson: NaturalPersonDto;
    libraryFiles: LibraryFileDto[] | undefined;

    constructor(data?: IPersonLibraryResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.juridicalPersonId = _data["juridicalPersonId"];
            this.juridicalPerson = _data["juridicalPerson"] ? CompanyDto.fromJS(_data["juridicalPerson"]) : <any>undefined;
            this.naturalPersonId = _data["naturalPersonId"];
            this.naturalPerson = _data["naturalPerson"] ? NaturalPersonDto.fromJS(_data["naturalPerson"]) : <any>undefined;
            if (Array.isArray(_data["libraryFiles"])) {
                this.libraryFiles = [] as any;
                for (let item of _data["libraryFiles"])
                    this.libraryFiles.push(LibraryFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PersonLibraryResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonLibraryResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["juridicalPersonId"] = this.juridicalPersonId;
        data["juridicalPerson"] = this.juridicalPerson ? this.juridicalPerson.toJSON() : <any>undefined;
        data["naturalPersonId"] = this.naturalPersonId;
        data["naturalPerson"] = this.naturalPerson ? this.naturalPerson.toJSON() : <any>undefined;
        if (Array.isArray(this.libraryFiles)) {
            data["libraryFiles"] = [];
            for (let item of this.libraryFiles)
                data["libraryFiles"].push(item.toJSON());
        }
        return data;
    }

    clone(): PersonLibraryResponseDto {
        const json = this.toJSON();
        let result = new PersonLibraryResponseDto();
        result.init(json);
        return result;
    }
}

export interface IPersonLibraryResponseDto {
    id: number;
    companyId: number | undefined;
    company: CompanyDto;
    juridicalPersonId: number | undefined;
    juridicalPerson: CompanyDto;
    naturalPersonId: number | undefined;
    naturalPerson: NaturalPersonDto;
    libraryFiles: LibraryFileDto[] | undefined;
}

export class PersonRoleByCompanyDto implements IPersonRoleByCompanyDto {
    personCompanyRoleDataId: number;
    companyId: number;
    personType: string | undefined;
    fullName: string | undefined;
    companyRole: string | undefined;
    position: string | undefined;
    shareholding: number | undefined;
    nominalValue: number | undefined;
    effectiveDate: moment.Moment | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    grantDate: moment.Moment | undefined;
    revocationDate: moment.Moment | undefined;
    finalBeneficiary: string | undefined;
    politicallyExposedPerson: string | undefined;
    email: string | undefined;
    relatedFullName: string | undefined;
    attorneyInFactType: string | undefined;
    companyName: string | undefined;
    companyTypeId: number;
    companyTypeCode: string | undefined;

    constructor(data?: IPersonRoleByCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personCompanyRoleDataId = _data["personCompanyRoleDataId"];
            this.companyId = _data["companyId"];
            this.personType = _data["personType"];
            this.fullName = _data["fullName"];
            this.companyRole = _data["companyRole"];
            this.position = _data["position"];
            this.shareholding = _data["shareholding"];
            this.nominalValue = _data["nominalValue"];
            this.effectiveDate = _data["effectiveDate"] ? moment(_data["effectiveDate"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.grantDate = _data["grantDate"] ? moment(_data["grantDate"].toString()) : <any>undefined;
            this.revocationDate = _data["revocationDate"] ? moment(_data["revocationDate"].toString()) : <any>undefined;
            this.finalBeneficiary = _data["finalBeneficiary"];
            this.politicallyExposedPerson = _data["politicallyExposedPerson"];
            this.email = _data["email"];
            this.relatedFullName = _data["relatedFullName"];
            this.attorneyInFactType = _data["attorneyInFactType"];
            this.companyName = _data["companyName"];
            this.companyTypeId = _data["companyTypeId"];
            this.companyTypeCode = _data["companyTypeCode"];
        }
    }

    static fromJS(data: any): PersonRoleByCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonRoleByCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personCompanyRoleDataId"] = this.personCompanyRoleDataId;
        data["companyId"] = this.companyId;
        data["personType"] = this.personType;
        data["fullName"] = this.fullName;
        data["companyRole"] = this.companyRole;
        data["position"] = this.position;
        data["shareholding"] = this.shareholding;
        data["nominalValue"] = this.nominalValue;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["grantDate"] = this.grantDate ? this.grantDate.toISOString() : <any>undefined;
        data["revocationDate"] = this.revocationDate ? this.revocationDate.toISOString() : <any>undefined;
        data["finalBeneficiary"] = this.finalBeneficiary;
        data["politicallyExposedPerson"] = this.politicallyExposedPerson;
        data["email"] = this.email;
        data["relatedFullName"] = this.relatedFullName;
        data["attorneyInFactType"] = this.attorneyInFactType;
        data["companyName"] = this.companyName;
        data["companyTypeId"] = this.companyTypeId;
        data["companyTypeCode"] = this.companyTypeCode;
        return data;
    }

    clone(): PersonRoleByCompanyDto {
        const json = this.toJSON();
        let result = new PersonRoleByCompanyDto();
        result.init(json);
        return result;
    }
}

export interface IPersonRoleByCompanyDto {
    personCompanyRoleDataId: number;
    companyId: number;
    personType: string | undefined;
    fullName: string | undefined;
    companyRole: string | undefined;
    position: string | undefined;
    shareholding: number | undefined;
    nominalValue: number | undefined;
    effectiveDate: moment.Moment | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    grantDate: moment.Moment | undefined;
    revocationDate: moment.Moment | undefined;
    finalBeneficiary: string | undefined;
    politicallyExposedPerson: string | undefined;
    email: string | undefined;
    relatedFullName: string | undefined;
    attorneyInFactType: string | undefined;
    companyName: string | undefined;
    companyTypeId: number;
    companyTypeCode: string | undefined;
}

export class PersonRoleByCompanyDtoPagedResultDto implements IPersonRoleByCompanyDtoPagedResultDto {
    items: PersonRoleByCompanyDto[] | undefined;
    totalCount: number;

    constructor(data?: IPersonRoleByCompanyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PersonRoleByCompanyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PersonRoleByCompanyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonRoleByCompanyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PersonRoleByCompanyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PersonRoleByCompanyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPersonRoleByCompanyDtoPagedResultDto {
    items: PersonRoleByCompanyDto[] | undefined;
    totalCount: number;
}

export class Position implements IPosition {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;

    constructor(data?: IPosition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
        }
    }

    static fromJS(data: any): Position {
        data = typeof data === 'object' ? data : {};
        let result = new Position();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        return data;
    }

    clone(): Position {
        const json = this.toJSON();
        let result = new Position();
        result.init(json);
        return result;
    }
}

export interface IPosition {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
}

export class PositionDto implements IPositionDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;

    constructor(data?: IPositionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
        }
    }

    static fromJS(data: any): PositionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PositionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        return data;
    }

    clone(): PositionDto {
        const json = this.toJSON();
        let result = new PositionDto();
        result.init(json);
        return result;
    }
}

export interface IPositionDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
}

export class PositionDtoPagedResultDto implements IPositionDtoPagedResultDto {
    items: PositionDto[] | undefined;
    totalCount: number;

    constructor(data?: IPositionDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PositionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PositionDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PositionDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PositionDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PositionDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPositionDtoPagedResultDto {
    items: PositionDto[] | undefined;
    totalCount: number;
}

export class RegisterInput implements IRegisterInput {
    name: string;
    surname: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }

    clone(): RegisterInput {
        const json = this.toJSON();
        let result = new RegisterInput();
        result.init(json);
        return result;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }

    clone(): RegisterOutput {
        const json = this.toJSON();
        let result = new RegisterOutput();
        result.init(json);
        return result;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class RenameLibraryItemRequestDto implements IRenameLibraryItemRequestDto {
    id: number;
    guid: string;
    name: string | undefined;

    constructor(data?: IRenameLibraryItemRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.guid = _data["guid"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RenameLibraryItemRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RenameLibraryItemRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["guid"] = this.guid;
        data["name"] = this.name;
        return data;
    }

    clone(): RenameLibraryItemRequestDto {
        const json = this.toJSON();
        let result = new RenameLibraryItemRequestDto();
        result.init(json);
        return result;
    }
}

export interface IRenameLibraryItemRequestDto {
    id: number;
    guid: string;
    name: string | undefined;
}

export class RenameLibraryItemResponseDto implements IRenameLibraryItemResponseDto {
    id: number;
    guid: string;
    name: string | undefined;

    constructor(data?: IRenameLibraryItemResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.guid = _data["guid"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RenameLibraryItemResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RenameLibraryItemResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["guid"] = this.guid;
        data["name"] = this.name;
        return data;
    }

    clone(): RenameLibraryItemResponseDto {
        const json = this.toJSON();
        let result = new RenameLibraryItemResponseDto();
        result.init(json);
        return result;
    }
}

export interface IRenameLibraryItemResponseDto {
    id: number;
    guid: string;
    name: string | undefined;
}

export enum RequestStatusEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class ResetPasswordDto implements IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ResetPasswordDto {
        const json = this.toJSON();
        let result = new ResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;
}

export class RoleDto implements IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class RoleDtoListResultDto implements IRoleDtoListResultDto {
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoListResultDto {
    items: RoleDto[] | undefined;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;
}

export class RoleEditDto implements IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        return data;
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
}

export class RoleListDto implements IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleListDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export class SelectableCompanyDto implements ISelectableCompanyDto {
    companyId: number;
    countryISOAlpha2Code: string | undefined;
    name: string | undefined;
    companyTypeName: string | undefined;
    balanceMonth: number | undefined;
    checked: boolean;

    constructor(data?: ISelectableCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.countryISOAlpha2Code = _data["countryISOAlpha2Code"];
            this.name = _data["name"];
            this.companyTypeName = _data["companyTypeName"];
            this.balanceMonth = _data["balanceMonth"];
            this.checked = _data["checked"];
        }
    }

    static fromJS(data: any): SelectableCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectableCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["countryISOAlpha2Code"] = this.countryISOAlpha2Code;
        data["name"] = this.name;
        data["companyTypeName"] = this.companyTypeName;
        data["balanceMonth"] = this.balanceMonth;
        data["checked"] = this.checked;
        return data;
    }

    clone(): SelectableCompanyDto {
        const json = this.toJSON();
        let result = new SelectableCompanyDto();
        result.init(json);
        return result;
    }
}

export interface ISelectableCompanyDto {
    companyId: number;
    countryISOAlpha2Code: string | undefined;
    name: string | undefined;
    companyTypeName: string | undefined;
    balanceMonth: number | undefined;
    checked: boolean;
}

export class SelectableCompanyDtoPagedResultDto implements ISelectableCompanyDtoPagedResultDto {
    items: SelectableCompanyDto[] | undefined;
    totalCount: number;

    constructor(data?: ISelectableCompanyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SelectableCompanyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SelectableCompanyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectableCompanyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SelectableCompanyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SelectableCompanyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISelectableCompanyDtoPagedResultDto {
    items: SelectableCompanyDto[] | undefined;
    totalCount: number;
}

export class SelectableUserDto implements ISelectableUserDto {
    userId: number;
    emailAddress: string | undefined;
    fullName: string | undefined;
    profilePhotoBytes: string | undefined;
    checked: boolean;

    constructor(data?: ISelectableUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.emailAddress = _data["emailAddress"];
            this.fullName = _data["fullName"];
            this.profilePhotoBytes = _data["profilePhotoBytes"];
            this.checked = _data["checked"];
        }
    }

    static fromJS(data: any): SelectableUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectableUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["emailAddress"] = this.emailAddress;
        data["fullName"] = this.fullName;
        data["profilePhotoBytes"] = this.profilePhotoBytes;
        data["checked"] = this.checked;
        return data;
    }

    clone(): SelectableUserDto {
        const json = this.toJSON();
        let result = new SelectableUserDto();
        result.init(json);
        return result;
    }
}

export interface ISelectableUserDto {
    userId: number;
    emailAddress: string | undefined;
    fullName: string | undefined;
    profilePhotoBytes: string | undefined;
    checked: boolean;
}

export class SelfResetPasswordDto implements ISelfResetPasswordDto {
    emailAddress: string;
    passwordResetCode: string;
    newPassword: string;

    constructor(data?: ISelfResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): SelfResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelfResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["passwordResetCode"] = this.passwordResetCode;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): SelfResetPasswordDto {
        const json = this.toJSON();
        let result = new SelfResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface ISelfResetPasswordDto {
    emailAddress: string;
    passwordResetCode: string;
    newPassword: string;
}

export class Setting implements ISetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): Setting {
        const json = this.toJSON();
        let result = new Setting();
        result.init(json);
        return result;
    }
}

export interface ISetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
}

export class ShareType implements IShareType {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
    code: string | undefined;

    constructor(data?: IShareType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ShareType {
        data = typeof data === 'object' ? data : {};
        let result = new ShareType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        data["code"] = this.code;
        return data;
    }

    clone(): ShareType {
        const json = this.toJSON();
        let result = new ShareType();
        result.init(json);
        return result;
    }
}

export interface IShareType {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
    code: string | undefined;
}

export class ShareTypeDto implements IShareTypeDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
    code: string;

    constructor(data?: IShareTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ShareTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShareTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        data["code"] = this.code;
        return data;
    }

    clone(): ShareTypeDto {
        const json = this.toJSON();
        let result = new ShareTypeDto();
        result.init(json);
        return result;
    }
}

export interface IShareTypeDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
    code: string;
}

export class ShareTypeDtoPagedResultDto implements IShareTypeDtoPagedResultDto {
    items: ShareTypeDto[] | undefined;
    totalCount: number;

    constructor(data?: IShareTypeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ShareTypeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ShareTypeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShareTypeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ShareTypeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ShareTypeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IShareTypeDtoPagedResultDto {
    items: ShareTypeDto[] | undefined;
    totalCount: number;
}

export class Spouse implements ISpouse {
    id: number;
    tenantId: number;
    tenant: Tenant;
    names: string | undefined;
    surnames: string | undefined;
    identificationDocumentId: number | undefined;
    identificationDocument: IdentificationDocument;

    constructor(data?: ISpouse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.names = _data["names"];
            this.surnames = _data["surnames"];
            this.identificationDocumentId = _data["identificationDocumentId"];
            this.identificationDocument = _data["identificationDocument"] ? IdentificationDocument.fromJS(_data["identificationDocument"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Spouse {
        data = typeof data === 'object' ? data : {};
        let result = new Spouse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["names"] = this.names;
        data["surnames"] = this.surnames;
        data["identificationDocumentId"] = this.identificationDocumentId;
        data["identificationDocument"] = this.identificationDocument ? this.identificationDocument.toJSON() : <any>undefined;
        return data;
    }

    clone(): Spouse {
        const json = this.toJSON();
        let result = new Spouse();
        result.init(json);
        return result;
    }
}

export interface ISpouse {
    id: number;
    tenantId: number;
    tenant: Tenant;
    names: string | undefined;
    surnames: string | undefined;
    identificationDocumentId: number | undefined;
    identificationDocument: IdentificationDocument;
}

export class SpouseDto implements ISpouseDto {
    id: number;
    tenantId: number;
    names: string | undefined;
    surnames: string | undefined;
    identificationDocumentId: number | undefined;
    identificationDocument: IdentificationDocumentDto;

    constructor(data?: ISpouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.names = _data["names"];
            this.surnames = _data["surnames"];
            this.identificationDocumentId = _data["identificationDocumentId"];
            this.identificationDocument = _data["identificationDocument"] ? IdentificationDocumentDto.fromJS(_data["identificationDocument"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SpouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["names"] = this.names;
        data["surnames"] = this.surnames;
        data["identificationDocumentId"] = this.identificationDocumentId;
        data["identificationDocument"] = this.identificationDocument ? this.identificationDocument.toJSON() : <any>undefined;
        return data;
    }

    clone(): SpouseDto {
        const json = this.toJSON();
        let result = new SpouseDto();
        result.init(json);
        return result;
    }
}

export interface ISpouseDto {
    id: number;
    tenantId: number;
    names: string | undefined;
    surnames: string | undefined;
    identificationDocumentId: number | undefined;
    identificationDocument: IdentificationDocumentDto;
}

export class TemplateCustomFieldDto implements ITemplateCustomFieldDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    tenant: Tenant;
    sortOrder: number;
    isRequired: boolean;
    customFieldId: number | undefined;
    customField: CustomFieldDto;
    templateId: number;
    templateName: string | undefined;

    constructor(data?: ITemplateCustomFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.sortOrder = _data["sortOrder"];
            this.isRequired = _data["isRequired"];
            this.customFieldId = _data["customFieldId"];
            this.customField = _data["customField"] ? CustomFieldDto.fromJS(_data["customField"]) : <any>undefined;
            this.templateId = _data["templateId"];
            this.templateName = _data["templateName"];
        }
    }

    static fromJS(data: any): TemplateCustomFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateCustomFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["sortOrder"] = this.sortOrder;
        data["isRequired"] = this.isRequired;
        data["customFieldId"] = this.customFieldId;
        data["customField"] = this.customField ? this.customField.toJSON() : <any>undefined;
        data["templateId"] = this.templateId;
        data["templateName"] = this.templateName;
        return data;
    }

    clone(): TemplateCustomFieldDto {
        const json = this.toJSON();
        let result = new TemplateCustomFieldDto();
        result.init(json);
        return result;
    }
}

export interface ITemplateCustomFieldDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    tenant: Tenant;
    sortOrder: number;
    isRequired: boolean;
    customFieldId: number | undefined;
    customField: CustomFieldDto;
    templateId: number;
    templateName: string | undefined;
}

export class TemplateCustomFieldDtoPagedResultDto implements ITemplateCustomFieldDtoPagedResultDto {
    items: TemplateCustomFieldDto[] | undefined;
    totalCount: number;

    constructor(data?: ITemplateCustomFieldDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TemplateCustomFieldDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TemplateCustomFieldDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateCustomFieldDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TemplateCustomFieldDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TemplateCustomFieldDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITemplateCustomFieldDtoPagedResultDto {
    items: TemplateCustomFieldDto[] | undefined;
    totalCount: number;
}

export class TemplateDto implements ITemplateDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    creatorUserName: string | undefined;
    templateCustomFields: TemplateCustomFieldDto[] | undefined;

    constructor(data?: ITemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.creatorUserName = _data["creatorUserName"];
            if (Array.isArray(_data["templateCustomFields"])) {
                this.templateCustomFields = [] as any;
                for (let item of _data["templateCustomFields"])
                    this.templateCustomFields.push(TemplateCustomFieldDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["creatorUserName"] = this.creatorUserName;
        if (Array.isArray(this.templateCustomFields)) {
            data["templateCustomFields"] = [];
            for (let item of this.templateCustomFields)
                data["templateCustomFields"].push(item.toJSON());
        }
        return data;
    }

    clone(): TemplateDto {
        const json = this.toJSON();
        let result = new TemplateDto();
        result.init(json);
        return result;
    }
}

export interface ITemplateDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    creatorUserName: string | undefined;
    templateCustomFields: TemplateCustomFieldDto[] | undefined;
}

export class TemplateDtoPagedResultDto implements ITemplateDtoPagedResultDto {
    items: TemplateDto[] | undefined;
    totalCount: number;

    constructor(data?: ITemplateDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TemplateDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TemplateDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TemplateDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TemplateDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITemplateDtoPagedResultDto {
    items: TemplateDto[] | undefined;
    totalCount: number;
}

export class Tenant implements ITenant {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    isActive: boolean;
    edition: Edition;
    editionId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    deleterUser: User;
    phoneNumber: string | undefined;
    alternativePhoneNumber: string | undefined;
    documentNumber: string | undefined;

    constructor(data?: ITenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
            this.edition = _data["edition"] ? Edition.fromJS(_data["edition"]) : <any>undefined;
            this.editionId = _data["editionId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.alternativePhoneNumber = _data["alternativePhoneNumber"];
            this.documentNumber = _data["documentNumber"];
        }
    }

    static fromJS(data: any): Tenant {
        data = typeof data === 'object' ? data : {};
        let result = new Tenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["editionId"] = this.editionId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["alternativePhoneNumber"] = this.alternativePhoneNumber;
        data["documentNumber"] = this.documentNumber;
        return data;
    }

    clone(): Tenant {
        const json = this.toJSON();
        let result = new Tenant();
        result.init(json);
        return result;
    }
}

export interface ITenant {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    isActive: boolean;
    edition: Edition;
    editionId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    deleterUser: User;
    phoneNumber: string | undefined;
    alternativePhoneNumber: string | undefined;
    documentNumber: string | undefined;
}

export enum TenantAvailabilityState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class TenantDto implements ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;
    phoneNumber: string | undefined;
    alternativePhoneNumber: string | undefined;
    documentNumber: string | undefined;
    creationTime: moment.Moment;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.phoneNumber = _data["phoneNumber"];
            this.alternativePhoneNumber = _data["alternativePhoneNumber"];
            this.documentNumber = _data["documentNumber"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["phoneNumber"] = this.phoneNumber;
        data["alternativePhoneNumber"] = this.alternativePhoneNumber;
        data["documentNumber"] = this.documentNumber;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;
    phoneNumber: string | undefined;
    alternativePhoneNumber: string | undefined;
    documentNumber: string | undefined;
    creationTime: moment.Moment;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TenantDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        return data;
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
}

export class TenantPublicSettingsDto implements ITenantPublicSettingsDto {
    logo: string | undefined;
    primaryColor: string | undefined;
    primaryColorLight: string | undefined;
    primaryColorFocus: string | undefined;
    primaryColorBack: string | undefined;

    constructor(data?: ITenantPublicSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logo = _data["logo"];
            this.primaryColor = _data["primaryColor"];
            this.primaryColorLight = _data["primaryColorLight"];
            this.primaryColorFocus = _data["primaryColorFocus"];
            this.primaryColorBack = _data["primaryColorBack"];
        }
    }

    static fromJS(data: any): TenantPublicSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantPublicSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logo"] = this.logo;
        data["primaryColor"] = this.primaryColor;
        data["primaryColorLight"] = this.primaryColorLight;
        data["primaryColorFocus"] = this.primaryColorFocus;
        data["primaryColorBack"] = this.primaryColorBack;
        return data;
    }

    clone(): TenantPublicSettingsDto {
        const json = this.toJSON();
        let result = new TenantPublicSettingsDto();
        result.init(json);
        return result;
    }
}

export interface ITenantPublicSettingsDto {
    logo: string | undefined;
    primaryColor: string | undefined;
    primaryColorLight: string | undefined;
    primaryColorFocus: string | undefined;
    primaryColorBack: string | undefined;
}

export class TypeFieldDto implements ITypeFieldDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    description: string | undefined;
    isText: boolean;
    isNumber: boolean;
    isDate: boolean;
    isBoolean: boolean;

    constructor(data?: ITypeFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isText = _data["isText"];
            this.isNumber = _data["isNumber"];
            this.isDate = _data["isDate"];
            this.isBoolean = _data["isBoolean"];
        }
    }

    static fromJS(data: any): TypeFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new TypeFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isText"] = this.isText;
        data["isNumber"] = this.isNumber;
        data["isDate"] = this.isDate;
        data["isBoolean"] = this.isBoolean;
        return data;
    }

    clone(): TypeFieldDto {
        const json = this.toJSON();
        let result = new TypeFieldDto();
        result.init(json);
        return result;
    }
}

export interface ITypeFieldDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    description: string | undefined;
    isText: boolean;
    isNumber: boolean;
    isDate: boolean;
    isBoolean: boolean;
}

export class TypeFieldDtoPagedResultDto implements ITypeFieldDtoPagedResultDto {
    items: TypeFieldDto[] | undefined;
    totalCount: number;

    constructor(data?: ITypeFieldDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TypeFieldDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TypeFieldDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TypeFieldDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TypeFieldDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TypeFieldDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITypeFieldDtoPagedResultDto {
    items: TypeFieldDto[] | undefined;
    totalCount: number;
}

export enum UiThemeEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class UpdatePersonLibraryConfigurationItemRequestDto implements IUpdatePersonLibraryConfigurationItemRequestDto {
    id: number;
    libraryConfigurationId: number | undefined;
    libraryConfigurationKindId: number | undefined;
    libraryConfigurationRoleId: number | undefined;
    libraryFileOwnerId: number | undefined;
    parentId: number | undefined;
    libraryFileTypeId: number;
    isVisble: boolean;
    isChecked: boolean;
    isShared: boolean;
    name: string | undefined;
    mime: string | undefined;
    guid: string;
    fullNameExtension: string | undefined;
    userId: number | undefined;

    constructor(data?: IUpdatePersonLibraryConfigurationItemRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libraryConfigurationId = _data["libraryConfigurationId"];
            this.libraryConfigurationKindId = _data["libraryConfigurationKindId"];
            this.libraryConfigurationRoleId = _data["libraryConfigurationRoleId"];
            this.libraryFileOwnerId = _data["libraryFileOwnerId"];
            this.parentId = _data["parentId"];
            this.libraryFileTypeId = _data["libraryFileTypeId"];
            this.isVisble = _data["isVisble"];
            this.isChecked = _data["isChecked"];
            this.isShared = _data["isShared"];
            this.name = _data["name"];
            this.mime = _data["mime"];
            this.guid = _data["guid"];
            this.fullNameExtension = _data["fullNameExtension"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UpdatePersonLibraryConfigurationItemRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePersonLibraryConfigurationItemRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libraryConfigurationId"] = this.libraryConfigurationId;
        data["libraryConfigurationKindId"] = this.libraryConfigurationKindId;
        data["libraryConfigurationRoleId"] = this.libraryConfigurationRoleId;
        data["libraryFileOwnerId"] = this.libraryFileOwnerId;
        data["parentId"] = this.parentId;
        data["libraryFileTypeId"] = this.libraryFileTypeId;
        data["isVisble"] = this.isVisble;
        data["isChecked"] = this.isChecked;
        data["isShared"] = this.isShared;
        data["name"] = this.name;
        data["mime"] = this.mime;
        data["guid"] = this.guid;
        data["fullNameExtension"] = this.fullNameExtension;
        data["userId"] = this.userId;
        return data;
    }

    clone(): UpdatePersonLibraryConfigurationItemRequestDto {
        const json = this.toJSON();
        let result = new UpdatePersonLibraryConfigurationItemRequestDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePersonLibraryConfigurationItemRequestDto {
    id: number;
    libraryConfigurationId: number | undefined;
    libraryConfigurationKindId: number | undefined;
    libraryConfigurationRoleId: number | undefined;
    libraryFileOwnerId: number | undefined;
    parentId: number | undefined;
    libraryFileTypeId: number;
    isVisble: boolean;
    isChecked: boolean;
    isShared: boolean;
    name: string | undefined;
    mime: string | undefined;
    guid: string;
    fullNameExtension: string | undefined;
    userId: number | undefined;
}

export class UpdatePersonLibraryConfigurationItemResponseDto implements IUpdatePersonLibraryConfigurationItemResponseDto {
    id: number;
    libraryConfigurationId: number | undefined;
    libraryConfigurationKindId: number | undefined;
    libraryConfigurationRoleId: number | undefined;
    libraryFileOwnerId: number | undefined;
    parentId: number | undefined;
    libraryFileTypeId: number;
    isVisble: boolean;
    isChecked: boolean;
    isShared: boolean;
    name: string | undefined;
    mime: string | undefined;
    guid: string;
    fullNameExtension: string | undefined;

    constructor(data?: IUpdatePersonLibraryConfigurationItemResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libraryConfigurationId = _data["libraryConfigurationId"];
            this.libraryConfigurationKindId = _data["libraryConfigurationKindId"];
            this.libraryConfigurationRoleId = _data["libraryConfigurationRoleId"];
            this.libraryFileOwnerId = _data["libraryFileOwnerId"];
            this.parentId = _data["parentId"];
            this.libraryFileTypeId = _data["libraryFileTypeId"];
            this.isVisble = _data["isVisble"];
            this.isChecked = _data["isChecked"];
            this.isShared = _data["isShared"];
            this.name = _data["name"];
            this.mime = _data["mime"];
            this.guid = _data["guid"];
            this.fullNameExtension = _data["fullNameExtension"];
        }
    }

    static fromJS(data: any): UpdatePersonLibraryConfigurationItemResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePersonLibraryConfigurationItemResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libraryConfigurationId"] = this.libraryConfigurationId;
        data["libraryConfigurationKindId"] = this.libraryConfigurationKindId;
        data["libraryConfigurationRoleId"] = this.libraryConfigurationRoleId;
        data["libraryFileOwnerId"] = this.libraryFileOwnerId;
        data["parentId"] = this.parentId;
        data["libraryFileTypeId"] = this.libraryFileTypeId;
        data["isVisble"] = this.isVisble;
        data["isChecked"] = this.isChecked;
        data["isShared"] = this.isShared;
        data["name"] = this.name;
        data["mime"] = this.mime;
        data["guid"] = this.guid;
        data["fullNameExtension"] = this.fullNameExtension;
        return data;
    }

    clone(): UpdatePersonLibraryConfigurationItemResponseDto {
        const json = this.toJSON();
        let result = new UpdatePersonLibraryConfigurationItemResponseDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePersonLibraryConfigurationItemResponseDto {
    id: number;
    libraryConfigurationId: number | undefined;
    libraryConfigurationKindId: number | undefined;
    libraryConfigurationRoleId: number | undefined;
    libraryFileOwnerId: number | undefined;
    parentId: number | undefined;
    libraryFileTypeId: number;
    isVisble: boolean;
    isChecked: boolean;
    isShared: boolean;
    name: string | undefined;
    mime: string | undefined;
    guid: string;
    fullNameExtension: string | undefined;
}

export class UpdateSuggestedCompanyChangesInputDto implements IUpdateSuggestedCompanyChangesInputDto {
    createOrUpdateCompanyDto: CreateOrUpdateCompanyDto;
    status: RequestStatusEnum;

    constructor(data?: IUpdateSuggestedCompanyChangesInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createOrUpdateCompanyDto = _data["createOrUpdateCompanyDto"] ? CreateOrUpdateCompanyDto.fromJS(_data["createOrUpdateCompanyDto"]) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateSuggestedCompanyChangesInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSuggestedCompanyChangesInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createOrUpdateCompanyDto"] = this.createOrUpdateCompanyDto ? this.createOrUpdateCompanyDto.toJSON() : <any>undefined;
        data["status"] = this.status;
        return data;
    }

    clone(): UpdateSuggestedCompanyChangesInputDto {
        const json = this.toJSON();
        let result = new UpdateSuggestedCompanyChangesInputDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSuggestedCompanyChangesInputDto {
    createOrUpdateCompanyDto: CreateOrUpdateCompanyDto;
    status: RequestStatusEnum;
}

export class UpdateSuggestedJuridicalPersonChangesInputDto implements IUpdateSuggestedJuridicalPersonChangesInputDto {
    createOrUpdateJuridicalPersonDto: CreateOrUpdateJuridicalPersonDto;
    status: RequestStatusEnum;

    constructor(data?: IUpdateSuggestedJuridicalPersonChangesInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createOrUpdateJuridicalPersonDto = _data["createOrUpdateJuridicalPersonDto"] ? CreateOrUpdateJuridicalPersonDto.fromJS(_data["createOrUpdateJuridicalPersonDto"]) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateSuggestedJuridicalPersonChangesInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSuggestedJuridicalPersonChangesInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createOrUpdateJuridicalPersonDto"] = this.createOrUpdateJuridicalPersonDto ? this.createOrUpdateJuridicalPersonDto.toJSON() : <any>undefined;
        data["status"] = this.status;
        return data;
    }

    clone(): UpdateSuggestedJuridicalPersonChangesInputDto {
        const json = this.toJSON();
        let result = new UpdateSuggestedJuridicalPersonChangesInputDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSuggestedJuridicalPersonChangesInputDto {
    createOrUpdateJuridicalPersonDto: CreateOrUpdateJuridicalPersonDto;
    status: RequestStatusEnum;
}

export class UpdateSuggestedNaturalPersonChangesInputDto implements IUpdateSuggestedNaturalPersonChangesInputDto {
    createOrUpdateNaturalPersonDto: CreateOrUpdateNaturalPersonDto;
    status: RequestStatusEnum;

    constructor(data?: IUpdateSuggestedNaturalPersonChangesInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createOrUpdateNaturalPersonDto = _data["createOrUpdateNaturalPersonDto"] ? CreateOrUpdateNaturalPersonDto.fromJS(_data["createOrUpdateNaturalPersonDto"]) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateSuggestedNaturalPersonChangesInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSuggestedNaturalPersonChangesInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createOrUpdateNaturalPersonDto"] = this.createOrUpdateNaturalPersonDto ? this.createOrUpdateNaturalPersonDto.toJSON() : <any>undefined;
        data["status"] = this.status;
        return data;
    }

    clone(): UpdateSuggestedNaturalPersonChangesInputDto {
        const json = this.toJSON();
        let result = new UpdateSuggestedNaturalPersonChangesInputDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSuggestedNaturalPersonChangesInputDto {
    createOrUpdateNaturalPersonDto: CreateOrUpdateNaturalPersonDto;
    status: RequestStatusEnum;
}

export class UpdateTenantDto implements IUpdateTenantDto {
    id: number;
    tenancyName: string;
    name: string;
    adminTenantId: number;
    adminEmailAddress: string;
    isActive: boolean;
    phoneNumber: string | undefined;
    alternativePhoneNumber: string | undefined;
    documentNumber: string | undefined;

    constructor(data?: IUpdateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminTenantId = _data["adminTenantId"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.isActive = _data["isActive"];
            this.phoneNumber = _data["phoneNumber"];
            this.alternativePhoneNumber = _data["alternativePhoneNumber"];
            this.documentNumber = _data["documentNumber"];
        }
    }

    static fromJS(data: any): UpdateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminTenantId"] = this.adminTenantId;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["isActive"] = this.isActive;
        data["phoneNumber"] = this.phoneNumber;
        data["alternativePhoneNumber"] = this.alternativePhoneNumber;
        data["documentNumber"] = this.documentNumber;
        return data;
    }

    clone(): UpdateTenantDto {
        const json = this.toJSON();
        let result = new UpdateTenantDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateTenantDto {
    id: number;
    tenancyName: string;
    name: string;
    adminTenantId: number;
    adminEmailAddress: string;
    isActive: boolean;
    phoneNumber: string | undefined;
    alternativePhoneNumber: string | undefined;
    documentNumber: string | undefined;
}

export class UpdateTenantLibraryConfigurationItemDto implements IUpdateTenantLibraryConfigurationItemDto {
    id: number;
    libraryConfigurationId: number | undefined;
    libraryConfigurationKindId: number | undefined;
    libraryConfigurationRoleId: number | undefined;
    parentId: number | undefined;
    libraryFileTypeId: number;
    isVisble: boolean;
    isChecked: boolean;
    isShared: boolean;
    name: string | undefined;
    mime: string | undefined;
    guid: string;
    fullNameExtension: string | undefined;

    constructor(data?: IUpdateTenantLibraryConfigurationItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libraryConfigurationId = _data["libraryConfigurationId"];
            this.libraryConfigurationKindId = _data["libraryConfigurationKindId"];
            this.libraryConfigurationRoleId = _data["libraryConfigurationRoleId"];
            this.parentId = _data["parentId"];
            this.libraryFileTypeId = _data["libraryFileTypeId"];
            this.isVisble = _data["isVisble"];
            this.isChecked = _data["isChecked"];
            this.isShared = _data["isShared"];
            this.name = _data["name"];
            this.mime = _data["mime"];
            this.guid = _data["guid"];
            this.fullNameExtension = _data["fullNameExtension"];
        }
    }

    static fromJS(data: any): UpdateTenantLibraryConfigurationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantLibraryConfigurationItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libraryConfigurationId"] = this.libraryConfigurationId;
        data["libraryConfigurationKindId"] = this.libraryConfigurationKindId;
        data["libraryConfigurationRoleId"] = this.libraryConfigurationRoleId;
        data["parentId"] = this.parentId;
        data["libraryFileTypeId"] = this.libraryFileTypeId;
        data["isVisble"] = this.isVisble;
        data["isChecked"] = this.isChecked;
        data["isShared"] = this.isShared;
        data["name"] = this.name;
        data["mime"] = this.mime;
        data["guid"] = this.guid;
        data["fullNameExtension"] = this.fullNameExtension;
        return data;
    }

    clone(): UpdateTenantLibraryConfigurationItemDto {
        const json = this.toJSON();
        let result = new UpdateTenantLibraryConfigurationItemDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateTenantLibraryConfigurationItemDto {
    id: number;
    libraryConfigurationId: number | undefined;
    libraryConfigurationKindId: number | undefined;
    libraryConfigurationRoleId: number | undefined;
    parentId: number | undefined;
    libraryFileTypeId: number;
    isVisble: boolean;
    isChecked: boolean;
    isShared: boolean;
    name: string | undefined;
    mime: string | undefined;
    guid: string;
    fullNameExtension: string | undefined;
}

export class UploadProfilePhotoOutputDto implements IUploadProfilePhotoOutputDto {
    profilePhoto: string | undefined;
    mimeType: string | undefined;
    profilePhotoBytes: string | undefined;

    constructor(data?: IUploadProfilePhotoOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePhoto = _data["profilePhoto"];
            this.mimeType = _data["mimeType"];
            this.profilePhotoBytes = _data["profilePhotoBytes"];
        }
    }

    static fromJS(data: any): UploadProfilePhotoOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadProfilePhotoOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePhoto"] = this.profilePhoto;
        data["mimeType"] = this.mimeType;
        data["profilePhotoBytes"] = this.profilePhotoBytes;
        return data;
    }

    clone(): UploadProfilePhotoOutputDto {
        const json = this.toJSON();
        let result = new UploadProfilePhotoOutputDto();
        result.init(json);
        return result;
    }
}

export interface IUploadProfilePhotoOutputDto {
    profilePhoto: string | undefined;
    mimeType: string | undefined;
    profilePhotoBytes: string | undefined;
}

export class User implements IUser {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    readonly fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    profilePhoto: string | undefined;
    mimeType: string | undefined;
    welcomeSent: boolean;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.authenticationSource = _data["authenticationSource"];
            this.userName = _data["userName"];
            this.tenantId = _data["tenantId"];
            this.emailAddress = _data["emailAddress"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            (<any>this).fullName = _data["fullName"];
            this.password = _data["password"];
            this.emailConfirmationCode = _data["emailConfirmationCode"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? moment(_data["lockoutEndDateUtc"].toString()) : <any>undefined;
            this.accessFailedCount = _data["accessFailedCount"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.securityStamp = _data["securityStamp"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            if (Array.isArray(_data["logins"])) {
                this.logins = [] as any;
                for (let item of _data["logins"])
                    this.logins.push(UserLogin.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims.push(UserClaim.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(UserPermissionSetting.fromJS(item));
            }
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings.push(Setting.fromJS(item));
            }
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.isActive = _data["isActive"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.normalizedEmailAddress = _data["normalizedEmailAddress"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens.push(UserToken.fromJS(item));
            }
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.profilePhoto = _data["profilePhoto"];
            this.mimeType = _data["mimeType"];
            this.welcomeSent = _data["welcomeSent"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["authenticationSource"] = this.authenticationSource;
        data["userName"] = this.userName;
        data["tenantId"] = this.tenantId;
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["password"] = this.password;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["passwordResetCode"] = this.passwordResetCode;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : <any>undefined;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["securityStamp"] = this.securityStamp;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        if (Array.isArray(this.logins)) {
            data["logins"] = [];
            for (let item of this.logins)
                data["logins"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["normalizedUserName"] = this.normalizedUserName;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item.toJSON());
        }
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["profilePhoto"] = this.profilePhoto;
        data["mimeType"] = this.mimeType;
        data["welcomeSent"] = this.welcomeSent;
        return data;
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    profilePhoto: string | undefined;
    mimeType: string | undefined;
    welcomeSent: boolean;
}

export class UserClaim implements IUserClaim {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        return data;
    }

    clone(): UserClaim {
        const json = this.toJSON();
        let result = new UserClaim();
        result.init(json);
        return result;
    }
}

export interface IUserClaim {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
}

export class UserDto implements IUserDto {
    id: number;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;
    profilePhoto: string | undefined;
    mimeType: string | undefined;
    profilePhotoBytes: string | undefined;
    selectedCompaniesIds: number[] | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.fullName = _data["fullName"];
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.profilePhoto = _data["profilePhoto"];
            this.mimeType = _data["mimeType"];
            this.profilePhotoBytes = _data["profilePhotoBytes"];
            if (Array.isArray(_data["selectedCompaniesIds"])) {
                this.selectedCompaniesIds = [] as any;
                for (let item of _data["selectedCompaniesIds"])
                    this.selectedCompaniesIds.push(item);
            }
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["profilePhoto"] = this.profilePhoto;
        data["mimeType"] = this.mimeType;
        data["profilePhotoBytes"] = this.profilePhotoBytes;
        if (Array.isArray(this.selectedCompaniesIds)) {
            data["selectedCompaniesIds"] = [];
            for (let item of this.selectedCompaniesIds)
                data["selectedCompaniesIds"].push(item);
        }
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    id: number;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;
    profilePhoto: string | undefined;
    mimeType: string | undefined;
    profilePhotoBytes: string | undefined;
    selectedCompaniesIds: number[] | undefined;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;
}

export class UserLogin implements IUserLogin {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        return data;
    }

    clone(): UserLogin {
        const json = this.toJSON();
        let result = new UserLogin();
        result.init(json);
        return result;
    }
}

export interface IUserLogin {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    mimeType: string | undefined;
    profilePhotoBytes: string | undefined;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.mimeType = _data["mimeType"];
            this.profilePhotoBytes = _data["profilePhotoBytes"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["mimeType"] = this.mimeType;
        data["profilePhotoBytes"] = this.profilePhotoBytes;
        return data;
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    mimeType: string | undefined;
    profilePhotoBytes: string | undefined;
}

export class UserNotificationChannelDto implements IUserNotificationChannelDto {
    id: number;
    userNotificationSettingId: number;
    notificationChannel: NotificationChannelEnum;
    enabledChannel: boolean;

    constructor(data?: IUserNotificationChannelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userNotificationSettingId = _data["userNotificationSettingId"];
            this.notificationChannel = _data["notificationChannel"];
            this.enabledChannel = _data["enabledChannel"];
        }
    }

    static fromJS(data: any): UserNotificationChannelDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotificationChannelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userNotificationSettingId"] = this.userNotificationSettingId;
        data["notificationChannel"] = this.notificationChannel;
        data["enabledChannel"] = this.enabledChannel;
        return data;
    }

    clone(): UserNotificationChannelDto {
        const json = this.toJSON();
        let result = new UserNotificationChannelDto();
        result.init(json);
        return result;
    }
}

export interface IUserNotificationChannelDto {
    id: number;
    userNotificationSettingId: number;
    notificationChannel: NotificationChannelEnum;
    enabledChannel: boolean;
}

export class UserNotificationCompanyCheckedDto implements IUserNotificationCompanyCheckedDto {
    company: CompanyDto;
    isChecked: boolean;

    constructor(data?: IUserNotificationCompanyCheckedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.isChecked = _data["isChecked"];
        }
    }

    static fromJS(data: any): UserNotificationCompanyCheckedDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotificationCompanyCheckedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["isChecked"] = this.isChecked;
        return data;
    }

    clone(): UserNotificationCompanyCheckedDto {
        const json = this.toJSON();
        let result = new UserNotificationCompanyCheckedDto();
        result.init(json);
        return result;
    }
}

export interface IUserNotificationCompanyCheckedDto {
    company: CompanyDto;
    isChecked: boolean;
}

export class UserNotificationSettingDto implements IUserNotificationSettingDto {
    id: number;
    userId: number;
    tenantId: number;
    notificationTypeId: number;
    enabled: boolean;
    daysInAdvance: number;
    user: UserDto;
    tenant: TenantDto;
    notificationType: NotificationTypeDto;
    userNotificationChannels: UserNotificationChannelDto[] | undefined;
    companies: UserNotificationCompanyCheckedDto[] | undefined;

    constructor(data?: IUserNotificationSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.notificationTypeId = _data["notificationTypeId"];
            this.enabled = _data["enabled"];
            this.daysInAdvance = _data["daysInAdvance"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantDto.fromJS(_data["tenant"]) : <any>undefined;
            this.notificationType = _data["notificationType"] ? NotificationTypeDto.fromJS(_data["notificationType"]) : <any>undefined;
            if (Array.isArray(_data["userNotificationChannels"])) {
                this.userNotificationChannels = [] as any;
                for (let item of _data["userNotificationChannels"])
                    this.userNotificationChannels.push(UserNotificationChannelDto.fromJS(item));
            }
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies.push(UserNotificationCompanyCheckedDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserNotificationSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotificationSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["notificationTypeId"] = this.notificationTypeId;
        data["enabled"] = this.enabled;
        data["daysInAdvance"] = this.daysInAdvance;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["notificationType"] = this.notificationType ? this.notificationType.toJSON() : <any>undefined;
        if (Array.isArray(this.userNotificationChannels)) {
            data["userNotificationChannels"] = [];
            for (let item of this.userNotificationChannels)
                data["userNotificationChannels"].push(item.toJSON());
        }
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserNotificationSettingDto {
        const json = this.toJSON();
        let result = new UserNotificationSettingDto();
        result.init(json);
        return result;
    }
}

export interface IUserNotificationSettingDto {
    id: number;
    userId: number;
    tenantId: number;
    notificationTypeId: number;
    enabled: boolean;
    daysInAdvance: number;
    user: UserDto;
    tenant: TenantDto;
    notificationType: NotificationTypeDto;
    userNotificationChannels: UserNotificationChannelDto[] | undefined;
    companies: UserNotificationCompanyCheckedDto[] | undefined;
}

export class UserNotificationSettingDtoPagedResultDto implements IUserNotificationSettingDtoPagedResultDto {
    items: UserNotificationSettingDto[] | undefined;
    totalCount: number;

    constructor(data?: IUserNotificationSettingDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserNotificationSettingDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserNotificationSettingDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotificationSettingDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserNotificationSettingDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserNotificationSettingDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserNotificationSettingDtoPagedResultDto {
    items: UserNotificationSettingDto[] | undefined;
    totalCount: number;
}

export enum UserNotificationState {
    _0 = 0,
    _1 = 1,
}

export class UserPermissionSetting implements IUserPermissionSetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    userId: number;

    constructor(data?: IUserPermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isGranted = _data["isGranted"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UserPermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["userId"] = this.userId;
        return data;
    }

    clone(): UserPermissionSetting {
        const json = this.toJSON();
        let result = new UserPermissionSetting();
        result.init(json);
        return result;
    }
}

export interface IUserPermissionSetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    userId: number;
}

export class UserRole implements IUserRole {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    roleId: number;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        return data;
    }

    clone(): UserRole {
        const json = this.toJSON();
        let result = new UserRole();
        result.init(json);
        return result;
    }
}

export interface IUserRole {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    roleId: number;
}

export class UserSuggestedCompanyChangesControl implements IUserSuggestedCompanyChangesControl {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    userId: number;
    companyId: number;
    company: Company;
    suggestedChangesJson: string | undefined;
    status: RequestStatusEnum;

    constructor(data?: IUserSuggestedCompanyChangesControl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.suggestedChangesJson = _data["suggestedChangesJson"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UserSuggestedCompanyChangesControl {
        data = typeof data === 'object' ? data : {};
        let result = new UserSuggestedCompanyChangesControl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["suggestedChangesJson"] = this.suggestedChangesJson;
        data["status"] = this.status;
        return data;
    }

    clone(): UserSuggestedCompanyChangesControl {
        const json = this.toJSON();
        let result = new UserSuggestedCompanyChangesControl();
        result.init(json);
        return result;
    }
}

export interface IUserSuggestedCompanyChangesControl {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    userId: number;
    companyId: number;
    company: Company;
    suggestedChangesJson: string | undefined;
    status: RequestStatusEnum;
}

export class UserSuggestedCompanyChangesOutputDto implements IUserSuggestedCompanyChangesOutputDto {
    createOrUpdateCompany: CreateOrUpdateCompanyDto;
    directors: PersonCompanyRoleDataDto[] | undefined;
    shareholders: PersonCompanyRoleDataDto[] | undefined;
    contacts: PersonCompanyRoleDataDto[] | undefined;
    linked: PersonCompanyRoleDataDto[] | undefined;
    attorneysInFact: PersonCompanyRoleDataDto[] | undefined;
    finalBeneficiaries: PersonCompanyRoleDataDto[] | undefined;

    constructor(data?: IUserSuggestedCompanyChangesOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createOrUpdateCompany = _data["createOrUpdateCompany"] ? CreateOrUpdateCompanyDto.fromJS(_data["createOrUpdateCompany"]) : <any>undefined;
            if (Array.isArray(_data["directors"])) {
                this.directors = [] as any;
                for (let item of _data["directors"])
                    this.directors.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            if (Array.isArray(_data["shareholders"])) {
                this.shareholders = [] as any;
                for (let item of _data["shareholders"])
                    this.shareholders.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            if (Array.isArray(_data["linked"])) {
                this.linked = [] as any;
                for (let item of _data["linked"])
                    this.linked.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            if (Array.isArray(_data["attorneysInFact"])) {
                this.attorneysInFact = [] as any;
                for (let item of _data["attorneysInFact"])
                    this.attorneysInFact.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            if (Array.isArray(_data["finalBeneficiaries"])) {
                this.finalBeneficiaries = [] as any;
                for (let item of _data["finalBeneficiaries"])
                    this.finalBeneficiaries.push(PersonCompanyRoleDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserSuggestedCompanyChangesOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSuggestedCompanyChangesOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createOrUpdateCompany"] = this.createOrUpdateCompany ? this.createOrUpdateCompany.toJSON() : <any>undefined;
        if (Array.isArray(this.directors)) {
            data["directors"] = [];
            for (let item of this.directors)
                data["directors"].push(item.toJSON());
        }
        if (Array.isArray(this.shareholders)) {
            data["shareholders"] = [];
            for (let item of this.shareholders)
                data["shareholders"].push(item.toJSON());
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.linked)) {
            data["linked"] = [];
            for (let item of this.linked)
                data["linked"].push(item.toJSON());
        }
        if (Array.isArray(this.attorneysInFact)) {
            data["attorneysInFact"] = [];
            for (let item of this.attorneysInFact)
                data["attorneysInFact"].push(item.toJSON());
        }
        if (Array.isArray(this.finalBeneficiaries)) {
            data["finalBeneficiaries"] = [];
            for (let item of this.finalBeneficiaries)
                data["finalBeneficiaries"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserSuggestedCompanyChangesOutputDto {
        const json = this.toJSON();
        let result = new UserSuggestedCompanyChangesOutputDto();
        result.init(json);
        return result;
    }
}

export interface IUserSuggestedCompanyChangesOutputDto {
    createOrUpdateCompany: CreateOrUpdateCompanyDto;
    directors: PersonCompanyRoleDataDto[] | undefined;
    shareholders: PersonCompanyRoleDataDto[] | undefined;
    contacts: PersonCompanyRoleDataDto[] | undefined;
    linked: PersonCompanyRoleDataDto[] | undefined;
    attorneysInFact: PersonCompanyRoleDataDto[] | undefined;
    finalBeneficiaries: PersonCompanyRoleDataDto[] | undefined;
}

export class UserSuggestedJuridicalPersonChangesControl implements IUserSuggestedJuridicalPersonChangesControl {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    userId: number;
    juridicalPersonId: number;
    company: Company;
    suggestedChangesJson: string | undefined;
    status: RequestStatusEnum;

    constructor(data?: IUserSuggestedJuridicalPersonChangesControl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.juridicalPersonId = _data["juridicalPersonId"];
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.suggestedChangesJson = _data["suggestedChangesJson"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UserSuggestedJuridicalPersonChangesControl {
        data = typeof data === 'object' ? data : {};
        let result = new UserSuggestedJuridicalPersonChangesControl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["juridicalPersonId"] = this.juridicalPersonId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["suggestedChangesJson"] = this.suggestedChangesJson;
        data["status"] = this.status;
        return data;
    }

    clone(): UserSuggestedJuridicalPersonChangesControl {
        const json = this.toJSON();
        let result = new UserSuggestedJuridicalPersonChangesControl();
        result.init(json);
        return result;
    }
}

export interface IUserSuggestedJuridicalPersonChangesControl {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    userId: number;
    juridicalPersonId: number;
    company: Company;
    suggestedChangesJson: string | undefined;
    status: RequestStatusEnum;
}

export class UserSuggestedJuridicalPersonChangesOutputDto implements IUserSuggestedJuridicalPersonChangesOutputDto {
    createOrUpdateJuridicalPerson: CreateOrUpdateJuridicalPersonDto;
    directors: PersonCompanyRoleDataDto[] | undefined;
    shareholders: PersonCompanyRoleDataDto[] | undefined;
    contacts: PersonCompanyRoleDataDto[] | undefined;
    linked: PersonCompanyRoleDataDto[] | undefined;
    attorneysInFact: PersonCompanyRoleDataDto[] | undefined;
    finalBeneficiaries: PersonCompanyRoleDataDto[] | undefined;

    constructor(data?: IUserSuggestedJuridicalPersonChangesOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createOrUpdateJuridicalPerson = _data["createOrUpdateJuridicalPerson"] ? CreateOrUpdateJuridicalPersonDto.fromJS(_data["createOrUpdateJuridicalPerson"]) : <any>undefined;
            if (Array.isArray(_data["directors"])) {
                this.directors = [] as any;
                for (let item of _data["directors"])
                    this.directors.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            if (Array.isArray(_data["shareholders"])) {
                this.shareholders = [] as any;
                for (let item of _data["shareholders"])
                    this.shareholders.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            if (Array.isArray(_data["linked"])) {
                this.linked = [] as any;
                for (let item of _data["linked"])
                    this.linked.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            if (Array.isArray(_data["attorneysInFact"])) {
                this.attorneysInFact = [] as any;
                for (let item of _data["attorneysInFact"])
                    this.attorneysInFact.push(PersonCompanyRoleDataDto.fromJS(item));
            }
            if (Array.isArray(_data["finalBeneficiaries"])) {
                this.finalBeneficiaries = [] as any;
                for (let item of _data["finalBeneficiaries"])
                    this.finalBeneficiaries.push(PersonCompanyRoleDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserSuggestedJuridicalPersonChangesOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSuggestedJuridicalPersonChangesOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createOrUpdateJuridicalPerson"] = this.createOrUpdateJuridicalPerson ? this.createOrUpdateJuridicalPerson.toJSON() : <any>undefined;
        if (Array.isArray(this.directors)) {
            data["directors"] = [];
            for (let item of this.directors)
                data["directors"].push(item.toJSON());
        }
        if (Array.isArray(this.shareholders)) {
            data["shareholders"] = [];
            for (let item of this.shareholders)
                data["shareholders"].push(item.toJSON());
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.linked)) {
            data["linked"] = [];
            for (let item of this.linked)
                data["linked"].push(item.toJSON());
        }
        if (Array.isArray(this.attorneysInFact)) {
            data["attorneysInFact"] = [];
            for (let item of this.attorneysInFact)
                data["attorneysInFact"].push(item.toJSON());
        }
        if (Array.isArray(this.finalBeneficiaries)) {
            data["finalBeneficiaries"] = [];
            for (let item of this.finalBeneficiaries)
                data["finalBeneficiaries"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserSuggestedJuridicalPersonChangesOutputDto {
        const json = this.toJSON();
        let result = new UserSuggestedJuridicalPersonChangesOutputDto();
        result.init(json);
        return result;
    }
}

export interface IUserSuggestedJuridicalPersonChangesOutputDto {
    createOrUpdateJuridicalPerson: CreateOrUpdateJuridicalPersonDto;
    directors: PersonCompanyRoleDataDto[] | undefined;
    shareholders: PersonCompanyRoleDataDto[] | undefined;
    contacts: PersonCompanyRoleDataDto[] | undefined;
    linked: PersonCompanyRoleDataDto[] | undefined;
    attorneysInFact: PersonCompanyRoleDataDto[] | undefined;
    finalBeneficiaries: PersonCompanyRoleDataDto[] | undefined;
}

export class UserSuggestedNaturalPersonChangesControl implements IUserSuggestedNaturalPersonChangesControl {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    userId: number;
    personId: number;
    naturalPerson: NaturalPerson;
    suggestedChangesJson: string | undefined;
    status: RequestStatusEnum;

    constructor(data?: IUserSuggestedNaturalPersonChangesControl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.personId = _data["personId"];
            this.naturalPerson = _data["naturalPerson"] ? NaturalPerson.fromJS(_data["naturalPerson"]) : <any>undefined;
            this.suggestedChangesJson = _data["suggestedChangesJson"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UserSuggestedNaturalPersonChangesControl {
        data = typeof data === 'object' ? data : {};
        let result = new UserSuggestedNaturalPersonChangesControl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["personId"] = this.personId;
        data["naturalPerson"] = this.naturalPerson ? this.naturalPerson.toJSON() : <any>undefined;
        data["suggestedChangesJson"] = this.suggestedChangesJson;
        data["status"] = this.status;
        return data;
    }

    clone(): UserSuggestedNaturalPersonChangesControl {
        const json = this.toJSON();
        let result = new UserSuggestedNaturalPersonChangesControl();
        result.init(json);
        return result;
    }
}

export interface IUserSuggestedNaturalPersonChangesControl {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    userId: number;
    personId: number;
    naturalPerson: NaturalPerson;
    suggestedChangesJson: string | undefined;
    status: RequestStatusEnum;
}

export class UserSuggestedNaturalPersonChangesOutputDto implements IUserSuggestedNaturalPersonChangesOutputDto {
    createOrUpdateNaturalPerson: CreateOrUpdateNaturalPersonDto;

    constructor(data?: IUserSuggestedNaturalPersonChangesOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createOrUpdateNaturalPerson = _data["createOrUpdateNaturalPerson"] ? CreateOrUpdateNaturalPersonDto.fromJS(_data["createOrUpdateNaturalPerson"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserSuggestedNaturalPersonChangesOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSuggestedNaturalPersonChangesOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createOrUpdateNaturalPerson"] = this.createOrUpdateNaturalPerson ? this.createOrUpdateNaturalPerson.toJSON() : <any>undefined;
        return data;
    }

    clone(): UserSuggestedNaturalPersonChangesOutputDto {
        const json = this.toJSON();
        let result = new UserSuggestedNaturalPersonChangesOutputDto();
        result.init(json);
        return result;
    }
}

export interface IUserSuggestedNaturalPersonChangesOutputDto {
    createOrUpdateNaturalPerson: CreateOrUpdateNaturalPersonDto;
}

export class UserToken implements IUserToken {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): UserToken {
        const json = this.toJSON();
        let result = new UserToken();
        result.init(json);
        return result;
    }
}

export interface IUserToken {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
}

export class ValueFieldDto implements IValueFieldDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    assetId: number | undefined;
    asset: AssetDto;
    valueText: string | undefined;
    valueNumber: number | undefined;
    valueDate: moment.Moment | undefined;
    valueBoolean: boolean | undefined;
    valueOptionId: number | undefined;
    customFieldId: number | undefined;
    customField: CustomFieldDto;

    constructor(data?: IValueFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.assetId = _data["assetId"];
            this.asset = _data["asset"] ? AssetDto.fromJS(_data["asset"]) : <any>undefined;
            this.valueText = _data["valueText"];
            this.valueNumber = _data["valueNumber"];
            this.valueDate = _data["valueDate"] ? moment(_data["valueDate"].toString()) : <any>undefined;
            this.valueBoolean = _data["valueBoolean"];
            this.valueOptionId = _data["valueOptionId"];
            this.customFieldId = _data["customFieldId"];
            this.customField = _data["customField"] ? CustomFieldDto.fromJS(_data["customField"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ValueFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValueFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["assetId"] = this.assetId;
        data["asset"] = this.asset ? this.asset.toJSON() : <any>undefined;
        data["valueText"] = this.valueText;
        data["valueNumber"] = this.valueNumber;
        data["valueDate"] = this.valueDate ? this.valueDate.toISOString() : <any>undefined;
        data["valueBoolean"] = this.valueBoolean;
        data["valueOptionId"] = this.valueOptionId;
        data["customFieldId"] = this.customFieldId;
        data["customField"] = this.customField ? this.customField.toJSON() : <any>undefined;
        return data;
    }

    clone(): ValueFieldDto {
        const json = this.toJSON();
        let result = new ValueFieldDto();
        result.init(json);
        return result;
    }
}

export interface IValueFieldDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    assetId: number | undefined;
    asset: AssetDto;
    valueText: string | undefined;
    valueNumber: number | undefined;
    valueDate: moment.Moment | undefined;
    valueBoolean: boolean | undefined;
    valueOptionId: number | undefined;
    customFieldId: number | undefined;
    customField: CustomFieldDto;
}

export class ValueFieldDtoPagedResultDto implements IValueFieldDtoPagedResultDto {
    items: ValueFieldDto[] | undefined;
    totalCount: number;

    constructor(data?: IValueFieldDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ValueFieldDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ValueFieldDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValueFieldDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ValueFieldDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ValueFieldDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IValueFieldDtoPagedResultDto {
    items: ValueFieldDto[] | undefined;
    totalCount: number;
}

export class WorkActivity implements IWorkActivity {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
    code: string | undefined;
    parentId: number | undefined;
    parent: WorkActivity;

    constructor(data?: IWorkActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
            this.code = _data["code"];
            this.parentId = _data["parentId"];
            this.parent = _data["parent"] ? WorkActivity.fromJS(_data["parent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkActivity {
        data = typeof data === 'object' ? data : {};
        let result = new WorkActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        data["code"] = this.code;
        data["parentId"] = this.parentId;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        return data;
    }

    clone(): WorkActivity {
        const json = this.toJSON();
        let result = new WorkActivity();
        result.init(json);
        return result;
    }
}

export interface IWorkActivity {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string | undefined;
    code: string | undefined;
    parentId: number | undefined;
    parent: WorkActivity;
}

export class WorkActivityDto implements IWorkActivityDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
    code: string;
    parentId: number | undefined;
    parent: WorkActivityDto;

    constructor(data?: IWorkActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.localizationKeyName = _data["localizationKeyName"];
            this.code = _data["code"];
            this.parentId = _data["parentId"];
            this.parent = _data["parent"] ? WorkActivityDto.fromJS(_data["parent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["localizationKeyName"] = this.localizationKeyName;
        data["code"] = this.code;
        data["parentId"] = this.parentId;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        return data;
    }

    clone(): WorkActivityDto {
        const json = this.toJSON();
        let result = new WorkActivityDto();
        result.init(json);
        return result;
    }
}

export interface IWorkActivityDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    localizationKeyName: string;
    code: string;
    parentId: number | undefined;
    parent: WorkActivityDto;
}

export class WorkActivityDtoPagedResultDto implements IWorkActivityDtoPagedResultDto {
    items: WorkActivityDto[] | undefined;
    totalCount: number;

    constructor(data?: IWorkActivityDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WorkActivityDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): WorkActivityDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkActivityDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): WorkActivityDtoPagedResultDto {
        const json = this.toJSON();
        let result = new WorkActivityDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IWorkActivityDtoPagedResultDto {
    items: WorkActivityDto[] | undefined;
    totalCount: number;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}